/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LoginImport } from './routes/login'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as AuthNoPermissionImport } from './routes/_auth/no-permission'
import { Route as AuthHomeImport } from './routes/_auth/home'
import { Route as AuthChangePasswordImport } from './routes/_auth/change-password'
import { Route as AuthUserMessagesIndexImport } from './routes/_auth/user-messages/index'
import { Route as AuthTestrunIndexImport } from './routes/_auth/testrun/index'
import { Route as AuthWarehouseInv9210IndexImport } from './routes/_auth/warehouse/inv9210/index'
import { Route as AuthWarehouseInv9120IndexImport } from './routes/_auth/warehouse/inv9120/index'
import { Route as AuthWarehouseInv9110IndexImport } from './routes/_auth/warehouse/inv9110/index'
import { Route as AuthWarehouseInv9020IndexImport } from './routes/_auth/warehouse/inv9020/index'
import { Route as AuthWarehouseInv9010IndexImport } from './routes/_auth/warehouse/inv9010/index'
import { Route as AuthWarehouseInv5010IndexImport } from './routes/_auth/warehouse/inv5010/index'
import { Route as AuthWarehouseInv4310IndexImport } from './routes/_auth/warehouse/inv4310/index'
import { Route as AuthWarehouseInv4210IndexImport } from './routes/_auth/warehouse/inv4210/index'
import { Route as AuthWarehouseInv4110IndexImport } from './routes/_auth/warehouse/inv4110/index'
import { Route as AuthWarehouseInv4020IndexImport } from './routes/_auth/warehouse/inv4020/index'
import { Route as AuthWarehouseInv4015IndexImport } from './routes/_auth/warehouse/inv4015/index'
import { Route as AuthWarehouseInv4010IndexImport } from './routes/_auth/warehouse/inv4010/index'
import { Route as AuthWarehouseInv3510IndexImport } from './routes/_auth/warehouse/inv3510/index'
import { Route as AuthWarehouseInv3020IndexImport } from './routes/_auth/warehouse/inv3020/index'
import { Route as AuthWarehouseInv3010IndexImport } from './routes/_auth/warehouse/inv3010/index'
import { Route as AuthWarehouseInv2310IndexImport } from './routes/_auth/warehouse/inv2310/index'
import { Route as AuthWarehouseInv2215IndexImport } from './routes/_auth/warehouse/inv2215/index'
import { Route as AuthWarehouseInv2210IndexImport } from './routes/_auth/warehouse/inv2210/index'
import { Route as AuthWarehouseInv2010IndexImport } from './routes/_auth/warehouse/inv2010/index'
import { Route as AuthWarehouseInv1310IndexImport } from './routes/_auth/warehouse/inv1310/index'
import { Route as AuthWarehouseInv1210IndexImport } from './routes/_auth/warehouse/inv1210/index'
import { Route as AuthWarehouseInv1140IndexImport } from './routes/_auth/warehouse/inv1140/index'
import { Route as AuthWarehouseInv1120IndexImport } from './routes/_auth/warehouse/inv1120/index'
import { Route as AuthWarehouseInv1110IndexImport } from './routes/_auth/warehouse/inv1110/index'
import { Route as AuthWarehouseInv1015IndexImport } from './routes/_auth/warehouse/inv1015/index'
import { Route as AuthWarehouseInv1010IndexImport } from './routes/_auth/warehouse/inv1010/index'
import { Route as AuthWarehouseDashboardIndexImport } from './routes/_auth/warehouse/dashboard/index'
import { Route as AuthSettingsUsersIndexImport } from './routes/_auth/settings/users/index'
import { Route as AuthSettingsSuppliersIndexImport } from './routes/_auth/settings/suppliers/index'
import { Route as AuthSettingsScreenCaptureIndexImport } from './routes/_auth/settings/screen-capture/index'
import { Route as AuthSettingsRunningNumbersIndexImport } from './routes/_auth/settings/running-numbers/index'
import { Route as AuthSettingsRolesIndexImport } from './routes/_auth/settings/roles/index'
import { Route as AuthSettingsPartiesIndexImport } from './routes/_auth/settings/parties/index'
import { Route as AuthSettingsMoldsIndexImport } from './routes/_auth/settings/molds/index'
import { Route as AuthSettingsMachinesIndexImport } from './routes/_auth/settings/machines/index'
import { Route as AuthSettingsLocationsIndexImport } from './routes/_auth/settings/locations/index'
import { Route as AuthSettingsItemsIndexImport } from './routes/_auth/settings/items/index'
import { Route as AuthSettingsHolidaysIndexImport } from './routes/_auth/settings/holidays/index'
import { Route as AuthSettingsGroupsIndexImport } from './routes/_auth/settings/groups/index'
import { Route as AuthSettingsCustomersIndexImport } from './routes/_auth/settings/customers/index'
import { Route as AuthSaleSale2310IndexImport } from './routes/_auth/sale/sale2310/index'
import { Route as AuthSaleSale1230IndexImport } from './routes/_auth/sale/sale1230/index'
import { Route as AuthSaleSale1220IndexImport } from './routes/_auth/sale/sale1220/index'
import { Route as AuthSaleSale1210IndexImport } from './routes/_auth/sale/sale1210/index'
import { Route as AuthSaleSale1030IndexImport } from './routes/_auth/sale/sale1030/index'
import { Route as AuthSaleSale1020IndexImport } from './routes/_auth/sale/sale1020/index'
import { Route as AuthSaleSale1010IndexImport } from './routes/_auth/sale/sale1010/index'
import { Route as AuthQcQc9010IndexImport } from './routes/_auth/qc/qc9010/index'
import { Route as AuthQcQc8110IndexImport } from './routes/_auth/qc/qc8110/index'
import { Route as AuthQcQc8030IndexImport } from './routes/_auth/qc/qc8030/index'
import { Route as AuthQcQc8015IndexImport } from './routes/_auth/qc/qc8015/index'
import { Route as AuthQcQc8010IndexImport } from './routes/_auth/qc/qc8010/index'
import { Route as AuthQcQc1010IndexImport } from './routes/_auth/qc/qc1010/index'
import { Route as AuthPurchaseTrackingIndexImport } from './routes/_auth/purchase/tracking/index'
import { Route as AuthPurchaseProblemIndexImport } from './routes/_auth/purchase/problem/index'
import { Route as AuthPurchasePo9030IndexImport } from './routes/_auth/purchase/po9030/index'
import { Route as AuthPurchasePo9020IndexImport } from './routes/_auth/purchase/po9020/index'
import { Route as AuthPurchasePo9010IndexImport } from './routes/_auth/purchase/po9010/index'
import { Route as AuthPurchasePo1010IndexImport } from './routes/_auth/purchase/po1010/index'
import { Route as AuthPurchaseBplusSyncIndexImport } from './routes/_auth/purchase/bplus-sync/index'
import { Route as AuthProductionWo9010IndexImport } from './routes/_auth/production/wo9010/index'
import { Route as AuthProductionWo3010IndexImport } from './routes/_auth/production/wo3010/index'
import { Route as AuthProductionWo1210IndexImport } from './routes/_auth/production/wo1210/index'
import { Route as AuthProductionWo1115IndexImport } from './routes/_auth/production/wo1115/index'
import { Route as AuthProductionWo1110IndexImport } from './routes/_auth/production/wo1110/index'
import { Route as AuthProductionWo1010IndexImport } from './routes/_auth/production/wo1010/index'
import { Route as AuthProductionPrd4030IndexImport } from './routes/_auth/production/prd4030/index'
import { Route as AuthProductionPrd4020IndexImport } from './routes/_auth/production/prd4020/index'
import { Route as AuthProductionPrd4010IndexImport } from './routes/_auth/production/prd4010/index'
import { Route as AuthProductionPrd3110IndexImport } from './routes/_auth/production/prd3110/index'
import { Route as AuthProductionPrd3010IndexImport } from './routes/_auth/production/prd3010/index'
import { Route as AuthProductionPrd2010IndexImport } from './routes/_auth/production/prd2010/index'
import { Route as AuthProductionPrd1210IndexImport } from './routes/_auth/production/prd1210/index'
import { Route as AuthProductionPrd1110IndexImport } from './routes/_auth/production/prd1110/index'
import { Route as AuthProductionPrd1015IndexImport } from './routes/_auth/production/prd1015/index'
import { Route as AuthProductionPrd1011IndexImport } from './routes/_auth/production/prd1011/index'
import { Route as AuthProductionPrd1010IndexImport } from './routes/_auth/production/prd1010/index'
import { Route as AuthAccountingJournalEntryIndexImport } from './routes/_auth/accounting/journal-entry/index'
import { Route as AuthAccountingFiscalYearIndexImport } from './routes/_auth/accounting/fiscal-year/index'
import { Route as AuthAccountingChartOfAccountsIndexImport } from './routes/_auth/accounting/chart-of-accounts/index'
import { Route as AuthWarehouseInv5010CreateImport } from './routes/_auth/warehouse/inv5010/create'
import { Route as AuthWarehouseInv5010IdImport } from './routes/_auth/warehouse/inv5010/$id'
import { Route as AuthWarehouseInv4310CreateImport } from './routes/_auth/warehouse/inv4310/create'
import { Route as AuthWarehouseInv4310IdImport } from './routes/_auth/warehouse/inv4310/$id'
import { Route as AuthWarehouseInv3510CreateImport } from './routes/_auth/warehouse/inv3510/create'
import { Route as AuthWarehouseInv3510IdImport } from './routes/_auth/warehouse/inv3510/$id'
import { Route as AuthWarehouseInv3020CreateImport } from './routes/_auth/warehouse/inv3020/create'
import { Route as AuthWarehouseInv3020IdImport } from './routes/_auth/warehouse/inv3020/$id'
import { Route as AuthWarehouseInv3010CreateImport } from './routes/_auth/warehouse/inv3010/create'
import { Route as AuthWarehouseInv3010IdImport } from './routes/_auth/warehouse/inv3010/$id'
import { Route as AuthWarehouseInv2310CreateImport } from './routes/_auth/warehouse/inv2310/create'
import { Route as AuthWarehouseInv2310IdImport } from './routes/_auth/warehouse/inv2310/$id'
import { Route as AuthWarehouseInv2215CreateImport } from './routes/_auth/warehouse/inv2215/create'
import { Route as AuthWarehouseInv2215IdImport } from './routes/_auth/warehouse/inv2215/$id'
import { Route as AuthWarehouseInv2210CreateImport } from './routes/_auth/warehouse/inv2210/create'
import { Route as AuthWarehouseInv2210IdImport } from './routes/_auth/warehouse/inv2210/$id'
import { Route as AuthWarehouseInv2010CreateImport } from './routes/_auth/warehouse/inv2010/create'
import { Route as AuthWarehouseInv2010IdImport } from './routes/_auth/warehouse/inv2010/$id'
import { Route as AuthWarehouseInv1310CreateImport } from './routes/_auth/warehouse/inv1310/create'
import { Route as AuthWarehouseInv1310IdImport } from './routes/_auth/warehouse/inv1310/$id'
import { Route as AuthWarehouseInv1210CreateImport } from './routes/_auth/warehouse/inv1210/create'
import { Route as AuthWarehouseInv1210IdImport } from './routes/_auth/warehouse/inv1210/$id'
import { Route as AuthWarehouseInv1140CreateImport } from './routes/_auth/warehouse/inv1140/create'
import { Route as AuthWarehouseInv1140IdImport } from './routes/_auth/warehouse/inv1140/$id'
import { Route as AuthWarehouseInv1120IdImport } from './routes/_auth/warehouse/inv1120/$id'
import { Route as AuthWarehouseInv1110IdImport } from './routes/_auth/warehouse/inv1110/$id'
import { Route as AuthWarehouseInv1015CreateImport } from './routes/_auth/warehouse/inv1015/create'
import { Route as AuthWarehouseInv1015IdImport } from './routes/_auth/warehouse/inv1015/$id'
import { Route as AuthWarehouseInv1010CreateImport } from './routes/_auth/warehouse/inv1010/create'
import { Route as AuthWarehouseInv1010IdImport } from './routes/_auth/warehouse/inv1010/$id'
import { Route as AuthSettingsUsersCreateImport } from './routes/_auth/settings/users/create'
import { Route as AuthSettingsUsersIdImport } from './routes/_auth/settings/users/$id'
import { Route as AuthSettingsSuppliersCreateImport } from './routes/_auth/settings/suppliers/create'
import { Route as AuthSettingsSuppliersIdImport } from './routes/_auth/settings/suppliers/$id'
import { Route as AuthSettingsRunningNumbersCreateByYearImport } from './routes/_auth/settings/running-numbers/create-by-year'
import { Route as AuthSettingsRunningNumbersCreateImport } from './routes/_auth/settings/running-numbers/create'
import { Route as AuthSettingsRunningNumbersIdImport } from './routes/_auth/settings/running-numbers/$id'
import { Route as AuthSettingsRolesCreateImport } from './routes/_auth/settings/roles/create'
import { Route as AuthSettingsRolesIdImport } from './routes/_auth/settings/roles/$id'
import { Route as AuthSettingsPartiesCreateImport } from './routes/_auth/settings/parties/create'
import { Route as AuthSettingsPartiesIdImport } from './routes/_auth/settings/parties/$id'
import { Route as AuthSettingsMoldsCreateImport } from './routes/_auth/settings/molds/create'
import { Route as AuthSettingsMoldsIdImport } from './routes/_auth/settings/molds/$id'
import { Route as AuthSettingsMachinesCreateImport } from './routes/_auth/settings/machines/create'
import { Route as AuthSettingsMachinesIdImport } from './routes/_auth/settings/machines/$id'
import { Route as AuthSettingsLocationsCreateImport } from './routes/_auth/settings/locations/create'
import { Route as AuthSettingsLocationsIdImport } from './routes/_auth/settings/locations/$id'
import { Route as AuthSettingsItemsCreateImport } from './routes/_auth/settings/items/create'
import { Route as AuthSettingsHolidaysCreateImport } from './routes/_auth/settings/holidays/create'
import { Route as AuthSettingsHolidaysIdImport } from './routes/_auth/settings/holidays/$id'
import { Route as AuthSettingsGroupsCreateImport } from './routes/_auth/settings/groups/create'
import { Route as AuthSettingsGroupsIdImport } from './routes/_auth/settings/groups/$id'
import { Route as AuthSettingsCustomersCreateImport } from './routes/_auth/settings/customers/create'
import { Route as AuthSettingsCustomersIdImport } from './routes/_auth/settings/customers/$id'
import { Route as AuthSaleSale2310CreateImport } from './routes/_auth/sale/sale2310/create'
import { Route as AuthSaleSale2310IdImport } from './routes/_auth/sale/sale2310/$id'
import { Route as AuthSaleSale1230IdImport } from './routes/_auth/sale/sale1230/$id'
import { Route as AuthSaleSale1220CreateImport } from './routes/_auth/sale/sale1220/create'
import { Route as AuthSaleSale1220IdImport } from './routes/_auth/sale/sale1220/$id'
import { Route as AuthSaleSale1010CreateImport } from './routes/_auth/sale/sale1010/create'
import { Route as AuthSaleSale1010IdImport } from './routes/_auth/sale/sale1010/$id'
import { Route as AuthQcQc8110CreateImport } from './routes/_auth/qc/qc8110/create'
import { Route as AuthQcQc8110IdImport } from './routes/_auth/qc/qc8110/$id'
import { Route as AuthQcQc8015IdImport } from './routes/_auth/qc/qc8015/$id'
import { Route as AuthQcQc8010CreateImport } from './routes/_auth/qc/qc8010/create'
import { Route as AuthQcQc8010IdImport } from './routes/_auth/qc/qc8010/$id'
import { Route as AuthPurchasePo1010CreateImport } from './routes/_auth/purchase/po1010/create'
import { Route as AuthPurchasePo1010IdImport } from './routes/_auth/purchase/po1010/$id'
import { Route as AuthProductionWo3010CreateImport } from './routes/_auth/production/wo3010/create'
import { Route as AuthProductionWo3010IdImport } from './routes/_auth/production/wo3010/$id'
import { Route as AuthProductionWo1110IdImport } from './routes/_auth/production/wo1110/$id'
import { Route as AuthProductionWo1010CreateImport } from './routes/_auth/production/wo1010/create'
import { Route as AuthProductionWo1010IdImport } from './routes/_auth/production/wo1010/$id'
import { Route as AuthProductionPrd4010IdImport } from './routes/_auth/production/prd4010/$id'
import { Route as AuthProductionPrd3110IdImport } from './routes/_auth/production/prd3110/$id'
import { Route as AuthProductionPrd3010IdImport } from './routes/_auth/production/prd3010/$id'
import { Route as AuthProductionPrd1210IdImport } from './routes/_auth/production/prd1210/$id'
import { Route as AuthAccountingReportsTrialBalanceImport } from './routes/_auth/accounting/reports/trial-balance'
import { Route as AuthAccountingReportsGeneralLedgerImport } from './routes/_auth/accounting/reports/general-ledger'
import { Route as AuthAccountingJournalEntryCreateImport } from './routes/_auth/accounting/journal-entry/create'
import { Route as AuthAccountingJournalEntryIdImport } from './routes/_auth/accounting/journal-entry/$id'
import { Route as AuthAccountingFiscalYearCreateImport } from './routes/_auth/accounting/fiscal-year/create'
import { Route as AuthAccountingFiscalYearIdImport } from './routes/_auth/accounting/fiscal-year/$id'
import { Route as AuthAccountingChartOfAccountsCreateImport } from './routes/_auth/accounting/chart-of-accounts/create'
import { Route as AuthSettingsItemsItemIdIndexImport } from './routes/_auth/settings/items/$itemId/index'
import { Route as AuthWarehouseInv4310AdjustIdImport } from './routes/_auth/warehouse/inv4310/adjust.$id'
import { Route as AuthWarehouseInv4310IdOverrideItemsImport } from './routes/_auth/warehouse/inv4310/$id_.override-items'
import { Route as AuthWarehouseInv3510EditIdImport } from './routes/_auth/warehouse/inv3510/edit.$id'
import { Route as AuthWarehouseInv3510IdZonesImport } from './routes/_auth/warehouse/inv3510/$id_.zones'
import { Route as AuthWarehouseInv3510IdVariancesImport } from './routes/_auth/warehouse/inv3510/$id_.variances'
import { Route as AuthWarehouseInv3510IdProgressImport } from './routes/_auth/warehouse/inv3510/$id_.progress'
import { Route as AuthWarehouseInv3510IdCompletionImport } from './routes/_auth/warehouse/inv3510/$id_.completion'
import { Route as AuthWarehouseInv3020EditIdImport } from './routes/_auth/warehouse/inv3020/edit.$id'
import { Route as AuthWarehouseInv3010EditIdImport } from './routes/_auth/warehouse/inv3010/edit.$id'
import { Route as AuthWarehouseInv2310EditIdImport } from './routes/_auth/warehouse/inv2310/edit.$id'
import { Route as AuthWarehouseInv2215EditIdImport } from './routes/_auth/warehouse/inv2215/edit.$id'
import { Route as AuthWarehouseInv2210EditIdImport } from './routes/_auth/warehouse/inv2210/edit.$id'
import { Route as AuthWarehouseInv2010EditIdImport } from './routes/_auth/warehouse/inv2010/edit.$id'
import { Route as AuthWarehouseInv1310EditIdImport } from './routes/_auth/warehouse/inv1310/edit.$id'
import { Route as AuthWarehouseInv1210EditIdImport } from './routes/_auth/warehouse/inv1210/edit.$id'
import { Route as AuthWarehouseInv1140EditIdImport } from './routes/_auth/warehouse/inv1140/edit.$id'
import { Route as AuthWarehouseInv1015EditIdImport } from './routes/_auth/warehouse/inv1015/edit.$id'
import { Route as AuthWarehouseInv1010EditIdImport } from './routes/_auth/warehouse/inv1010/edit.$id'
import { Route as AuthSettingsUsersEditIdImport } from './routes/_auth/settings/users/edit.$id'
import { Route as AuthSettingsSuppliersEditIdImport } from './routes/_auth/settings/suppliers/edit.$id'
import { Route as AuthSettingsRunningNumbersEditIdImport } from './routes/_auth/settings/running-numbers/edit.$id'
import { Route as AuthSettingsRolesEditIdImport } from './routes/_auth/settings/roles/edit.$id'
import { Route as AuthSettingsPartiesEditIdImport } from './routes/_auth/settings/parties/edit.$id'
import { Route as AuthSettingsMoldsEditIdImport } from './routes/_auth/settings/molds/edit.$id'
import { Route as AuthSettingsMoldsDeleteIdImport } from './routes/_auth/settings/molds/delete.$id'
import { Route as AuthSettingsMachinesEditIdImport } from './routes/_auth/settings/machines/edit.$id'
import { Route as AuthSettingsLocationsEditIdImport } from './routes/_auth/settings/locations/edit.$id'
import { Route as AuthSettingsItemsViewIdImport } from './routes/_auth/settings/items/view.$id'
import { Route as AuthSettingsItemsEditIdImport } from './routes/_auth/settings/items/edit.$id'
import { Route as AuthSettingsHolidaysEditIdImport } from './routes/_auth/settings/holidays/edit.$id'
import { Route as AuthSettingsGroupsEditIdImport } from './routes/_auth/settings/groups/edit.$id'
import { Route as AuthSettingsCustomersEditIdImport } from './routes/_auth/settings/customers/edit.$id'
import { Route as AuthSaleSale2310EditIdImport } from './routes/_auth/sale/sale2310/edit.$id'
import { Route as AuthSaleSale1220EditIdImport } from './routes/_auth/sale/sale1220/edit.$id'
import { Route as AuthSaleSale1010EditIdImport } from './routes/_auth/sale/sale1010/edit.$id'
import { Route as AuthQcQc8110EditIdImport } from './routes/_auth/qc/qc8110/edit.$id'
import { Route as AuthQcQc8010ViewIdImport } from './routes/_auth/qc/qc8010/view.$id'
import { Route as AuthPurchasePo1010EditIdImport } from './routes/_auth/purchase/po1010/edit.$id'
import { Route as AuthProductionWo3010EditIdImport } from './routes/_auth/production/wo3010/edit.$id'
import { Route as AuthProductionWo1110EditIdImport } from './routes/_auth/production/wo1110/edit.$id'
import { Route as AuthProductionWo1010EditIdImport } from './routes/_auth/production/wo1010/edit.$id'
import { Route as AuthProductionPrd3110EditIdImport } from './routes/_auth/production/prd3110/edit.$id'
import { Route as AuthProductionPrd1110CreateWsidImport } from './routes/_auth/production/prd1110/create.$wsid'
import { Route as AuthProductionPrd1010CreateWsidImport } from './routes/_auth/production/prd1010/create.$wsid'
import { Route as AuthAccountingJournalEntryEditIdImport } from './routes/_auth/accounting/journal-entry/edit.$id'
import { Route as AuthAccountingChartOfAccountsEditIdImport } from './routes/_auth/accounting/chart-of-accounts/edit.$id'
import { Route as AuthSettingsUsersIndexDeleteIdImport } from './routes/_auth/settings/users/index.delete.$id'
import { Route as AuthSettingsSuppliersIndexDeleteIdImport } from './routes/_auth/settings/suppliers/index.delete.$id'
import { Route as AuthSettingsRunningNumbersIndexDeleteIdImport } from './routes/_auth/settings/running-numbers/index.delete.$id'
import { Route as AuthSettingsPartiesIndexDeleteIdImport } from './routes/_auth/settings/parties/index.delete.$id'
import { Route as AuthSettingsLocationsIndexDeleteIdImport } from './routes/_auth/settings/locations/index.delete.$id'
import { Route as AuthSettingsCustomersIndexDeleteIdImport } from './routes/_auth/settings/customers/index.delete.$id'
import { Route as AuthQcQc8030IndexResultIdImport } from './routes/_auth/qc/qc8030/index.result.$id'
import { Route as AuthQcQc1010IndexHoldIdImport } from './routes/_auth/qc/qc1010/index.hold.$id'
import { Route as AuthProductionWo1210IndexHoldIdImport } from './routes/_auth/production/wo1210/index.hold.$id'
import { Route as AuthSettingsRolesEditIdDeleteImport } from './routes/_auth/settings/roles/edit.$id.delete'
import { Route as AuthSettingsMachinesEditIdDeleteImport } from './routes/_auth/settings/machines/edit.$id.delete'
import { Route as AuthSettingsItemsItemIdBomsCreateImport } from './routes/_auth/settings/items/$itemId/boms/create'
import { Route as AuthSettingsItemsItemIdBomsIdImport } from './routes/_auth/settings/items/$itemId/boms/$id'
import { Route as AuthSettingsHolidaysEditIdDeleteImport } from './routes/_auth/settings/holidays/edit.$id.delete'
import { Route as AuthPurchaseTrackingReceiveIdItemIdImport } from './routes/_auth/purchase/tracking/receive.$id.$itemId'
import { Route as AuthProductionPrd1110EditWsidIdImport } from './routes/_auth/production/prd1110/edit.$wsid.$id'
import { Route as AuthProductionPrd1010EditWsidIdImport } from './routes/_auth/production/prd1010/edit.$wsid.$id'
import { Route as AuthSettingsItemsItemIdBomsEditIdImport } from './routes/_auth/settings/items/$itemId/boms/edit.$id'

// Create/Update Routes

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthNoPermissionRoute = AuthNoPermissionImport.update({
  id: '/no-permission',
  path: '/no-permission',
  getParentRoute: () => AuthRoute,
} as any)

const AuthHomeRoute = AuthHomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthRoute,
} as any)

const AuthChangePasswordRoute = AuthChangePasswordImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AuthRoute,
} as any)

const AuthUserMessagesIndexRoute = AuthUserMessagesIndexImport.update({
  id: '/user-messages/',
  path: '/user-messages/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthTestrunIndexRoute = AuthTestrunIndexImport.update({
  id: '/testrun/',
  path: '/testrun/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv9210IndexRoute = AuthWarehouseInv9210IndexImport.update({
  id: '/warehouse/inv9210/',
  path: '/warehouse/inv9210/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv9120IndexRoute = AuthWarehouseInv9120IndexImport.update({
  id: '/warehouse/inv9120/',
  path: '/warehouse/inv9120/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv9110IndexRoute = AuthWarehouseInv9110IndexImport.update({
  id: '/warehouse/inv9110/',
  path: '/warehouse/inv9110/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv9020IndexRoute = AuthWarehouseInv9020IndexImport.update({
  id: '/warehouse/inv9020/',
  path: '/warehouse/inv9020/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv9010IndexRoute = AuthWarehouseInv9010IndexImport.update({
  id: '/warehouse/inv9010/',
  path: '/warehouse/inv9010/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv5010IndexRoute = AuthWarehouseInv5010IndexImport.update({
  id: '/warehouse/inv5010/',
  path: '/warehouse/inv5010/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv4310IndexRoute = AuthWarehouseInv4310IndexImport.update({
  id: '/warehouse/inv4310/',
  path: '/warehouse/inv4310/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv4210IndexRoute = AuthWarehouseInv4210IndexImport.update({
  id: '/warehouse/inv4210/',
  path: '/warehouse/inv4210/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv4110IndexRoute = AuthWarehouseInv4110IndexImport.update({
  id: '/warehouse/inv4110/',
  path: '/warehouse/inv4110/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv4020IndexRoute = AuthWarehouseInv4020IndexImport.update({
  id: '/warehouse/inv4020/',
  path: '/warehouse/inv4020/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv4015IndexRoute = AuthWarehouseInv4015IndexImport.update({
  id: '/warehouse/inv4015/',
  path: '/warehouse/inv4015/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv4010IndexRoute = AuthWarehouseInv4010IndexImport.update({
  id: '/warehouse/inv4010/',
  path: '/warehouse/inv4010/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv3510IndexRoute = AuthWarehouseInv3510IndexImport.update({
  id: '/warehouse/inv3510/',
  path: '/warehouse/inv3510/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv3020IndexRoute = AuthWarehouseInv3020IndexImport.update({
  id: '/warehouse/inv3020/',
  path: '/warehouse/inv3020/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv3010IndexRoute = AuthWarehouseInv3010IndexImport.update({
  id: '/warehouse/inv3010/',
  path: '/warehouse/inv3010/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv2310IndexRoute = AuthWarehouseInv2310IndexImport.update({
  id: '/warehouse/inv2310/',
  path: '/warehouse/inv2310/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv2215IndexRoute = AuthWarehouseInv2215IndexImport.update({
  id: '/warehouse/inv2215/',
  path: '/warehouse/inv2215/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv2210IndexRoute = AuthWarehouseInv2210IndexImport.update({
  id: '/warehouse/inv2210/',
  path: '/warehouse/inv2210/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv2010IndexRoute = AuthWarehouseInv2010IndexImport.update({
  id: '/warehouse/inv2010/',
  path: '/warehouse/inv2010/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv1310IndexRoute = AuthWarehouseInv1310IndexImport.update({
  id: '/warehouse/inv1310/',
  path: '/warehouse/inv1310/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv1210IndexRoute = AuthWarehouseInv1210IndexImport.update({
  id: '/warehouse/inv1210/',
  path: '/warehouse/inv1210/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv1140IndexRoute = AuthWarehouseInv1140IndexImport.update({
  id: '/warehouse/inv1140/',
  path: '/warehouse/inv1140/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv1120IndexRoute = AuthWarehouseInv1120IndexImport.update({
  id: '/warehouse/inv1120/',
  path: '/warehouse/inv1120/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv1110IndexRoute = AuthWarehouseInv1110IndexImport.update({
  id: '/warehouse/inv1110/',
  path: '/warehouse/inv1110/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv1015IndexRoute = AuthWarehouseInv1015IndexImport.update({
  id: '/warehouse/inv1015/',
  path: '/warehouse/inv1015/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv1010IndexRoute = AuthWarehouseInv1010IndexImport.update({
  id: '/warehouse/inv1010/',
  path: '/warehouse/inv1010/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseDashboardIndexRoute =
  AuthWarehouseDashboardIndexImport.update({
    id: '/warehouse/dashboard/',
    path: '/warehouse/dashboard/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsUsersIndexRoute = AuthSettingsUsersIndexImport.update({
  id: '/settings/users/',
  path: '/settings/users/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsSuppliersIndexRoute = AuthSettingsSuppliersIndexImport.update(
  {
    id: '/settings/suppliers/',
    path: '/settings/suppliers/',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthSettingsScreenCaptureIndexRoute =
  AuthSettingsScreenCaptureIndexImport.update({
    id: '/settings/screen-capture/',
    path: '/settings/screen-capture/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsRunningNumbersIndexRoute =
  AuthSettingsRunningNumbersIndexImport.update({
    id: '/settings/running-numbers/',
    path: '/settings/running-numbers/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsRolesIndexRoute = AuthSettingsRolesIndexImport.update({
  id: '/settings/roles/',
  path: '/settings/roles/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsPartiesIndexRoute = AuthSettingsPartiesIndexImport.update({
  id: '/settings/parties/',
  path: '/settings/parties/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsMoldsIndexRoute = AuthSettingsMoldsIndexImport.update({
  id: '/settings/molds/',
  path: '/settings/molds/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsMachinesIndexRoute = AuthSettingsMachinesIndexImport.update({
  id: '/settings/machines/',
  path: '/settings/machines/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsLocationsIndexRoute = AuthSettingsLocationsIndexImport.update(
  {
    id: '/settings/locations/',
    path: '/settings/locations/',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthSettingsItemsIndexRoute = AuthSettingsItemsIndexImport.update({
  id: '/settings/items/',
  path: '/settings/items/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsHolidaysIndexRoute = AuthSettingsHolidaysIndexImport.update({
  id: '/settings/holidays/',
  path: '/settings/holidays/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsGroupsIndexRoute = AuthSettingsGroupsIndexImport.update({
  id: '/settings/groups/',
  path: '/settings/groups/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsCustomersIndexRoute = AuthSettingsCustomersIndexImport.update(
  {
    id: '/settings/customers/',
    path: '/settings/customers/',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthSaleSale2310IndexRoute = AuthSaleSale2310IndexImport.update({
  id: '/sale/sale2310/',
  path: '/sale/sale2310/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSaleSale1230IndexRoute = AuthSaleSale1230IndexImport.update({
  id: '/sale/sale1230/',
  path: '/sale/sale1230/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSaleSale1220IndexRoute = AuthSaleSale1220IndexImport.update({
  id: '/sale/sale1220/',
  path: '/sale/sale1220/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSaleSale1210IndexRoute = AuthSaleSale1210IndexImport.update({
  id: '/sale/sale1210/',
  path: '/sale/sale1210/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSaleSale1030IndexRoute = AuthSaleSale1030IndexImport.update({
  id: '/sale/sale1030/',
  path: '/sale/sale1030/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSaleSale1020IndexRoute = AuthSaleSale1020IndexImport.update({
  id: '/sale/sale1020/',
  path: '/sale/sale1020/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSaleSale1010IndexRoute = AuthSaleSale1010IndexImport.update({
  id: '/sale/sale1010/',
  path: '/sale/sale1010/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthQcQc9010IndexRoute = AuthQcQc9010IndexImport.update({
  id: '/qc/qc9010/',
  path: '/qc/qc9010/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthQcQc8110IndexRoute = AuthQcQc8110IndexImport.update({
  id: '/qc/qc8110/',
  path: '/qc/qc8110/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthQcQc8030IndexRoute = AuthQcQc8030IndexImport.update({
  id: '/qc/qc8030/',
  path: '/qc/qc8030/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthQcQc8015IndexRoute = AuthQcQc8015IndexImport.update({
  id: '/qc/qc8015/',
  path: '/qc/qc8015/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthQcQc8010IndexRoute = AuthQcQc8010IndexImport.update({
  id: '/qc/qc8010/',
  path: '/qc/qc8010/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthQcQc1010IndexRoute = AuthQcQc1010IndexImport.update({
  id: '/qc/qc1010/',
  path: '/qc/qc1010/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPurchaseTrackingIndexRoute = AuthPurchaseTrackingIndexImport.update({
  id: '/purchase/tracking/',
  path: '/purchase/tracking/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPurchaseProblemIndexRoute = AuthPurchaseProblemIndexImport.update({
  id: '/purchase/problem/',
  path: '/purchase/problem/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPurchasePo9030IndexRoute = AuthPurchasePo9030IndexImport.update({
  id: '/purchase/po9030/',
  path: '/purchase/po9030/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPurchasePo9020IndexRoute = AuthPurchasePo9020IndexImport.update({
  id: '/purchase/po9020/',
  path: '/purchase/po9020/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPurchasePo9010IndexRoute = AuthPurchasePo9010IndexImport.update({
  id: '/purchase/po9010/',
  path: '/purchase/po9010/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPurchasePo1010IndexRoute = AuthPurchasePo1010IndexImport.update({
  id: '/purchase/po1010/',
  path: '/purchase/po1010/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPurchaseBplusSyncIndexRoute = AuthPurchaseBplusSyncIndexImport.update(
  {
    id: '/purchase/bplus-sync/',
    path: '/purchase/bplus-sync/',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthProductionWo9010IndexRoute = AuthProductionWo9010IndexImport.update({
  id: '/production/wo9010/',
  path: '/production/wo9010/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthProductionWo3010IndexRoute = AuthProductionWo3010IndexImport.update({
  id: '/production/wo3010/',
  path: '/production/wo3010/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthProductionWo1210IndexRoute = AuthProductionWo1210IndexImport.update({
  id: '/production/wo1210/',
  path: '/production/wo1210/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthProductionWo1115IndexRoute = AuthProductionWo1115IndexImport.update({
  id: '/production/wo1115/',
  path: '/production/wo1115/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthProductionWo1110IndexRoute = AuthProductionWo1110IndexImport.update({
  id: '/production/wo1110/',
  path: '/production/wo1110/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthProductionWo1010IndexRoute = AuthProductionWo1010IndexImport.update({
  id: '/production/wo1010/',
  path: '/production/wo1010/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthProductionPrd4030IndexRoute = AuthProductionPrd4030IndexImport.update(
  {
    id: '/production/prd4030/',
    path: '/production/prd4030/',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthProductionPrd4020IndexRoute = AuthProductionPrd4020IndexImport.update(
  {
    id: '/production/prd4020/',
    path: '/production/prd4020/',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthProductionPrd4010IndexRoute = AuthProductionPrd4010IndexImport.update(
  {
    id: '/production/prd4010/',
    path: '/production/prd4010/',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthProductionPrd3110IndexRoute = AuthProductionPrd3110IndexImport.update(
  {
    id: '/production/prd3110/',
    path: '/production/prd3110/',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthProductionPrd3010IndexRoute = AuthProductionPrd3010IndexImport.update(
  {
    id: '/production/prd3010/',
    path: '/production/prd3010/',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthProductionPrd2010IndexRoute = AuthProductionPrd2010IndexImport.update(
  {
    id: '/production/prd2010/',
    path: '/production/prd2010/',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthProductionPrd1210IndexRoute = AuthProductionPrd1210IndexImport.update(
  {
    id: '/production/prd1210/',
    path: '/production/prd1210/',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthProductionPrd1110IndexRoute = AuthProductionPrd1110IndexImport.update(
  {
    id: '/production/prd1110/',
    path: '/production/prd1110/',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthProductionPrd1015IndexRoute = AuthProductionPrd1015IndexImport.update(
  {
    id: '/production/prd1015/',
    path: '/production/prd1015/',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthProductionPrd1011IndexRoute = AuthProductionPrd1011IndexImport.update(
  {
    id: '/production/prd1011/',
    path: '/production/prd1011/',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthProductionPrd1010IndexRoute = AuthProductionPrd1010IndexImport.update(
  {
    id: '/production/prd1010/',
    path: '/production/prd1010/',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthAccountingJournalEntryIndexRoute =
  AuthAccountingJournalEntryIndexImport.update({
    id: '/accounting/journal-entry/',
    path: '/accounting/journal-entry/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthAccountingFiscalYearIndexRoute =
  AuthAccountingFiscalYearIndexImport.update({
    id: '/accounting/fiscal-year/',
    path: '/accounting/fiscal-year/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthAccountingChartOfAccountsIndexRoute =
  AuthAccountingChartOfAccountsIndexImport.update({
    id: '/accounting/chart-of-accounts/',
    path: '/accounting/chart-of-accounts/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWarehouseInv5010CreateRoute = AuthWarehouseInv5010CreateImport.update(
  {
    id: '/warehouse/inv5010/create',
    path: '/warehouse/inv5010/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv5010IdRoute = AuthWarehouseInv5010IdImport.update({
  id: '/warehouse/inv5010/$id',
  path: '/warehouse/inv5010/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv4310CreateRoute = AuthWarehouseInv4310CreateImport.update(
  {
    id: '/warehouse/inv4310/create',
    path: '/warehouse/inv4310/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv4310IdRoute = AuthWarehouseInv4310IdImport.update({
  id: '/warehouse/inv4310/$id',
  path: '/warehouse/inv4310/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv3510CreateRoute = AuthWarehouseInv3510CreateImport.update(
  {
    id: '/warehouse/inv3510/create',
    path: '/warehouse/inv3510/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv3510IdRoute = AuthWarehouseInv3510IdImport.update({
  id: '/warehouse/inv3510/$id',
  path: '/warehouse/inv3510/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv3020CreateRoute = AuthWarehouseInv3020CreateImport.update(
  {
    id: '/warehouse/inv3020/create',
    path: '/warehouse/inv3020/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv3020IdRoute = AuthWarehouseInv3020IdImport.update({
  id: '/warehouse/inv3020/$id',
  path: '/warehouse/inv3020/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv3010CreateRoute = AuthWarehouseInv3010CreateImport.update(
  {
    id: '/warehouse/inv3010/create',
    path: '/warehouse/inv3010/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv3010IdRoute = AuthWarehouseInv3010IdImport.update({
  id: '/warehouse/inv3010/$id',
  path: '/warehouse/inv3010/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv2310CreateRoute = AuthWarehouseInv2310CreateImport.update(
  {
    id: '/warehouse/inv2310/create',
    path: '/warehouse/inv2310/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv2310IdRoute = AuthWarehouseInv2310IdImport.update({
  id: '/warehouse/inv2310/$id',
  path: '/warehouse/inv2310/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv2215CreateRoute = AuthWarehouseInv2215CreateImport.update(
  {
    id: '/warehouse/inv2215/create',
    path: '/warehouse/inv2215/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv2215IdRoute = AuthWarehouseInv2215IdImport.update({
  id: '/warehouse/inv2215/$id',
  path: '/warehouse/inv2215/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv2210CreateRoute = AuthWarehouseInv2210CreateImport.update(
  {
    id: '/warehouse/inv2210/create',
    path: '/warehouse/inv2210/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv2210IdRoute = AuthWarehouseInv2210IdImport.update({
  id: '/warehouse/inv2210/$id',
  path: '/warehouse/inv2210/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv2010CreateRoute = AuthWarehouseInv2010CreateImport.update(
  {
    id: '/warehouse/inv2010/create',
    path: '/warehouse/inv2010/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv2010IdRoute = AuthWarehouseInv2010IdImport.update({
  id: '/warehouse/inv2010/$id',
  path: '/warehouse/inv2010/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv1310CreateRoute = AuthWarehouseInv1310CreateImport.update(
  {
    id: '/warehouse/inv1310/create',
    path: '/warehouse/inv1310/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv1310IdRoute = AuthWarehouseInv1310IdImport.update({
  id: '/warehouse/inv1310/$id',
  path: '/warehouse/inv1310/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv1210CreateRoute = AuthWarehouseInv1210CreateImport.update(
  {
    id: '/warehouse/inv1210/create',
    path: '/warehouse/inv1210/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv1210IdRoute = AuthWarehouseInv1210IdImport.update({
  id: '/warehouse/inv1210/$id',
  path: '/warehouse/inv1210/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv1140CreateRoute = AuthWarehouseInv1140CreateImport.update(
  {
    id: '/warehouse/inv1140/create',
    path: '/warehouse/inv1140/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv1140IdRoute = AuthWarehouseInv1140IdImport.update({
  id: '/warehouse/inv1140/$id',
  path: '/warehouse/inv1140/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv1120IdRoute = AuthWarehouseInv1120IdImport.update({
  id: '/warehouse/inv1120/$id',
  path: '/warehouse/inv1120/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv1110IdRoute = AuthWarehouseInv1110IdImport.update({
  id: '/warehouse/inv1110/$id',
  path: '/warehouse/inv1110/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv1015CreateRoute = AuthWarehouseInv1015CreateImport.update(
  {
    id: '/warehouse/inv1015/create',
    path: '/warehouse/inv1015/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv1015IdRoute = AuthWarehouseInv1015IdImport.update({
  id: '/warehouse/inv1015/$id',
  path: '/warehouse/inv1015/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWarehouseInv1010CreateRoute = AuthWarehouseInv1010CreateImport.update(
  {
    id: '/warehouse/inv1010/create',
    path: '/warehouse/inv1010/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv1010IdRoute = AuthWarehouseInv1010IdImport.update({
  id: '/warehouse/inv1010/$id',
  path: '/warehouse/inv1010/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsUsersCreateRoute = AuthSettingsUsersCreateImport.update({
  id: '/settings/users/create',
  path: '/settings/users/create',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsUsersIdRoute = AuthSettingsUsersIdImport.update({
  id: '/settings/users/$id',
  path: '/settings/users/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsSuppliersCreateRoute =
  AuthSettingsSuppliersCreateImport.update({
    id: '/settings/suppliers/create',
    path: '/settings/suppliers/create',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsSuppliersIdRoute = AuthSettingsSuppliersIdImport.update({
  id: '/settings/suppliers/$id',
  path: '/settings/suppliers/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsRunningNumbersCreateByYearRoute =
  AuthSettingsRunningNumbersCreateByYearImport.update({
    id: '/settings/running-numbers/create-by-year',
    path: '/settings/running-numbers/create-by-year',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsRunningNumbersCreateRoute =
  AuthSettingsRunningNumbersCreateImport.update({
    id: '/settings/running-numbers/create',
    path: '/settings/running-numbers/create',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsRunningNumbersIdRoute =
  AuthSettingsRunningNumbersIdImport.update({
    id: '/settings/running-numbers/$id',
    path: '/settings/running-numbers/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsRolesCreateRoute = AuthSettingsRolesCreateImport.update({
  id: '/settings/roles/create',
  path: '/settings/roles/create',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsRolesIdRoute = AuthSettingsRolesIdImport.update({
  id: '/settings/roles/$id',
  path: '/settings/roles/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsPartiesCreateRoute = AuthSettingsPartiesCreateImport.update({
  id: '/settings/parties/create',
  path: '/settings/parties/create',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsPartiesIdRoute = AuthSettingsPartiesIdImport.update({
  id: '/settings/parties/$id',
  path: '/settings/parties/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsMoldsCreateRoute = AuthSettingsMoldsCreateImport.update({
  id: '/settings/molds/create',
  path: '/settings/molds/create',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsMoldsIdRoute = AuthSettingsMoldsIdImport.update({
  id: '/settings/molds/$id',
  path: '/settings/molds/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsMachinesCreateRoute = AuthSettingsMachinesCreateImport.update(
  {
    id: '/settings/machines/create',
    path: '/settings/machines/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthSettingsMachinesIdRoute = AuthSettingsMachinesIdImport.update({
  id: '/settings/machines/$id',
  path: '/settings/machines/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsLocationsCreateRoute =
  AuthSettingsLocationsCreateImport.update({
    id: '/settings/locations/create',
    path: '/settings/locations/create',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsLocationsIdRoute = AuthSettingsLocationsIdImport.update({
  id: '/settings/locations/$id',
  path: '/settings/locations/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsItemsCreateRoute = AuthSettingsItemsCreateImport.update({
  id: '/settings/items/create',
  path: '/settings/items/create',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsHolidaysCreateRoute = AuthSettingsHolidaysCreateImport.update(
  {
    id: '/settings/holidays/create',
    path: '/settings/holidays/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthSettingsHolidaysIdRoute = AuthSettingsHolidaysIdImport.update({
  id: '/settings/holidays/$id',
  path: '/settings/holidays/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsGroupsCreateRoute = AuthSettingsGroupsCreateImport.update({
  id: '/settings/groups/create',
  path: '/settings/groups/create',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsGroupsIdRoute = AuthSettingsGroupsIdImport.update({
  id: '/settings/groups/$id',
  path: '/settings/groups/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsCustomersCreateRoute =
  AuthSettingsCustomersCreateImport.update({
    id: '/settings/customers/create',
    path: '/settings/customers/create',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsCustomersIdRoute = AuthSettingsCustomersIdImport.update({
  id: '/settings/customers/$id',
  path: '/settings/customers/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSaleSale2310CreateRoute = AuthSaleSale2310CreateImport.update({
  id: '/sale/sale2310/create',
  path: '/sale/sale2310/create',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSaleSale2310IdRoute = AuthSaleSale2310IdImport.update({
  id: '/sale/sale2310/$id',
  path: '/sale/sale2310/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSaleSale1230IdRoute = AuthSaleSale1230IdImport.update({
  id: '/sale/sale1230/$id',
  path: '/sale/sale1230/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSaleSale1220CreateRoute = AuthSaleSale1220CreateImport.update({
  id: '/sale/sale1220/create',
  path: '/sale/sale1220/create',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSaleSale1220IdRoute = AuthSaleSale1220IdImport.update({
  id: '/sale/sale1220/$id',
  path: '/sale/sale1220/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSaleSale1010CreateRoute = AuthSaleSale1010CreateImport.update({
  id: '/sale/sale1010/create',
  path: '/sale/sale1010/create',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSaleSale1010IdRoute = AuthSaleSale1010IdImport.update({
  id: '/sale/sale1010/$id',
  path: '/sale/sale1010/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthQcQc8110CreateRoute = AuthQcQc8110CreateImport.update({
  id: '/qc/qc8110/create',
  path: '/qc/qc8110/create',
  getParentRoute: () => AuthRoute,
} as any)

const AuthQcQc8110IdRoute = AuthQcQc8110IdImport.update({
  id: '/qc/qc8110/$id',
  path: '/qc/qc8110/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthQcQc8015IdRoute = AuthQcQc8015IdImport.update({
  id: '/qc/qc8015/$id',
  path: '/qc/qc8015/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthQcQc8010CreateRoute = AuthQcQc8010CreateImport.update({
  id: '/qc/qc8010/create',
  path: '/qc/qc8010/create',
  getParentRoute: () => AuthRoute,
} as any)

const AuthQcQc8010IdRoute = AuthQcQc8010IdImport.update({
  id: '/qc/qc8010/$id',
  path: '/qc/qc8010/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPurchasePo1010CreateRoute = AuthPurchasePo1010CreateImport.update({
  id: '/purchase/po1010/create',
  path: '/purchase/po1010/create',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPurchasePo1010IdRoute = AuthPurchasePo1010IdImport.update({
  id: '/purchase/po1010/$id',
  path: '/purchase/po1010/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthProductionWo3010CreateRoute = AuthProductionWo3010CreateImport.update(
  {
    id: '/production/wo3010/create',
    path: '/production/wo3010/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthProductionWo3010IdRoute = AuthProductionWo3010IdImport.update({
  id: '/production/wo3010/$id',
  path: '/production/wo3010/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthProductionWo1110IdRoute = AuthProductionWo1110IdImport.update({
  id: '/production/wo1110/$id',
  path: '/production/wo1110/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthProductionWo1010CreateRoute = AuthProductionWo1010CreateImport.update(
  {
    id: '/production/wo1010/create',
    path: '/production/wo1010/create',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthProductionWo1010IdRoute = AuthProductionWo1010IdImport.update({
  id: '/production/wo1010/$id',
  path: '/production/wo1010/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthProductionPrd4010IdRoute = AuthProductionPrd4010IdImport.update({
  id: '/production/prd4010/$id',
  path: '/production/prd4010/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthProductionPrd3110IdRoute = AuthProductionPrd3110IdImport.update({
  id: '/production/prd3110/$id',
  path: '/production/prd3110/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthProductionPrd3010IdRoute = AuthProductionPrd3010IdImport.update({
  id: '/production/prd3010/$id',
  path: '/production/prd3010/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthProductionPrd1210IdRoute = AuthProductionPrd1210IdImport.update({
  id: '/production/prd1210/$id',
  path: '/production/prd1210/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthAccountingReportsTrialBalanceRoute =
  AuthAccountingReportsTrialBalanceImport.update({
    id: '/accounting/reports/trial-balance',
    path: '/accounting/reports/trial-balance',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthAccountingReportsGeneralLedgerRoute =
  AuthAccountingReportsGeneralLedgerImport.update({
    id: '/accounting/reports/general-ledger',
    path: '/accounting/reports/general-ledger',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthAccountingJournalEntryCreateRoute =
  AuthAccountingJournalEntryCreateImport.update({
    id: '/accounting/journal-entry/create',
    path: '/accounting/journal-entry/create',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthAccountingJournalEntryIdRoute =
  AuthAccountingJournalEntryIdImport.update({
    id: '/accounting/journal-entry/$id',
    path: '/accounting/journal-entry/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthAccountingFiscalYearCreateRoute =
  AuthAccountingFiscalYearCreateImport.update({
    id: '/accounting/fiscal-year/create',
    path: '/accounting/fiscal-year/create',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthAccountingFiscalYearIdRoute = AuthAccountingFiscalYearIdImport.update(
  {
    id: '/accounting/fiscal-year/$id',
    path: '/accounting/fiscal-year/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthAccountingChartOfAccountsCreateRoute =
  AuthAccountingChartOfAccountsCreateImport.update({
    id: '/accounting/chart-of-accounts/create',
    path: '/accounting/chart-of-accounts/create',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsItemsItemIdIndexRoute =
  AuthSettingsItemsItemIdIndexImport.update({
    id: '/settings/items/$itemId/',
    path: '/settings/items/$itemId/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWarehouseInv4310AdjustIdRoute =
  AuthWarehouseInv4310AdjustIdImport.update({
    id: '/warehouse/inv4310/adjust/$id',
    path: '/warehouse/inv4310/adjust/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWarehouseInv4310IdOverrideItemsRoute =
  AuthWarehouseInv4310IdOverrideItemsImport.update({
    id: '/warehouse/inv4310/$id_/override-items',
    path: '/warehouse/inv4310/$id/override-items',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWarehouseInv3510EditIdRoute = AuthWarehouseInv3510EditIdImport.update(
  {
    id: '/warehouse/inv3510/edit/$id',
    path: '/warehouse/inv3510/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv3510IdZonesRoute =
  AuthWarehouseInv3510IdZonesImport.update({
    id: '/warehouse/inv3510/$id_/zones',
    path: '/warehouse/inv3510/$id/zones',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWarehouseInv3510IdVariancesRoute =
  AuthWarehouseInv3510IdVariancesImport.update({
    id: '/warehouse/inv3510/$id_/variances',
    path: '/warehouse/inv3510/$id/variances',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWarehouseInv3510IdProgressRoute =
  AuthWarehouseInv3510IdProgressImport.update({
    id: '/warehouse/inv3510/$id_/progress',
    path: '/warehouse/inv3510/$id/progress',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWarehouseInv3510IdCompletionRoute =
  AuthWarehouseInv3510IdCompletionImport.update({
    id: '/warehouse/inv3510/$id_/completion',
    path: '/warehouse/inv3510/$id/completion',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWarehouseInv3020EditIdRoute = AuthWarehouseInv3020EditIdImport.update(
  {
    id: '/warehouse/inv3020/edit/$id',
    path: '/warehouse/inv3020/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv3010EditIdRoute = AuthWarehouseInv3010EditIdImport.update(
  {
    id: '/warehouse/inv3010/edit/$id',
    path: '/warehouse/inv3010/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv2310EditIdRoute = AuthWarehouseInv2310EditIdImport.update(
  {
    id: '/warehouse/inv2310/edit/$id',
    path: '/warehouse/inv2310/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv2215EditIdRoute = AuthWarehouseInv2215EditIdImport.update(
  {
    id: '/warehouse/inv2215/edit/$id',
    path: '/warehouse/inv2215/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv2210EditIdRoute = AuthWarehouseInv2210EditIdImport.update(
  {
    id: '/warehouse/inv2210/edit/$id',
    path: '/warehouse/inv2210/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv2010EditIdRoute = AuthWarehouseInv2010EditIdImport.update(
  {
    id: '/warehouse/inv2010/edit/$id',
    path: '/warehouse/inv2010/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv1310EditIdRoute = AuthWarehouseInv1310EditIdImport.update(
  {
    id: '/warehouse/inv1310/edit/$id',
    path: '/warehouse/inv1310/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv1210EditIdRoute = AuthWarehouseInv1210EditIdImport.update(
  {
    id: '/warehouse/inv1210/edit/$id',
    path: '/warehouse/inv1210/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv1140EditIdRoute = AuthWarehouseInv1140EditIdImport.update(
  {
    id: '/warehouse/inv1140/edit/$id',
    path: '/warehouse/inv1140/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv1015EditIdRoute = AuthWarehouseInv1015EditIdImport.update(
  {
    id: '/warehouse/inv1015/edit/$id',
    path: '/warehouse/inv1015/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthWarehouseInv1010EditIdRoute = AuthWarehouseInv1010EditIdImport.update(
  {
    id: '/warehouse/inv1010/edit/$id',
    path: '/warehouse/inv1010/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthSettingsUsersEditIdRoute = AuthSettingsUsersEditIdImport.update({
  id: '/settings/users/edit/$id',
  path: '/settings/users/edit/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsSuppliersEditIdRoute =
  AuthSettingsSuppliersEditIdImport.update({
    id: '/settings/suppliers/edit/$id',
    path: '/settings/suppliers/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsRunningNumbersEditIdRoute =
  AuthSettingsRunningNumbersEditIdImport.update({
    id: '/settings/running-numbers/edit/$id',
    path: '/settings/running-numbers/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsRolesEditIdRoute = AuthSettingsRolesEditIdImport.update({
  id: '/settings/roles/edit/$id',
  path: '/settings/roles/edit/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsPartiesEditIdRoute = AuthSettingsPartiesEditIdImport.update({
  id: '/settings/parties/edit/$id',
  path: '/settings/parties/edit/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsMoldsEditIdRoute = AuthSettingsMoldsEditIdImport.update({
  id: '/settings/molds/edit/$id',
  path: '/settings/molds/edit/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsMoldsDeleteIdRoute = AuthSettingsMoldsDeleteIdImport.update({
  id: '/settings/molds/delete/$id',
  path: '/settings/molds/delete/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsMachinesEditIdRoute = AuthSettingsMachinesEditIdImport.update(
  {
    id: '/settings/machines/edit/$id',
    path: '/settings/machines/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthSettingsLocationsEditIdRoute =
  AuthSettingsLocationsEditIdImport.update({
    id: '/settings/locations/edit/$id',
    path: '/settings/locations/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsItemsViewIdRoute = AuthSettingsItemsViewIdImport.update({
  id: '/settings/items/view/$id',
  path: '/settings/items/view/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsItemsEditIdRoute = AuthSettingsItemsEditIdImport.update({
  id: '/settings/items/edit/$id',
  path: '/settings/items/edit/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsHolidaysEditIdRoute = AuthSettingsHolidaysEditIdImport.update(
  {
    id: '/settings/holidays/edit/$id',
    path: '/settings/holidays/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthSettingsGroupsEditIdRoute = AuthSettingsGroupsEditIdImport.update({
  id: '/settings/groups/edit/$id',
  path: '/settings/groups/edit/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSettingsCustomersEditIdRoute =
  AuthSettingsCustomersEditIdImport.update({
    id: '/settings/customers/edit/$id',
    path: '/settings/customers/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSaleSale2310EditIdRoute = AuthSaleSale2310EditIdImport.update({
  id: '/sale/sale2310/edit/$id',
  path: '/sale/sale2310/edit/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSaleSale1220EditIdRoute = AuthSaleSale1220EditIdImport.update({
  id: '/sale/sale1220/edit/$id',
  path: '/sale/sale1220/edit/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSaleSale1010EditIdRoute = AuthSaleSale1010EditIdImport.update({
  id: '/sale/sale1010/edit/$id',
  path: '/sale/sale1010/edit/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthQcQc8110EditIdRoute = AuthQcQc8110EditIdImport.update({
  id: '/qc/qc8110/edit/$id',
  path: '/qc/qc8110/edit/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthQcQc8010ViewIdRoute = AuthQcQc8010ViewIdImport.update({
  id: '/qc/qc8010/view/$id',
  path: '/qc/qc8010/view/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPurchasePo1010EditIdRoute = AuthPurchasePo1010EditIdImport.update({
  id: '/purchase/po1010/edit/$id',
  path: '/purchase/po1010/edit/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthProductionWo3010EditIdRoute = AuthProductionWo3010EditIdImport.update(
  {
    id: '/production/wo3010/edit/$id',
    path: '/production/wo3010/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthProductionWo1110EditIdRoute = AuthProductionWo1110EditIdImport.update(
  {
    id: '/production/wo1110/edit/$id',
    path: '/production/wo1110/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthProductionWo1010EditIdRoute = AuthProductionWo1010EditIdImport.update(
  {
    id: '/production/wo1010/edit/$id',
    path: '/production/wo1010/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthProductionPrd3110EditIdRoute =
  AuthProductionPrd3110EditIdImport.update({
    id: '/production/prd3110/edit/$id',
    path: '/production/prd3110/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthProductionPrd1110CreateWsidRoute =
  AuthProductionPrd1110CreateWsidImport.update({
    id: '/production/prd1110/create/$wsid',
    path: '/production/prd1110/create/$wsid',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthProductionPrd1010CreateWsidRoute =
  AuthProductionPrd1010CreateWsidImport.update({
    id: '/production/prd1010/create/$wsid',
    path: '/production/prd1010/create/$wsid',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthAccountingJournalEntryEditIdRoute =
  AuthAccountingJournalEntryEditIdImport.update({
    id: '/accounting/journal-entry/edit/$id',
    path: '/accounting/journal-entry/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthAccountingChartOfAccountsEditIdRoute =
  AuthAccountingChartOfAccountsEditIdImport.update({
    id: '/accounting/chart-of-accounts/edit/$id',
    path: '/accounting/chart-of-accounts/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsUsersIndexDeleteIdRoute =
  AuthSettingsUsersIndexDeleteIdImport.update({
    id: '/settings/users/index/delete/$id',
    path: '/settings/users/index/delete/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsSuppliersIndexDeleteIdRoute =
  AuthSettingsSuppliersIndexDeleteIdImport.update({
    id: '/settings/suppliers/index/delete/$id',
    path: '/settings/suppliers/index/delete/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsRunningNumbersIndexDeleteIdRoute =
  AuthSettingsRunningNumbersIndexDeleteIdImport.update({
    id: '/settings/running-numbers/index/delete/$id',
    path: '/settings/running-numbers/index/delete/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsPartiesIndexDeleteIdRoute =
  AuthSettingsPartiesIndexDeleteIdImport.update({
    id: '/settings/parties/index/delete/$id',
    path: '/settings/parties/index/delete/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsLocationsIndexDeleteIdRoute =
  AuthSettingsLocationsIndexDeleteIdImport.update({
    id: '/settings/locations/index/delete/$id',
    path: '/settings/locations/index/delete/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsCustomersIndexDeleteIdRoute =
  AuthSettingsCustomersIndexDeleteIdImport.update({
    id: '/settings/customers/index/delete/$id',
    path: '/settings/customers/index/delete/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthQcQc8030IndexResultIdRoute = AuthQcQc8030IndexResultIdImport.update({
  id: '/qc/qc8030/index/result/$id',
  path: '/qc/qc8030/index/result/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthQcQc1010IndexHoldIdRoute = AuthQcQc1010IndexHoldIdImport.update({
  id: '/qc/qc1010/index/hold/$id',
  path: '/qc/qc1010/index/hold/$id',
  getParentRoute: () => AuthRoute,
} as any)

const AuthProductionWo1210IndexHoldIdRoute =
  AuthProductionWo1210IndexHoldIdImport.update({
    id: '/production/wo1210/index/hold/$id',
    path: '/production/wo1210/index/hold/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsRolesEditIdDeleteRoute =
  AuthSettingsRolesEditIdDeleteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => AuthSettingsRolesEditIdRoute,
  } as any)

const AuthSettingsMachinesEditIdDeleteRoute =
  AuthSettingsMachinesEditIdDeleteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => AuthSettingsMachinesEditIdRoute,
  } as any)

const AuthSettingsItemsItemIdBomsCreateRoute =
  AuthSettingsItemsItemIdBomsCreateImport.update({
    id: '/settings/items/$itemId/boms/create',
    path: '/settings/items/$itemId/boms/create',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsItemsItemIdBomsIdRoute =
  AuthSettingsItemsItemIdBomsIdImport.update({
    id: '/settings/items/$itemId/boms/$id',
    path: '/settings/items/$itemId/boms/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsHolidaysEditIdDeleteRoute =
  AuthSettingsHolidaysEditIdDeleteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => AuthSettingsHolidaysEditIdRoute,
  } as any)

const AuthPurchaseTrackingReceiveIdItemIdRoute =
  AuthPurchaseTrackingReceiveIdItemIdImport.update({
    id: '/purchase/tracking/receive/$id/$itemId',
    path: '/purchase/tracking/receive/$id/$itemId',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthProductionPrd1110EditWsidIdRoute =
  AuthProductionPrd1110EditWsidIdImport.update({
    id: '/production/prd1110/edit/$wsid/$id',
    path: '/production/prd1110/edit/$wsid/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthProductionPrd1010EditWsidIdRoute =
  AuthProductionPrd1010EditWsidIdImport.update({
    id: '/production/prd1010/edit/$wsid/$id',
    path: '/production/prd1010/edit/$wsid/$id',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthSettingsItemsItemIdBomsEditIdRoute =
  AuthSettingsItemsItemIdBomsEditIdImport.update({
    id: '/settings/items/$itemId/boms/edit/$id',
    path: '/settings/items/$itemId/boms/edit/$id',
    getParentRoute: () => AuthRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/_auth/change-password': {
      id: '/_auth/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AuthChangePasswordImport
      parentRoute: typeof AuthImport
    }
    '/_auth/home': {
      id: '/_auth/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthHomeImport
      parentRoute: typeof AuthImport
    }
    '/_auth/no-permission': {
      id: '/_auth/no-permission'
      path: '/no-permission'
      fullPath: '/no-permission'
      preLoaderRoute: typeof AuthNoPermissionImport
      parentRoute: typeof AuthImport
    }
    '/_auth/testrun/': {
      id: '/_auth/testrun/'
      path: '/testrun'
      fullPath: '/testrun'
      preLoaderRoute: typeof AuthTestrunIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/user-messages/': {
      id: '/_auth/user-messages/'
      path: '/user-messages'
      fullPath: '/user-messages'
      preLoaderRoute: typeof AuthUserMessagesIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/accounting/chart-of-accounts/create': {
      id: '/_auth/accounting/chart-of-accounts/create'
      path: '/accounting/chart-of-accounts/create'
      fullPath: '/accounting/chart-of-accounts/create'
      preLoaderRoute: typeof AuthAccountingChartOfAccountsCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/accounting/fiscal-year/$id': {
      id: '/_auth/accounting/fiscal-year/$id'
      path: '/accounting/fiscal-year/$id'
      fullPath: '/accounting/fiscal-year/$id'
      preLoaderRoute: typeof AuthAccountingFiscalYearIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/accounting/fiscal-year/create': {
      id: '/_auth/accounting/fiscal-year/create'
      path: '/accounting/fiscal-year/create'
      fullPath: '/accounting/fiscal-year/create'
      preLoaderRoute: typeof AuthAccountingFiscalYearCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/accounting/journal-entry/$id': {
      id: '/_auth/accounting/journal-entry/$id'
      path: '/accounting/journal-entry/$id'
      fullPath: '/accounting/journal-entry/$id'
      preLoaderRoute: typeof AuthAccountingJournalEntryIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/accounting/journal-entry/create': {
      id: '/_auth/accounting/journal-entry/create'
      path: '/accounting/journal-entry/create'
      fullPath: '/accounting/journal-entry/create'
      preLoaderRoute: typeof AuthAccountingJournalEntryCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/accounting/reports/general-ledger': {
      id: '/_auth/accounting/reports/general-ledger'
      path: '/accounting/reports/general-ledger'
      fullPath: '/accounting/reports/general-ledger'
      preLoaderRoute: typeof AuthAccountingReportsGeneralLedgerImport
      parentRoute: typeof AuthImport
    }
    '/_auth/accounting/reports/trial-balance': {
      id: '/_auth/accounting/reports/trial-balance'
      path: '/accounting/reports/trial-balance'
      fullPath: '/accounting/reports/trial-balance'
      preLoaderRoute: typeof AuthAccountingReportsTrialBalanceImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd1210/$id': {
      id: '/_auth/production/prd1210/$id'
      path: '/production/prd1210/$id'
      fullPath: '/production/prd1210/$id'
      preLoaderRoute: typeof AuthProductionPrd1210IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd3010/$id': {
      id: '/_auth/production/prd3010/$id'
      path: '/production/prd3010/$id'
      fullPath: '/production/prd3010/$id'
      preLoaderRoute: typeof AuthProductionPrd3010IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd3110/$id': {
      id: '/_auth/production/prd3110/$id'
      path: '/production/prd3110/$id'
      fullPath: '/production/prd3110/$id'
      preLoaderRoute: typeof AuthProductionPrd3110IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd4010/$id': {
      id: '/_auth/production/prd4010/$id'
      path: '/production/prd4010/$id'
      fullPath: '/production/prd4010/$id'
      preLoaderRoute: typeof AuthProductionPrd4010IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/wo1010/$id': {
      id: '/_auth/production/wo1010/$id'
      path: '/production/wo1010/$id'
      fullPath: '/production/wo1010/$id'
      preLoaderRoute: typeof AuthProductionWo1010IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/wo1010/create': {
      id: '/_auth/production/wo1010/create'
      path: '/production/wo1010/create'
      fullPath: '/production/wo1010/create'
      preLoaderRoute: typeof AuthProductionWo1010CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/wo1110/$id': {
      id: '/_auth/production/wo1110/$id'
      path: '/production/wo1110/$id'
      fullPath: '/production/wo1110/$id'
      preLoaderRoute: typeof AuthProductionWo1110IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/wo3010/$id': {
      id: '/_auth/production/wo3010/$id'
      path: '/production/wo3010/$id'
      fullPath: '/production/wo3010/$id'
      preLoaderRoute: typeof AuthProductionWo3010IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/wo3010/create': {
      id: '/_auth/production/wo3010/create'
      path: '/production/wo3010/create'
      fullPath: '/production/wo3010/create'
      preLoaderRoute: typeof AuthProductionWo3010CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/purchase/po1010/$id': {
      id: '/_auth/purchase/po1010/$id'
      path: '/purchase/po1010/$id'
      fullPath: '/purchase/po1010/$id'
      preLoaderRoute: typeof AuthPurchasePo1010IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/purchase/po1010/create': {
      id: '/_auth/purchase/po1010/create'
      path: '/purchase/po1010/create'
      fullPath: '/purchase/po1010/create'
      preLoaderRoute: typeof AuthPurchasePo1010CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/qc/qc8010/$id': {
      id: '/_auth/qc/qc8010/$id'
      path: '/qc/qc8010/$id'
      fullPath: '/qc/qc8010/$id'
      preLoaderRoute: typeof AuthQcQc8010IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/qc/qc8010/create': {
      id: '/_auth/qc/qc8010/create'
      path: '/qc/qc8010/create'
      fullPath: '/qc/qc8010/create'
      preLoaderRoute: typeof AuthQcQc8010CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/qc/qc8015/$id': {
      id: '/_auth/qc/qc8015/$id'
      path: '/qc/qc8015/$id'
      fullPath: '/qc/qc8015/$id'
      preLoaderRoute: typeof AuthQcQc8015IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/qc/qc8110/$id': {
      id: '/_auth/qc/qc8110/$id'
      path: '/qc/qc8110/$id'
      fullPath: '/qc/qc8110/$id'
      preLoaderRoute: typeof AuthQcQc8110IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/qc/qc8110/create': {
      id: '/_auth/qc/qc8110/create'
      path: '/qc/qc8110/create'
      fullPath: '/qc/qc8110/create'
      preLoaderRoute: typeof AuthQcQc8110CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale1010/$id': {
      id: '/_auth/sale/sale1010/$id'
      path: '/sale/sale1010/$id'
      fullPath: '/sale/sale1010/$id'
      preLoaderRoute: typeof AuthSaleSale1010IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale1010/create': {
      id: '/_auth/sale/sale1010/create'
      path: '/sale/sale1010/create'
      fullPath: '/sale/sale1010/create'
      preLoaderRoute: typeof AuthSaleSale1010CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale1220/$id': {
      id: '/_auth/sale/sale1220/$id'
      path: '/sale/sale1220/$id'
      fullPath: '/sale/sale1220/$id'
      preLoaderRoute: typeof AuthSaleSale1220IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale1220/create': {
      id: '/_auth/sale/sale1220/create'
      path: '/sale/sale1220/create'
      fullPath: '/sale/sale1220/create'
      preLoaderRoute: typeof AuthSaleSale1220CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale1230/$id': {
      id: '/_auth/sale/sale1230/$id'
      path: '/sale/sale1230/$id'
      fullPath: '/sale/sale1230/$id'
      preLoaderRoute: typeof AuthSaleSale1230IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale2310/$id': {
      id: '/_auth/sale/sale2310/$id'
      path: '/sale/sale2310/$id'
      fullPath: '/sale/sale2310/$id'
      preLoaderRoute: typeof AuthSaleSale2310IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale2310/create': {
      id: '/_auth/sale/sale2310/create'
      path: '/sale/sale2310/create'
      fullPath: '/sale/sale2310/create'
      preLoaderRoute: typeof AuthSaleSale2310CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/customers/$id': {
      id: '/_auth/settings/customers/$id'
      path: '/settings/customers/$id'
      fullPath: '/settings/customers/$id'
      preLoaderRoute: typeof AuthSettingsCustomersIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/customers/create': {
      id: '/_auth/settings/customers/create'
      path: '/settings/customers/create'
      fullPath: '/settings/customers/create'
      preLoaderRoute: typeof AuthSettingsCustomersCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/groups/$id': {
      id: '/_auth/settings/groups/$id'
      path: '/settings/groups/$id'
      fullPath: '/settings/groups/$id'
      preLoaderRoute: typeof AuthSettingsGroupsIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/groups/create': {
      id: '/_auth/settings/groups/create'
      path: '/settings/groups/create'
      fullPath: '/settings/groups/create'
      preLoaderRoute: typeof AuthSettingsGroupsCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/holidays/$id': {
      id: '/_auth/settings/holidays/$id'
      path: '/settings/holidays/$id'
      fullPath: '/settings/holidays/$id'
      preLoaderRoute: typeof AuthSettingsHolidaysIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/holidays/create': {
      id: '/_auth/settings/holidays/create'
      path: '/settings/holidays/create'
      fullPath: '/settings/holidays/create'
      preLoaderRoute: typeof AuthSettingsHolidaysCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/items/create': {
      id: '/_auth/settings/items/create'
      path: '/settings/items/create'
      fullPath: '/settings/items/create'
      preLoaderRoute: typeof AuthSettingsItemsCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/locations/$id': {
      id: '/_auth/settings/locations/$id'
      path: '/settings/locations/$id'
      fullPath: '/settings/locations/$id'
      preLoaderRoute: typeof AuthSettingsLocationsIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/locations/create': {
      id: '/_auth/settings/locations/create'
      path: '/settings/locations/create'
      fullPath: '/settings/locations/create'
      preLoaderRoute: typeof AuthSettingsLocationsCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/machines/$id': {
      id: '/_auth/settings/machines/$id'
      path: '/settings/machines/$id'
      fullPath: '/settings/machines/$id'
      preLoaderRoute: typeof AuthSettingsMachinesIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/machines/create': {
      id: '/_auth/settings/machines/create'
      path: '/settings/machines/create'
      fullPath: '/settings/machines/create'
      preLoaderRoute: typeof AuthSettingsMachinesCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/molds/$id': {
      id: '/_auth/settings/molds/$id'
      path: '/settings/molds/$id'
      fullPath: '/settings/molds/$id'
      preLoaderRoute: typeof AuthSettingsMoldsIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/molds/create': {
      id: '/_auth/settings/molds/create'
      path: '/settings/molds/create'
      fullPath: '/settings/molds/create'
      preLoaderRoute: typeof AuthSettingsMoldsCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/parties/$id': {
      id: '/_auth/settings/parties/$id'
      path: '/settings/parties/$id'
      fullPath: '/settings/parties/$id'
      preLoaderRoute: typeof AuthSettingsPartiesIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/parties/create': {
      id: '/_auth/settings/parties/create'
      path: '/settings/parties/create'
      fullPath: '/settings/parties/create'
      preLoaderRoute: typeof AuthSettingsPartiesCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/roles/$id': {
      id: '/_auth/settings/roles/$id'
      path: '/settings/roles/$id'
      fullPath: '/settings/roles/$id'
      preLoaderRoute: typeof AuthSettingsRolesIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/roles/create': {
      id: '/_auth/settings/roles/create'
      path: '/settings/roles/create'
      fullPath: '/settings/roles/create'
      preLoaderRoute: typeof AuthSettingsRolesCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/running-numbers/$id': {
      id: '/_auth/settings/running-numbers/$id'
      path: '/settings/running-numbers/$id'
      fullPath: '/settings/running-numbers/$id'
      preLoaderRoute: typeof AuthSettingsRunningNumbersIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/running-numbers/create': {
      id: '/_auth/settings/running-numbers/create'
      path: '/settings/running-numbers/create'
      fullPath: '/settings/running-numbers/create'
      preLoaderRoute: typeof AuthSettingsRunningNumbersCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/running-numbers/create-by-year': {
      id: '/_auth/settings/running-numbers/create-by-year'
      path: '/settings/running-numbers/create-by-year'
      fullPath: '/settings/running-numbers/create-by-year'
      preLoaderRoute: typeof AuthSettingsRunningNumbersCreateByYearImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/suppliers/$id': {
      id: '/_auth/settings/suppliers/$id'
      path: '/settings/suppliers/$id'
      fullPath: '/settings/suppliers/$id'
      preLoaderRoute: typeof AuthSettingsSuppliersIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/suppliers/create': {
      id: '/_auth/settings/suppliers/create'
      path: '/settings/suppliers/create'
      fullPath: '/settings/suppliers/create'
      preLoaderRoute: typeof AuthSettingsSuppliersCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/users/$id': {
      id: '/_auth/settings/users/$id'
      path: '/settings/users/$id'
      fullPath: '/settings/users/$id'
      preLoaderRoute: typeof AuthSettingsUsersIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/users/create': {
      id: '/_auth/settings/users/create'
      path: '/settings/users/create'
      fullPath: '/settings/users/create'
      preLoaderRoute: typeof AuthSettingsUsersCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1010/$id': {
      id: '/_auth/warehouse/inv1010/$id'
      path: '/warehouse/inv1010/$id'
      fullPath: '/warehouse/inv1010/$id'
      preLoaderRoute: typeof AuthWarehouseInv1010IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1010/create': {
      id: '/_auth/warehouse/inv1010/create'
      path: '/warehouse/inv1010/create'
      fullPath: '/warehouse/inv1010/create'
      preLoaderRoute: typeof AuthWarehouseInv1010CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1015/$id': {
      id: '/_auth/warehouse/inv1015/$id'
      path: '/warehouse/inv1015/$id'
      fullPath: '/warehouse/inv1015/$id'
      preLoaderRoute: typeof AuthWarehouseInv1015IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1015/create': {
      id: '/_auth/warehouse/inv1015/create'
      path: '/warehouse/inv1015/create'
      fullPath: '/warehouse/inv1015/create'
      preLoaderRoute: typeof AuthWarehouseInv1015CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1110/$id': {
      id: '/_auth/warehouse/inv1110/$id'
      path: '/warehouse/inv1110/$id'
      fullPath: '/warehouse/inv1110/$id'
      preLoaderRoute: typeof AuthWarehouseInv1110IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1120/$id': {
      id: '/_auth/warehouse/inv1120/$id'
      path: '/warehouse/inv1120/$id'
      fullPath: '/warehouse/inv1120/$id'
      preLoaderRoute: typeof AuthWarehouseInv1120IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1140/$id': {
      id: '/_auth/warehouse/inv1140/$id'
      path: '/warehouse/inv1140/$id'
      fullPath: '/warehouse/inv1140/$id'
      preLoaderRoute: typeof AuthWarehouseInv1140IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1140/create': {
      id: '/_auth/warehouse/inv1140/create'
      path: '/warehouse/inv1140/create'
      fullPath: '/warehouse/inv1140/create'
      preLoaderRoute: typeof AuthWarehouseInv1140CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1210/$id': {
      id: '/_auth/warehouse/inv1210/$id'
      path: '/warehouse/inv1210/$id'
      fullPath: '/warehouse/inv1210/$id'
      preLoaderRoute: typeof AuthWarehouseInv1210IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1210/create': {
      id: '/_auth/warehouse/inv1210/create'
      path: '/warehouse/inv1210/create'
      fullPath: '/warehouse/inv1210/create'
      preLoaderRoute: typeof AuthWarehouseInv1210CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1310/$id': {
      id: '/_auth/warehouse/inv1310/$id'
      path: '/warehouse/inv1310/$id'
      fullPath: '/warehouse/inv1310/$id'
      preLoaderRoute: typeof AuthWarehouseInv1310IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1310/create': {
      id: '/_auth/warehouse/inv1310/create'
      path: '/warehouse/inv1310/create'
      fullPath: '/warehouse/inv1310/create'
      preLoaderRoute: typeof AuthWarehouseInv1310CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv2010/$id': {
      id: '/_auth/warehouse/inv2010/$id'
      path: '/warehouse/inv2010/$id'
      fullPath: '/warehouse/inv2010/$id'
      preLoaderRoute: typeof AuthWarehouseInv2010IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv2010/create': {
      id: '/_auth/warehouse/inv2010/create'
      path: '/warehouse/inv2010/create'
      fullPath: '/warehouse/inv2010/create'
      preLoaderRoute: typeof AuthWarehouseInv2010CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv2210/$id': {
      id: '/_auth/warehouse/inv2210/$id'
      path: '/warehouse/inv2210/$id'
      fullPath: '/warehouse/inv2210/$id'
      preLoaderRoute: typeof AuthWarehouseInv2210IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv2210/create': {
      id: '/_auth/warehouse/inv2210/create'
      path: '/warehouse/inv2210/create'
      fullPath: '/warehouse/inv2210/create'
      preLoaderRoute: typeof AuthWarehouseInv2210CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv2215/$id': {
      id: '/_auth/warehouse/inv2215/$id'
      path: '/warehouse/inv2215/$id'
      fullPath: '/warehouse/inv2215/$id'
      preLoaderRoute: typeof AuthWarehouseInv2215IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv2215/create': {
      id: '/_auth/warehouse/inv2215/create'
      path: '/warehouse/inv2215/create'
      fullPath: '/warehouse/inv2215/create'
      preLoaderRoute: typeof AuthWarehouseInv2215CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv2310/$id': {
      id: '/_auth/warehouse/inv2310/$id'
      path: '/warehouse/inv2310/$id'
      fullPath: '/warehouse/inv2310/$id'
      preLoaderRoute: typeof AuthWarehouseInv2310IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv2310/create': {
      id: '/_auth/warehouse/inv2310/create'
      path: '/warehouse/inv2310/create'
      fullPath: '/warehouse/inv2310/create'
      preLoaderRoute: typeof AuthWarehouseInv2310CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv3010/$id': {
      id: '/_auth/warehouse/inv3010/$id'
      path: '/warehouse/inv3010/$id'
      fullPath: '/warehouse/inv3010/$id'
      preLoaderRoute: typeof AuthWarehouseInv3010IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv3010/create': {
      id: '/_auth/warehouse/inv3010/create'
      path: '/warehouse/inv3010/create'
      fullPath: '/warehouse/inv3010/create'
      preLoaderRoute: typeof AuthWarehouseInv3010CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv3020/$id': {
      id: '/_auth/warehouse/inv3020/$id'
      path: '/warehouse/inv3020/$id'
      fullPath: '/warehouse/inv3020/$id'
      preLoaderRoute: typeof AuthWarehouseInv3020IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv3020/create': {
      id: '/_auth/warehouse/inv3020/create'
      path: '/warehouse/inv3020/create'
      fullPath: '/warehouse/inv3020/create'
      preLoaderRoute: typeof AuthWarehouseInv3020CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv3510/$id': {
      id: '/_auth/warehouse/inv3510/$id'
      path: '/warehouse/inv3510/$id'
      fullPath: '/warehouse/inv3510/$id'
      preLoaderRoute: typeof AuthWarehouseInv3510IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv3510/create': {
      id: '/_auth/warehouse/inv3510/create'
      path: '/warehouse/inv3510/create'
      fullPath: '/warehouse/inv3510/create'
      preLoaderRoute: typeof AuthWarehouseInv3510CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv4310/$id': {
      id: '/_auth/warehouse/inv4310/$id'
      path: '/warehouse/inv4310/$id'
      fullPath: '/warehouse/inv4310/$id'
      preLoaderRoute: typeof AuthWarehouseInv4310IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv4310/create': {
      id: '/_auth/warehouse/inv4310/create'
      path: '/warehouse/inv4310/create'
      fullPath: '/warehouse/inv4310/create'
      preLoaderRoute: typeof AuthWarehouseInv4310CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv5010/$id': {
      id: '/_auth/warehouse/inv5010/$id'
      path: '/warehouse/inv5010/$id'
      fullPath: '/warehouse/inv5010/$id'
      preLoaderRoute: typeof AuthWarehouseInv5010IdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv5010/create': {
      id: '/_auth/warehouse/inv5010/create'
      path: '/warehouse/inv5010/create'
      fullPath: '/warehouse/inv5010/create'
      preLoaderRoute: typeof AuthWarehouseInv5010CreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/accounting/chart-of-accounts/': {
      id: '/_auth/accounting/chart-of-accounts/'
      path: '/accounting/chart-of-accounts'
      fullPath: '/accounting/chart-of-accounts'
      preLoaderRoute: typeof AuthAccountingChartOfAccountsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/accounting/fiscal-year/': {
      id: '/_auth/accounting/fiscal-year/'
      path: '/accounting/fiscal-year'
      fullPath: '/accounting/fiscal-year'
      preLoaderRoute: typeof AuthAccountingFiscalYearIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/accounting/journal-entry/': {
      id: '/_auth/accounting/journal-entry/'
      path: '/accounting/journal-entry'
      fullPath: '/accounting/journal-entry'
      preLoaderRoute: typeof AuthAccountingJournalEntryIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd1010/': {
      id: '/_auth/production/prd1010/'
      path: '/production/prd1010'
      fullPath: '/production/prd1010'
      preLoaderRoute: typeof AuthProductionPrd1010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd1011/': {
      id: '/_auth/production/prd1011/'
      path: '/production/prd1011'
      fullPath: '/production/prd1011'
      preLoaderRoute: typeof AuthProductionPrd1011IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd1015/': {
      id: '/_auth/production/prd1015/'
      path: '/production/prd1015'
      fullPath: '/production/prd1015'
      preLoaderRoute: typeof AuthProductionPrd1015IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd1110/': {
      id: '/_auth/production/prd1110/'
      path: '/production/prd1110'
      fullPath: '/production/prd1110'
      preLoaderRoute: typeof AuthProductionPrd1110IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd1210/': {
      id: '/_auth/production/prd1210/'
      path: '/production/prd1210'
      fullPath: '/production/prd1210'
      preLoaderRoute: typeof AuthProductionPrd1210IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd2010/': {
      id: '/_auth/production/prd2010/'
      path: '/production/prd2010'
      fullPath: '/production/prd2010'
      preLoaderRoute: typeof AuthProductionPrd2010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd3010/': {
      id: '/_auth/production/prd3010/'
      path: '/production/prd3010'
      fullPath: '/production/prd3010'
      preLoaderRoute: typeof AuthProductionPrd3010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd3110/': {
      id: '/_auth/production/prd3110/'
      path: '/production/prd3110'
      fullPath: '/production/prd3110'
      preLoaderRoute: typeof AuthProductionPrd3110IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd4010/': {
      id: '/_auth/production/prd4010/'
      path: '/production/prd4010'
      fullPath: '/production/prd4010'
      preLoaderRoute: typeof AuthProductionPrd4010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd4020/': {
      id: '/_auth/production/prd4020/'
      path: '/production/prd4020'
      fullPath: '/production/prd4020'
      preLoaderRoute: typeof AuthProductionPrd4020IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd4030/': {
      id: '/_auth/production/prd4030/'
      path: '/production/prd4030'
      fullPath: '/production/prd4030'
      preLoaderRoute: typeof AuthProductionPrd4030IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/wo1010/': {
      id: '/_auth/production/wo1010/'
      path: '/production/wo1010'
      fullPath: '/production/wo1010'
      preLoaderRoute: typeof AuthProductionWo1010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/wo1110/': {
      id: '/_auth/production/wo1110/'
      path: '/production/wo1110'
      fullPath: '/production/wo1110'
      preLoaderRoute: typeof AuthProductionWo1110IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/wo1115/': {
      id: '/_auth/production/wo1115/'
      path: '/production/wo1115'
      fullPath: '/production/wo1115'
      preLoaderRoute: typeof AuthProductionWo1115IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/wo1210/': {
      id: '/_auth/production/wo1210/'
      path: '/production/wo1210'
      fullPath: '/production/wo1210'
      preLoaderRoute: typeof AuthProductionWo1210IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/wo3010/': {
      id: '/_auth/production/wo3010/'
      path: '/production/wo3010'
      fullPath: '/production/wo3010'
      preLoaderRoute: typeof AuthProductionWo3010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/wo9010/': {
      id: '/_auth/production/wo9010/'
      path: '/production/wo9010'
      fullPath: '/production/wo9010'
      preLoaderRoute: typeof AuthProductionWo9010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/purchase/bplus-sync/': {
      id: '/_auth/purchase/bplus-sync/'
      path: '/purchase/bplus-sync'
      fullPath: '/purchase/bplus-sync'
      preLoaderRoute: typeof AuthPurchaseBplusSyncIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/purchase/po1010/': {
      id: '/_auth/purchase/po1010/'
      path: '/purchase/po1010'
      fullPath: '/purchase/po1010'
      preLoaderRoute: typeof AuthPurchasePo1010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/purchase/po9010/': {
      id: '/_auth/purchase/po9010/'
      path: '/purchase/po9010'
      fullPath: '/purchase/po9010'
      preLoaderRoute: typeof AuthPurchasePo9010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/purchase/po9020/': {
      id: '/_auth/purchase/po9020/'
      path: '/purchase/po9020'
      fullPath: '/purchase/po9020'
      preLoaderRoute: typeof AuthPurchasePo9020IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/purchase/po9030/': {
      id: '/_auth/purchase/po9030/'
      path: '/purchase/po9030'
      fullPath: '/purchase/po9030'
      preLoaderRoute: typeof AuthPurchasePo9030IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/purchase/problem/': {
      id: '/_auth/purchase/problem/'
      path: '/purchase/problem'
      fullPath: '/purchase/problem'
      preLoaderRoute: typeof AuthPurchaseProblemIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/purchase/tracking/': {
      id: '/_auth/purchase/tracking/'
      path: '/purchase/tracking'
      fullPath: '/purchase/tracking'
      preLoaderRoute: typeof AuthPurchaseTrackingIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/qc/qc1010/': {
      id: '/_auth/qc/qc1010/'
      path: '/qc/qc1010'
      fullPath: '/qc/qc1010'
      preLoaderRoute: typeof AuthQcQc1010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/qc/qc8010/': {
      id: '/_auth/qc/qc8010/'
      path: '/qc/qc8010'
      fullPath: '/qc/qc8010'
      preLoaderRoute: typeof AuthQcQc8010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/qc/qc8015/': {
      id: '/_auth/qc/qc8015/'
      path: '/qc/qc8015'
      fullPath: '/qc/qc8015'
      preLoaderRoute: typeof AuthQcQc8015IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/qc/qc8030/': {
      id: '/_auth/qc/qc8030/'
      path: '/qc/qc8030'
      fullPath: '/qc/qc8030'
      preLoaderRoute: typeof AuthQcQc8030IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/qc/qc8110/': {
      id: '/_auth/qc/qc8110/'
      path: '/qc/qc8110'
      fullPath: '/qc/qc8110'
      preLoaderRoute: typeof AuthQcQc8110IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/qc/qc9010/': {
      id: '/_auth/qc/qc9010/'
      path: '/qc/qc9010'
      fullPath: '/qc/qc9010'
      preLoaderRoute: typeof AuthQcQc9010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale1010/': {
      id: '/_auth/sale/sale1010/'
      path: '/sale/sale1010'
      fullPath: '/sale/sale1010'
      preLoaderRoute: typeof AuthSaleSale1010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale1020/': {
      id: '/_auth/sale/sale1020/'
      path: '/sale/sale1020'
      fullPath: '/sale/sale1020'
      preLoaderRoute: typeof AuthSaleSale1020IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale1030/': {
      id: '/_auth/sale/sale1030/'
      path: '/sale/sale1030'
      fullPath: '/sale/sale1030'
      preLoaderRoute: typeof AuthSaleSale1030IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale1210/': {
      id: '/_auth/sale/sale1210/'
      path: '/sale/sale1210'
      fullPath: '/sale/sale1210'
      preLoaderRoute: typeof AuthSaleSale1210IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale1220/': {
      id: '/_auth/sale/sale1220/'
      path: '/sale/sale1220'
      fullPath: '/sale/sale1220'
      preLoaderRoute: typeof AuthSaleSale1220IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale1230/': {
      id: '/_auth/sale/sale1230/'
      path: '/sale/sale1230'
      fullPath: '/sale/sale1230'
      preLoaderRoute: typeof AuthSaleSale1230IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale2310/': {
      id: '/_auth/sale/sale2310/'
      path: '/sale/sale2310'
      fullPath: '/sale/sale2310'
      preLoaderRoute: typeof AuthSaleSale2310IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/customers/': {
      id: '/_auth/settings/customers/'
      path: '/settings/customers'
      fullPath: '/settings/customers'
      preLoaderRoute: typeof AuthSettingsCustomersIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/groups/': {
      id: '/_auth/settings/groups/'
      path: '/settings/groups'
      fullPath: '/settings/groups'
      preLoaderRoute: typeof AuthSettingsGroupsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/holidays/': {
      id: '/_auth/settings/holidays/'
      path: '/settings/holidays'
      fullPath: '/settings/holidays'
      preLoaderRoute: typeof AuthSettingsHolidaysIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/items/': {
      id: '/_auth/settings/items/'
      path: '/settings/items'
      fullPath: '/settings/items'
      preLoaderRoute: typeof AuthSettingsItemsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/locations/': {
      id: '/_auth/settings/locations/'
      path: '/settings/locations'
      fullPath: '/settings/locations'
      preLoaderRoute: typeof AuthSettingsLocationsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/machines/': {
      id: '/_auth/settings/machines/'
      path: '/settings/machines'
      fullPath: '/settings/machines'
      preLoaderRoute: typeof AuthSettingsMachinesIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/molds/': {
      id: '/_auth/settings/molds/'
      path: '/settings/molds'
      fullPath: '/settings/molds'
      preLoaderRoute: typeof AuthSettingsMoldsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/parties/': {
      id: '/_auth/settings/parties/'
      path: '/settings/parties'
      fullPath: '/settings/parties'
      preLoaderRoute: typeof AuthSettingsPartiesIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/roles/': {
      id: '/_auth/settings/roles/'
      path: '/settings/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AuthSettingsRolesIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/running-numbers/': {
      id: '/_auth/settings/running-numbers/'
      path: '/settings/running-numbers'
      fullPath: '/settings/running-numbers'
      preLoaderRoute: typeof AuthSettingsRunningNumbersIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/screen-capture/': {
      id: '/_auth/settings/screen-capture/'
      path: '/settings/screen-capture'
      fullPath: '/settings/screen-capture'
      preLoaderRoute: typeof AuthSettingsScreenCaptureIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/suppliers/': {
      id: '/_auth/settings/suppliers/'
      path: '/settings/suppliers'
      fullPath: '/settings/suppliers'
      preLoaderRoute: typeof AuthSettingsSuppliersIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/users/': {
      id: '/_auth/settings/users/'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthSettingsUsersIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/dashboard/': {
      id: '/_auth/warehouse/dashboard/'
      path: '/warehouse/dashboard'
      fullPath: '/warehouse/dashboard'
      preLoaderRoute: typeof AuthWarehouseDashboardIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1010/': {
      id: '/_auth/warehouse/inv1010/'
      path: '/warehouse/inv1010'
      fullPath: '/warehouse/inv1010'
      preLoaderRoute: typeof AuthWarehouseInv1010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1015/': {
      id: '/_auth/warehouse/inv1015/'
      path: '/warehouse/inv1015'
      fullPath: '/warehouse/inv1015'
      preLoaderRoute: typeof AuthWarehouseInv1015IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1110/': {
      id: '/_auth/warehouse/inv1110/'
      path: '/warehouse/inv1110'
      fullPath: '/warehouse/inv1110'
      preLoaderRoute: typeof AuthWarehouseInv1110IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1120/': {
      id: '/_auth/warehouse/inv1120/'
      path: '/warehouse/inv1120'
      fullPath: '/warehouse/inv1120'
      preLoaderRoute: typeof AuthWarehouseInv1120IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1140/': {
      id: '/_auth/warehouse/inv1140/'
      path: '/warehouse/inv1140'
      fullPath: '/warehouse/inv1140'
      preLoaderRoute: typeof AuthWarehouseInv1140IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1210/': {
      id: '/_auth/warehouse/inv1210/'
      path: '/warehouse/inv1210'
      fullPath: '/warehouse/inv1210'
      preLoaderRoute: typeof AuthWarehouseInv1210IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1310/': {
      id: '/_auth/warehouse/inv1310/'
      path: '/warehouse/inv1310'
      fullPath: '/warehouse/inv1310'
      preLoaderRoute: typeof AuthWarehouseInv1310IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv2010/': {
      id: '/_auth/warehouse/inv2010/'
      path: '/warehouse/inv2010'
      fullPath: '/warehouse/inv2010'
      preLoaderRoute: typeof AuthWarehouseInv2010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv2210/': {
      id: '/_auth/warehouse/inv2210/'
      path: '/warehouse/inv2210'
      fullPath: '/warehouse/inv2210'
      preLoaderRoute: typeof AuthWarehouseInv2210IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv2215/': {
      id: '/_auth/warehouse/inv2215/'
      path: '/warehouse/inv2215'
      fullPath: '/warehouse/inv2215'
      preLoaderRoute: typeof AuthWarehouseInv2215IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv2310/': {
      id: '/_auth/warehouse/inv2310/'
      path: '/warehouse/inv2310'
      fullPath: '/warehouse/inv2310'
      preLoaderRoute: typeof AuthWarehouseInv2310IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv3010/': {
      id: '/_auth/warehouse/inv3010/'
      path: '/warehouse/inv3010'
      fullPath: '/warehouse/inv3010'
      preLoaderRoute: typeof AuthWarehouseInv3010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv3020/': {
      id: '/_auth/warehouse/inv3020/'
      path: '/warehouse/inv3020'
      fullPath: '/warehouse/inv3020'
      preLoaderRoute: typeof AuthWarehouseInv3020IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv3510/': {
      id: '/_auth/warehouse/inv3510/'
      path: '/warehouse/inv3510'
      fullPath: '/warehouse/inv3510'
      preLoaderRoute: typeof AuthWarehouseInv3510IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv4010/': {
      id: '/_auth/warehouse/inv4010/'
      path: '/warehouse/inv4010'
      fullPath: '/warehouse/inv4010'
      preLoaderRoute: typeof AuthWarehouseInv4010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv4015/': {
      id: '/_auth/warehouse/inv4015/'
      path: '/warehouse/inv4015'
      fullPath: '/warehouse/inv4015'
      preLoaderRoute: typeof AuthWarehouseInv4015IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv4020/': {
      id: '/_auth/warehouse/inv4020/'
      path: '/warehouse/inv4020'
      fullPath: '/warehouse/inv4020'
      preLoaderRoute: typeof AuthWarehouseInv4020IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv4110/': {
      id: '/_auth/warehouse/inv4110/'
      path: '/warehouse/inv4110'
      fullPath: '/warehouse/inv4110'
      preLoaderRoute: typeof AuthWarehouseInv4110IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv4210/': {
      id: '/_auth/warehouse/inv4210/'
      path: '/warehouse/inv4210'
      fullPath: '/warehouse/inv4210'
      preLoaderRoute: typeof AuthWarehouseInv4210IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv4310/': {
      id: '/_auth/warehouse/inv4310/'
      path: '/warehouse/inv4310'
      fullPath: '/warehouse/inv4310'
      preLoaderRoute: typeof AuthWarehouseInv4310IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv5010/': {
      id: '/_auth/warehouse/inv5010/'
      path: '/warehouse/inv5010'
      fullPath: '/warehouse/inv5010'
      preLoaderRoute: typeof AuthWarehouseInv5010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv9010/': {
      id: '/_auth/warehouse/inv9010/'
      path: '/warehouse/inv9010'
      fullPath: '/warehouse/inv9010'
      preLoaderRoute: typeof AuthWarehouseInv9010IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv9020/': {
      id: '/_auth/warehouse/inv9020/'
      path: '/warehouse/inv9020'
      fullPath: '/warehouse/inv9020'
      preLoaderRoute: typeof AuthWarehouseInv9020IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv9110/': {
      id: '/_auth/warehouse/inv9110/'
      path: '/warehouse/inv9110'
      fullPath: '/warehouse/inv9110'
      preLoaderRoute: typeof AuthWarehouseInv9110IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv9120/': {
      id: '/_auth/warehouse/inv9120/'
      path: '/warehouse/inv9120'
      fullPath: '/warehouse/inv9120'
      preLoaderRoute: typeof AuthWarehouseInv9120IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv9210/': {
      id: '/_auth/warehouse/inv9210/'
      path: '/warehouse/inv9210'
      fullPath: '/warehouse/inv9210'
      preLoaderRoute: typeof AuthWarehouseInv9210IndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/accounting/chart-of-accounts/edit/$id': {
      id: '/_auth/accounting/chart-of-accounts/edit/$id'
      path: '/accounting/chart-of-accounts/edit/$id'
      fullPath: '/accounting/chart-of-accounts/edit/$id'
      preLoaderRoute: typeof AuthAccountingChartOfAccountsEditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/accounting/journal-entry/edit/$id': {
      id: '/_auth/accounting/journal-entry/edit/$id'
      path: '/accounting/journal-entry/edit/$id'
      fullPath: '/accounting/journal-entry/edit/$id'
      preLoaderRoute: typeof AuthAccountingJournalEntryEditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd1010/create/$wsid': {
      id: '/_auth/production/prd1010/create/$wsid'
      path: '/production/prd1010/create/$wsid'
      fullPath: '/production/prd1010/create/$wsid'
      preLoaderRoute: typeof AuthProductionPrd1010CreateWsidImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd1110/create/$wsid': {
      id: '/_auth/production/prd1110/create/$wsid'
      path: '/production/prd1110/create/$wsid'
      fullPath: '/production/prd1110/create/$wsid'
      preLoaderRoute: typeof AuthProductionPrd1110CreateWsidImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd3110/edit/$id': {
      id: '/_auth/production/prd3110/edit/$id'
      path: '/production/prd3110/edit/$id'
      fullPath: '/production/prd3110/edit/$id'
      preLoaderRoute: typeof AuthProductionPrd3110EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/wo1010/edit/$id': {
      id: '/_auth/production/wo1010/edit/$id'
      path: '/production/wo1010/edit/$id'
      fullPath: '/production/wo1010/edit/$id'
      preLoaderRoute: typeof AuthProductionWo1010EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/wo1110/edit/$id': {
      id: '/_auth/production/wo1110/edit/$id'
      path: '/production/wo1110/edit/$id'
      fullPath: '/production/wo1110/edit/$id'
      preLoaderRoute: typeof AuthProductionWo1110EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/wo3010/edit/$id': {
      id: '/_auth/production/wo3010/edit/$id'
      path: '/production/wo3010/edit/$id'
      fullPath: '/production/wo3010/edit/$id'
      preLoaderRoute: typeof AuthProductionWo3010EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/purchase/po1010/edit/$id': {
      id: '/_auth/purchase/po1010/edit/$id'
      path: '/purchase/po1010/edit/$id'
      fullPath: '/purchase/po1010/edit/$id'
      preLoaderRoute: typeof AuthPurchasePo1010EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/qc/qc8010/view/$id': {
      id: '/_auth/qc/qc8010/view/$id'
      path: '/qc/qc8010/view/$id'
      fullPath: '/qc/qc8010/view/$id'
      preLoaderRoute: typeof AuthQcQc8010ViewIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/qc/qc8110/edit/$id': {
      id: '/_auth/qc/qc8110/edit/$id'
      path: '/qc/qc8110/edit/$id'
      fullPath: '/qc/qc8110/edit/$id'
      preLoaderRoute: typeof AuthQcQc8110EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale1010/edit/$id': {
      id: '/_auth/sale/sale1010/edit/$id'
      path: '/sale/sale1010/edit/$id'
      fullPath: '/sale/sale1010/edit/$id'
      preLoaderRoute: typeof AuthSaleSale1010EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale1220/edit/$id': {
      id: '/_auth/sale/sale1220/edit/$id'
      path: '/sale/sale1220/edit/$id'
      fullPath: '/sale/sale1220/edit/$id'
      preLoaderRoute: typeof AuthSaleSale1220EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sale/sale2310/edit/$id': {
      id: '/_auth/sale/sale2310/edit/$id'
      path: '/sale/sale2310/edit/$id'
      fullPath: '/sale/sale2310/edit/$id'
      preLoaderRoute: typeof AuthSaleSale2310EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/customers/edit/$id': {
      id: '/_auth/settings/customers/edit/$id'
      path: '/settings/customers/edit/$id'
      fullPath: '/settings/customers/edit/$id'
      preLoaderRoute: typeof AuthSettingsCustomersEditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/groups/edit/$id': {
      id: '/_auth/settings/groups/edit/$id'
      path: '/settings/groups/edit/$id'
      fullPath: '/settings/groups/edit/$id'
      preLoaderRoute: typeof AuthSettingsGroupsEditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/holidays/edit/$id': {
      id: '/_auth/settings/holidays/edit/$id'
      path: '/settings/holidays/edit/$id'
      fullPath: '/settings/holidays/edit/$id'
      preLoaderRoute: typeof AuthSettingsHolidaysEditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/items/edit/$id': {
      id: '/_auth/settings/items/edit/$id'
      path: '/settings/items/edit/$id'
      fullPath: '/settings/items/edit/$id'
      preLoaderRoute: typeof AuthSettingsItemsEditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/items/view/$id': {
      id: '/_auth/settings/items/view/$id'
      path: '/settings/items/view/$id'
      fullPath: '/settings/items/view/$id'
      preLoaderRoute: typeof AuthSettingsItemsViewIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/locations/edit/$id': {
      id: '/_auth/settings/locations/edit/$id'
      path: '/settings/locations/edit/$id'
      fullPath: '/settings/locations/edit/$id'
      preLoaderRoute: typeof AuthSettingsLocationsEditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/machines/edit/$id': {
      id: '/_auth/settings/machines/edit/$id'
      path: '/settings/machines/edit/$id'
      fullPath: '/settings/machines/edit/$id'
      preLoaderRoute: typeof AuthSettingsMachinesEditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/molds/delete/$id': {
      id: '/_auth/settings/molds/delete/$id'
      path: '/settings/molds/delete/$id'
      fullPath: '/settings/molds/delete/$id'
      preLoaderRoute: typeof AuthSettingsMoldsDeleteIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/molds/edit/$id': {
      id: '/_auth/settings/molds/edit/$id'
      path: '/settings/molds/edit/$id'
      fullPath: '/settings/molds/edit/$id'
      preLoaderRoute: typeof AuthSettingsMoldsEditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/parties/edit/$id': {
      id: '/_auth/settings/parties/edit/$id'
      path: '/settings/parties/edit/$id'
      fullPath: '/settings/parties/edit/$id'
      preLoaderRoute: typeof AuthSettingsPartiesEditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/roles/edit/$id': {
      id: '/_auth/settings/roles/edit/$id'
      path: '/settings/roles/edit/$id'
      fullPath: '/settings/roles/edit/$id'
      preLoaderRoute: typeof AuthSettingsRolesEditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/running-numbers/edit/$id': {
      id: '/_auth/settings/running-numbers/edit/$id'
      path: '/settings/running-numbers/edit/$id'
      fullPath: '/settings/running-numbers/edit/$id'
      preLoaderRoute: typeof AuthSettingsRunningNumbersEditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/suppliers/edit/$id': {
      id: '/_auth/settings/suppliers/edit/$id'
      path: '/settings/suppliers/edit/$id'
      fullPath: '/settings/suppliers/edit/$id'
      preLoaderRoute: typeof AuthSettingsSuppliersEditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/users/edit/$id': {
      id: '/_auth/settings/users/edit/$id'
      path: '/settings/users/edit/$id'
      fullPath: '/settings/users/edit/$id'
      preLoaderRoute: typeof AuthSettingsUsersEditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1010/edit/$id': {
      id: '/_auth/warehouse/inv1010/edit/$id'
      path: '/warehouse/inv1010/edit/$id'
      fullPath: '/warehouse/inv1010/edit/$id'
      preLoaderRoute: typeof AuthWarehouseInv1010EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1015/edit/$id': {
      id: '/_auth/warehouse/inv1015/edit/$id'
      path: '/warehouse/inv1015/edit/$id'
      fullPath: '/warehouse/inv1015/edit/$id'
      preLoaderRoute: typeof AuthWarehouseInv1015EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1140/edit/$id': {
      id: '/_auth/warehouse/inv1140/edit/$id'
      path: '/warehouse/inv1140/edit/$id'
      fullPath: '/warehouse/inv1140/edit/$id'
      preLoaderRoute: typeof AuthWarehouseInv1140EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1210/edit/$id': {
      id: '/_auth/warehouse/inv1210/edit/$id'
      path: '/warehouse/inv1210/edit/$id'
      fullPath: '/warehouse/inv1210/edit/$id'
      preLoaderRoute: typeof AuthWarehouseInv1210EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv1310/edit/$id': {
      id: '/_auth/warehouse/inv1310/edit/$id'
      path: '/warehouse/inv1310/edit/$id'
      fullPath: '/warehouse/inv1310/edit/$id'
      preLoaderRoute: typeof AuthWarehouseInv1310EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv2010/edit/$id': {
      id: '/_auth/warehouse/inv2010/edit/$id'
      path: '/warehouse/inv2010/edit/$id'
      fullPath: '/warehouse/inv2010/edit/$id'
      preLoaderRoute: typeof AuthWarehouseInv2010EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv2210/edit/$id': {
      id: '/_auth/warehouse/inv2210/edit/$id'
      path: '/warehouse/inv2210/edit/$id'
      fullPath: '/warehouse/inv2210/edit/$id'
      preLoaderRoute: typeof AuthWarehouseInv2210EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv2215/edit/$id': {
      id: '/_auth/warehouse/inv2215/edit/$id'
      path: '/warehouse/inv2215/edit/$id'
      fullPath: '/warehouse/inv2215/edit/$id'
      preLoaderRoute: typeof AuthWarehouseInv2215EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv2310/edit/$id': {
      id: '/_auth/warehouse/inv2310/edit/$id'
      path: '/warehouse/inv2310/edit/$id'
      fullPath: '/warehouse/inv2310/edit/$id'
      preLoaderRoute: typeof AuthWarehouseInv2310EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv3010/edit/$id': {
      id: '/_auth/warehouse/inv3010/edit/$id'
      path: '/warehouse/inv3010/edit/$id'
      fullPath: '/warehouse/inv3010/edit/$id'
      preLoaderRoute: typeof AuthWarehouseInv3010EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv3020/edit/$id': {
      id: '/_auth/warehouse/inv3020/edit/$id'
      path: '/warehouse/inv3020/edit/$id'
      fullPath: '/warehouse/inv3020/edit/$id'
      preLoaderRoute: typeof AuthWarehouseInv3020EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv3510/$id_/completion': {
      id: '/_auth/warehouse/inv3510/$id_/completion'
      path: '/warehouse/inv3510/$id/completion'
      fullPath: '/warehouse/inv3510/$id/completion'
      preLoaderRoute: typeof AuthWarehouseInv3510IdCompletionImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv3510/$id_/progress': {
      id: '/_auth/warehouse/inv3510/$id_/progress'
      path: '/warehouse/inv3510/$id/progress'
      fullPath: '/warehouse/inv3510/$id/progress'
      preLoaderRoute: typeof AuthWarehouseInv3510IdProgressImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv3510/$id_/variances': {
      id: '/_auth/warehouse/inv3510/$id_/variances'
      path: '/warehouse/inv3510/$id/variances'
      fullPath: '/warehouse/inv3510/$id/variances'
      preLoaderRoute: typeof AuthWarehouseInv3510IdVariancesImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv3510/$id_/zones': {
      id: '/_auth/warehouse/inv3510/$id_/zones'
      path: '/warehouse/inv3510/$id/zones'
      fullPath: '/warehouse/inv3510/$id/zones'
      preLoaderRoute: typeof AuthWarehouseInv3510IdZonesImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv3510/edit/$id': {
      id: '/_auth/warehouse/inv3510/edit/$id'
      path: '/warehouse/inv3510/edit/$id'
      fullPath: '/warehouse/inv3510/edit/$id'
      preLoaderRoute: typeof AuthWarehouseInv3510EditIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv4310/$id_/override-items': {
      id: '/_auth/warehouse/inv4310/$id_/override-items'
      path: '/warehouse/inv4310/$id/override-items'
      fullPath: '/warehouse/inv4310/$id/override-items'
      preLoaderRoute: typeof AuthWarehouseInv4310IdOverrideItemsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/warehouse/inv4310/adjust/$id': {
      id: '/_auth/warehouse/inv4310/adjust/$id'
      path: '/warehouse/inv4310/adjust/$id'
      fullPath: '/warehouse/inv4310/adjust/$id'
      preLoaderRoute: typeof AuthWarehouseInv4310AdjustIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/items/$itemId/': {
      id: '/_auth/settings/items/$itemId/'
      path: '/settings/items/$itemId'
      fullPath: '/settings/items/$itemId'
      preLoaderRoute: typeof AuthSettingsItemsItemIdIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd1010/edit/$wsid/$id': {
      id: '/_auth/production/prd1010/edit/$wsid/$id'
      path: '/production/prd1010/edit/$wsid/$id'
      fullPath: '/production/prd1010/edit/$wsid/$id'
      preLoaderRoute: typeof AuthProductionPrd1010EditWsidIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/production/prd1110/edit/$wsid/$id': {
      id: '/_auth/production/prd1110/edit/$wsid/$id'
      path: '/production/prd1110/edit/$wsid/$id'
      fullPath: '/production/prd1110/edit/$wsid/$id'
      preLoaderRoute: typeof AuthProductionPrd1110EditWsidIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/purchase/tracking/receive/$id/$itemId': {
      id: '/_auth/purchase/tracking/receive/$id/$itemId'
      path: '/purchase/tracking/receive/$id/$itemId'
      fullPath: '/purchase/tracking/receive/$id/$itemId'
      preLoaderRoute: typeof AuthPurchaseTrackingReceiveIdItemIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/holidays/edit/$id/delete': {
      id: '/_auth/settings/holidays/edit/$id/delete'
      path: '/delete'
      fullPath: '/settings/holidays/edit/$id/delete'
      preLoaderRoute: typeof AuthSettingsHolidaysEditIdDeleteImport
      parentRoute: typeof AuthSettingsHolidaysEditIdImport
    }
    '/_auth/settings/items/$itemId/boms/$id': {
      id: '/_auth/settings/items/$itemId/boms/$id'
      path: '/settings/items/$itemId/boms/$id'
      fullPath: '/settings/items/$itemId/boms/$id'
      preLoaderRoute: typeof AuthSettingsItemsItemIdBomsIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/items/$itemId/boms/create': {
      id: '/_auth/settings/items/$itemId/boms/create'
      path: '/settings/items/$itemId/boms/create'
      fullPath: '/settings/items/$itemId/boms/create'
      preLoaderRoute: typeof AuthSettingsItemsItemIdBomsCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/machines/edit/$id/delete': {
      id: '/_auth/settings/machines/edit/$id/delete'
      path: '/delete'
      fullPath: '/settings/machines/edit/$id/delete'
      preLoaderRoute: typeof AuthSettingsMachinesEditIdDeleteImport
      parentRoute: typeof AuthSettingsMachinesEditIdImport
    }
    '/_auth/settings/roles/edit/$id/delete': {
      id: '/_auth/settings/roles/edit/$id/delete'
      path: '/delete'
      fullPath: '/settings/roles/edit/$id/delete'
      preLoaderRoute: typeof AuthSettingsRolesEditIdDeleteImport
      parentRoute: typeof AuthSettingsRolesEditIdImport
    }
    '/_auth/production/wo1210/index/hold/$id': {
      id: '/_auth/production/wo1210/index/hold/$id'
      path: '/production/wo1210/index/hold/$id'
      fullPath: '/production/wo1210/index/hold/$id'
      preLoaderRoute: typeof AuthProductionWo1210IndexHoldIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/qc/qc1010/index/hold/$id': {
      id: '/_auth/qc/qc1010/index/hold/$id'
      path: '/qc/qc1010/index/hold/$id'
      fullPath: '/qc/qc1010/index/hold/$id'
      preLoaderRoute: typeof AuthQcQc1010IndexHoldIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/qc/qc8030/index/result/$id': {
      id: '/_auth/qc/qc8030/index/result/$id'
      path: '/qc/qc8030/index/result/$id'
      fullPath: '/qc/qc8030/index/result/$id'
      preLoaderRoute: typeof AuthQcQc8030IndexResultIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/customers/index/delete/$id': {
      id: '/_auth/settings/customers/index/delete/$id'
      path: '/settings/customers/index/delete/$id'
      fullPath: '/settings/customers/index/delete/$id'
      preLoaderRoute: typeof AuthSettingsCustomersIndexDeleteIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/locations/index/delete/$id': {
      id: '/_auth/settings/locations/index/delete/$id'
      path: '/settings/locations/index/delete/$id'
      fullPath: '/settings/locations/index/delete/$id'
      preLoaderRoute: typeof AuthSettingsLocationsIndexDeleteIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/parties/index/delete/$id': {
      id: '/_auth/settings/parties/index/delete/$id'
      path: '/settings/parties/index/delete/$id'
      fullPath: '/settings/parties/index/delete/$id'
      preLoaderRoute: typeof AuthSettingsPartiesIndexDeleteIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/running-numbers/index/delete/$id': {
      id: '/_auth/settings/running-numbers/index/delete/$id'
      path: '/settings/running-numbers/index/delete/$id'
      fullPath: '/settings/running-numbers/index/delete/$id'
      preLoaderRoute: typeof AuthSettingsRunningNumbersIndexDeleteIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/suppliers/index/delete/$id': {
      id: '/_auth/settings/suppliers/index/delete/$id'
      path: '/settings/suppliers/index/delete/$id'
      fullPath: '/settings/suppliers/index/delete/$id'
      preLoaderRoute: typeof AuthSettingsSuppliersIndexDeleteIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/users/index/delete/$id': {
      id: '/_auth/settings/users/index/delete/$id'
      path: '/settings/users/index/delete/$id'
      fullPath: '/settings/users/index/delete/$id'
      preLoaderRoute: typeof AuthSettingsUsersIndexDeleteIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings/items/$itemId/boms/edit/$id': {
      id: '/_auth/settings/items/$itemId/boms/edit/$id'
      path: '/settings/items/$itemId/boms/edit/$id'
      fullPath: '/settings/items/$itemId/boms/edit/$id'
      preLoaderRoute: typeof AuthSettingsItemsItemIdBomsEditIdImport
      parentRoute: typeof AuthImport
    }
  }
}

// Create and export the route tree

interface AuthSettingsHolidaysEditIdRouteChildren {
  AuthSettingsHolidaysEditIdDeleteRoute: typeof AuthSettingsHolidaysEditIdDeleteRoute
}

const AuthSettingsHolidaysEditIdRouteChildren: AuthSettingsHolidaysEditIdRouteChildren =
  {
    AuthSettingsHolidaysEditIdDeleteRoute:
      AuthSettingsHolidaysEditIdDeleteRoute,
  }

const AuthSettingsHolidaysEditIdRouteWithChildren =
  AuthSettingsHolidaysEditIdRoute._addFileChildren(
    AuthSettingsHolidaysEditIdRouteChildren,
  )

interface AuthSettingsMachinesEditIdRouteChildren {
  AuthSettingsMachinesEditIdDeleteRoute: typeof AuthSettingsMachinesEditIdDeleteRoute
}

const AuthSettingsMachinesEditIdRouteChildren: AuthSettingsMachinesEditIdRouteChildren =
  {
    AuthSettingsMachinesEditIdDeleteRoute:
      AuthSettingsMachinesEditIdDeleteRoute,
  }

const AuthSettingsMachinesEditIdRouteWithChildren =
  AuthSettingsMachinesEditIdRoute._addFileChildren(
    AuthSettingsMachinesEditIdRouteChildren,
  )

interface AuthSettingsRolesEditIdRouteChildren {
  AuthSettingsRolesEditIdDeleteRoute: typeof AuthSettingsRolesEditIdDeleteRoute
}

const AuthSettingsRolesEditIdRouteChildren: AuthSettingsRolesEditIdRouteChildren =
  {
    AuthSettingsRolesEditIdDeleteRoute: AuthSettingsRolesEditIdDeleteRoute,
  }

const AuthSettingsRolesEditIdRouteWithChildren =
  AuthSettingsRolesEditIdRoute._addFileChildren(
    AuthSettingsRolesEditIdRouteChildren,
  )

interface AuthRouteChildren {
  AuthChangePasswordRoute: typeof AuthChangePasswordRoute
  AuthHomeRoute: typeof AuthHomeRoute
  AuthNoPermissionRoute: typeof AuthNoPermissionRoute
  AuthTestrunIndexRoute: typeof AuthTestrunIndexRoute
  AuthUserMessagesIndexRoute: typeof AuthUserMessagesIndexRoute
  AuthAccountingChartOfAccountsCreateRoute: typeof AuthAccountingChartOfAccountsCreateRoute
  AuthAccountingFiscalYearIdRoute: typeof AuthAccountingFiscalYearIdRoute
  AuthAccountingFiscalYearCreateRoute: typeof AuthAccountingFiscalYearCreateRoute
  AuthAccountingJournalEntryIdRoute: typeof AuthAccountingJournalEntryIdRoute
  AuthAccountingJournalEntryCreateRoute: typeof AuthAccountingJournalEntryCreateRoute
  AuthAccountingReportsGeneralLedgerRoute: typeof AuthAccountingReportsGeneralLedgerRoute
  AuthAccountingReportsTrialBalanceRoute: typeof AuthAccountingReportsTrialBalanceRoute
  AuthProductionPrd1210IdRoute: typeof AuthProductionPrd1210IdRoute
  AuthProductionPrd3010IdRoute: typeof AuthProductionPrd3010IdRoute
  AuthProductionPrd3110IdRoute: typeof AuthProductionPrd3110IdRoute
  AuthProductionPrd4010IdRoute: typeof AuthProductionPrd4010IdRoute
  AuthProductionWo1010IdRoute: typeof AuthProductionWo1010IdRoute
  AuthProductionWo1010CreateRoute: typeof AuthProductionWo1010CreateRoute
  AuthProductionWo1110IdRoute: typeof AuthProductionWo1110IdRoute
  AuthProductionWo3010IdRoute: typeof AuthProductionWo3010IdRoute
  AuthProductionWo3010CreateRoute: typeof AuthProductionWo3010CreateRoute
  AuthPurchasePo1010IdRoute: typeof AuthPurchasePo1010IdRoute
  AuthPurchasePo1010CreateRoute: typeof AuthPurchasePo1010CreateRoute
  AuthQcQc8010IdRoute: typeof AuthQcQc8010IdRoute
  AuthQcQc8010CreateRoute: typeof AuthQcQc8010CreateRoute
  AuthQcQc8015IdRoute: typeof AuthQcQc8015IdRoute
  AuthQcQc8110IdRoute: typeof AuthQcQc8110IdRoute
  AuthQcQc8110CreateRoute: typeof AuthQcQc8110CreateRoute
  AuthSaleSale1010IdRoute: typeof AuthSaleSale1010IdRoute
  AuthSaleSale1010CreateRoute: typeof AuthSaleSale1010CreateRoute
  AuthSaleSale1220IdRoute: typeof AuthSaleSale1220IdRoute
  AuthSaleSale1220CreateRoute: typeof AuthSaleSale1220CreateRoute
  AuthSaleSale1230IdRoute: typeof AuthSaleSale1230IdRoute
  AuthSaleSale2310IdRoute: typeof AuthSaleSale2310IdRoute
  AuthSaleSale2310CreateRoute: typeof AuthSaleSale2310CreateRoute
  AuthSettingsCustomersIdRoute: typeof AuthSettingsCustomersIdRoute
  AuthSettingsCustomersCreateRoute: typeof AuthSettingsCustomersCreateRoute
  AuthSettingsGroupsIdRoute: typeof AuthSettingsGroupsIdRoute
  AuthSettingsGroupsCreateRoute: typeof AuthSettingsGroupsCreateRoute
  AuthSettingsHolidaysIdRoute: typeof AuthSettingsHolidaysIdRoute
  AuthSettingsHolidaysCreateRoute: typeof AuthSettingsHolidaysCreateRoute
  AuthSettingsItemsCreateRoute: typeof AuthSettingsItemsCreateRoute
  AuthSettingsLocationsIdRoute: typeof AuthSettingsLocationsIdRoute
  AuthSettingsLocationsCreateRoute: typeof AuthSettingsLocationsCreateRoute
  AuthSettingsMachinesIdRoute: typeof AuthSettingsMachinesIdRoute
  AuthSettingsMachinesCreateRoute: typeof AuthSettingsMachinesCreateRoute
  AuthSettingsMoldsIdRoute: typeof AuthSettingsMoldsIdRoute
  AuthSettingsMoldsCreateRoute: typeof AuthSettingsMoldsCreateRoute
  AuthSettingsPartiesIdRoute: typeof AuthSettingsPartiesIdRoute
  AuthSettingsPartiesCreateRoute: typeof AuthSettingsPartiesCreateRoute
  AuthSettingsRolesIdRoute: typeof AuthSettingsRolesIdRoute
  AuthSettingsRolesCreateRoute: typeof AuthSettingsRolesCreateRoute
  AuthSettingsRunningNumbersIdRoute: typeof AuthSettingsRunningNumbersIdRoute
  AuthSettingsRunningNumbersCreateRoute: typeof AuthSettingsRunningNumbersCreateRoute
  AuthSettingsRunningNumbersCreateByYearRoute: typeof AuthSettingsRunningNumbersCreateByYearRoute
  AuthSettingsSuppliersIdRoute: typeof AuthSettingsSuppliersIdRoute
  AuthSettingsSuppliersCreateRoute: typeof AuthSettingsSuppliersCreateRoute
  AuthSettingsUsersIdRoute: typeof AuthSettingsUsersIdRoute
  AuthSettingsUsersCreateRoute: typeof AuthSettingsUsersCreateRoute
  AuthWarehouseInv1010IdRoute: typeof AuthWarehouseInv1010IdRoute
  AuthWarehouseInv1010CreateRoute: typeof AuthWarehouseInv1010CreateRoute
  AuthWarehouseInv1015IdRoute: typeof AuthWarehouseInv1015IdRoute
  AuthWarehouseInv1015CreateRoute: typeof AuthWarehouseInv1015CreateRoute
  AuthWarehouseInv1110IdRoute: typeof AuthWarehouseInv1110IdRoute
  AuthWarehouseInv1120IdRoute: typeof AuthWarehouseInv1120IdRoute
  AuthWarehouseInv1140IdRoute: typeof AuthWarehouseInv1140IdRoute
  AuthWarehouseInv1140CreateRoute: typeof AuthWarehouseInv1140CreateRoute
  AuthWarehouseInv1210IdRoute: typeof AuthWarehouseInv1210IdRoute
  AuthWarehouseInv1210CreateRoute: typeof AuthWarehouseInv1210CreateRoute
  AuthWarehouseInv1310IdRoute: typeof AuthWarehouseInv1310IdRoute
  AuthWarehouseInv1310CreateRoute: typeof AuthWarehouseInv1310CreateRoute
  AuthWarehouseInv2010IdRoute: typeof AuthWarehouseInv2010IdRoute
  AuthWarehouseInv2010CreateRoute: typeof AuthWarehouseInv2010CreateRoute
  AuthWarehouseInv2210IdRoute: typeof AuthWarehouseInv2210IdRoute
  AuthWarehouseInv2210CreateRoute: typeof AuthWarehouseInv2210CreateRoute
  AuthWarehouseInv2215IdRoute: typeof AuthWarehouseInv2215IdRoute
  AuthWarehouseInv2215CreateRoute: typeof AuthWarehouseInv2215CreateRoute
  AuthWarehouseInv2310IdRoute: typeof AuthWarehouseInv2310IdRoute
  AuthWarehouseInv2310CreateRoute: typeof AuthWarehouseInv2310CreateRoute
  AuthWarehouseInv3010IdRoute: typeof AuthWarehouseInv3010IdRoute
  AuthWarehouseInv3010CreateRoute: typeof AuthWarehouseInv3010CreateRoute
  AuthWarehouseInv3020IdRoute: typeof AuthWarehouseInv3020IdRoute
  AuthWarehouseInv3020CreateRoute: typeof AuthWarehouseInv3020CreateRoute
  AuthWarehouseInv3510IdRoute: typeof AuthWarehouseInv3510IdRoute
  AuthWarehouseInv3510CreateRoute: typeof AuthWarehouseInv3510CreateRoute
  AuthWarehouseInv4310IdRoute: typeof AuthWarehouseInv4310IdRoute
  AuthWarehouseInv4310CreateRoute: typeof AuthWarehouseInv4310CreateRoute
  AuthWarehouseInv5010IdRoute: typeof AuthWarehouseInv5010IdRoute
  AuthWarehouseInv5010CreateRoute: typeof AuthWarehouseInv5010CreateRoute
  AuthAccountingChartOfAccountsIndexRoute: typeof AuthAccountingChartOfAccountsIndexRoute
  AuthAccountingFiscalYearIndexRoute: typeof AuthAccountingFiscalYearIndexRoute
  AuthAccountingJournalEntryIndexRoute: typeof AuthAccountingJournalEntryIndexRoute
  AuthProductionPrd1010IndexRoute: typeof AuthProductionPrd1010IndexRoute
  AuthProductionPrd1011IndexRoute: typeof AuthProductionPrd1011IndexRoute
  AuthProductionPrd1015IndexRoute: typeof AuthProductionPrd1015IndexRoute
  AuthProductionPrd1110IndexRoute: typeof AuthProductionPrd1110IndexRoute
  AuthProductionPrd1210IndexRoute: typeof AuthProductionPrd1210IndexRoute
  AuthProductionPrd2010IndexRoute: typeof AuthProductionPrd2010IndexRoute
  AuthProductionPrd3010IndexRoute: typeof AuthProductionPrd3010IndexRoute
  AuthProductionPrd3110IndexRoute: typeof AuthProductionPrd3110IndexRoute
  AuthProductionPrd4010IndexRoute: typeof AuthProductionPrd4010IndexRoute
  AuthProductionPrd4020IndexRoute: typeof AuthProductionPrd4020IndexRoute
  AuthProductionPrd4030IndexRoute: typeof AuthProductionPrd4030IndexRoute
  AuthProductionWo1010IndexRoute: typeof AuthProductionWo1010IndexRoute
  AuthProductionWo1110IndexRoute: typeof AuthProductionWo1110IndexRoute
  AuthProductionWo1115IndexRoute: typeof AuthProductionWo1115IndexRoute
  AuthProductionWo1210IndexRoute: typeof AuthProductionWo1210IndexRoute
  AuthProductionWo3010IndexRoute: typeof AuthProductionWo3010IndexRoute
  AuthProductionWo9010IndexRoute: typeof AuthProductionWo9010IndexRoute
  AuthPurchaseBplusSyncIndexRoute: typeof AuthPurchaseBplusSyncIndexRoute
  AuthPurchasePo1010IndexRoute: typeof AuthPurchasePo1010IndexRoute
  AuthPurchasePo9010IndexRoute: typeof AuthPurchasePo9010IndexRoute
  AuthPurchasePo9020IndexRoute: typeof AuthPurchasePo9020IndexRoute
  AuthPurchasePo9030IndexRoute: typeof AuthPurchasePo9030IndexRoute
  AuthPurchaseProblemIndexRoute: typeof AuthPurchaseProblemIndexRoute
  AuthPurchaseTrackingIndexRoute: typeof AuthPurchaseTrackingIndexRoute
  AuthQcQc1010IndexRoute: typeof AuthQcQc1010IndexRoute
  AuthQcQc8010IndexRoute: typeof AuthQcQc8010IndexRoute
  AuthQcQc8015IndexRoute: typeof AuthQcQc8015IndexRoute
  AuthQcQc8030IndexRoute: typeof AuthQcQc8030IndexRoute
  AuthQcQc8110IndexRoute: typeof AuthQcQc8110IndexRoute
  AuthQcQc9010IndexRoute: typeof AuthQcQc9010IndexRoute
  AuthSaleSale1010IndexRoute: typeof AuthSaleSale1010IndexRoute
  AuthSaleSale1020IndexRoute: typeof AuthSaleSale1020IndexRoute
  AuthSaleSale1030IndexRoute: typeof AuthSaleSale1030IndexRoute
  AuthSaleSale1210IndexRoute: typeof AuthSaleSale1210IndexRoute
  AuthSaleSale1220IndexRoute: typeof AuthSaleSale1220IndexRoute
  AuthSaleSale1230IndexRoute: typeof AuthSaleSale1230IndexRoute
  AuthSaleSale2310IndexRoute: typeof AuthSaleSale2310IndexRoute
  AuthSettingsCustomersIndexRoute: typeof AuthSettingsCustomersIndexRoute
  AuthSettingsGroupsIndexRoute: typeof AuthSettingsGroupsIndexRoute
  AuthSettingsHolidaysIndexRoute: typeof AuthSettingsHolidaysIndexRoute
  AuthSettingsItemsIndexRoute: typeof AuthSettingsItemsIndexRoute
  AuthSettingsLocationsIndexRoute: typeof AuthSettingsLocationsIndexRoute
  AuthSettingsMachinesIndexRoute: typeof AuthSettingsMachinesIndexRoute
  AuthSettingsMoldsIndexRoute: typeof AuthSettingsMoldsIndexRoute
  AuthSettingsPartiesIndexRoute: typeof AuthSettingsPartiesIndexRoute
  AuthSettingsRolesIndexRoute: typeof AuthSettingsRolesIndexRoute
  AuthSettingsRunningNumbersIndexRoute: typeof AuthSettingsRunningNumbersIndexRoute
  AuthSettingsScreenCaptureIndexRoute: typeof AuthSettingsScreenCaptureIndexRoute
  AuthSettingsSuppliersIndexRoute: typeof AuthSettingsSuppliersIndexRoute
  AuthSettingsUsersIndexRoute: typeof AuthSettingsUsersIndexRoute
  AuthWarehouseDashboardIndexRoute: typeof AuthWarehouseDashboardIndexRoute
  AuthWarehouseInv1010IndexRoute: typeof AuthWarehouseInv1010IndexRoute
  AuthWarehouseInv1015IndexRoute: typeof AuthWarehouseInv1015IndexRoute
  AuthWarehouseInv1110IndexRoute: typeof AuthWarehouseInv1110IndexRoute
  AuthWarehouseInv1120IndexRoute: typeof AuthWarehouseInv1120IndexRoute
  AuthWarehouseInv1140IndexRoute: typeof AuthWarehouseInv1140IndexRoute
  AuthWarehouseInv1210IndexRoute: typeof AuthWarehouseInv1210IndexRoute
  AuthWarehouseInv1310IndexRoute: typeof AuthWarehouseInv1310IndexRoute
  AuthWarehouseInv2010IndexRoute: typeof AuthWarehouseInv2010IndexRoute
  AuthWarehouseInv2210IndexRoute: typeof AuthWarehouseInv2210IndexRoute
  AuthWarehouseInv2215IndexRoute: typeof AuthWarehouseInv2215IndexRoute
  AuthWarehouseInv2310IndexRoute: typeof AuthWarehouseInv2310IndexRoute
  AuthWarehouseInv3010IndexRoute: typeof AuthWarehouseInv3010IndexRoute
  AuthWarehouseInv3020IndexRoute: typeof AuthWarehouseInv3020IndexRoute
  AuthWarehouseInv3510IndexRoute: typeof AuthWarehouseInv3510IndexRoute
  AuthWarehouseInv4010IndexRoute: typeof AuthWarehouseInv4010IndexRoute
  AuthWarehouseInv4015IndexRoute: typeof AuthWarehouseInv4015IndexRoute
  AuthWarehouseInv4020IndexRoute: typeof AuthWarehouseInv4020IndexRoute
  AuthWarehouseInv4110IndexRoute: typeof AuthWarehouseInv4110IndexRoute
  AuthWarehouseInv4210IndexRoute: typeof AuthWarehouseInv4210IndexRoute
  AuthWarehouseInv4310IndexRoute: typeof AuthWarehouseInv4310IndexRoute
  AuthWarehouseInv5010IndexRoute: typeof AuthWarehouseInv5010IndexRoute
  AuthWarehouseInv9010IndexRoute: typeof AuthWarehouseInv9010IndexRoute
  AuthWarehouseInv9020IndexRoute: typeof AuthWarehouseInv9020IndexRoute
  AuthWarehouseInv9110IndexRoute: typeof AuthWarehouseInv9110IndexRoute
  AuthWarehouseInv9120IndexRoute: typeof AuthWarehouseInv9120IndexRoute
  AuthWarehouseInv9210IndexRoute: typeof AuthWarehouseInv9210IndexRoute
  AuthAccountingChartOfAccountsEditIdRoute: typeof AuthAccountingChartOfAccountsEditIdRoute
  AuthAccountingJournalEntryEditIdRoute: typeof AuthAccountingJournalEntryEditIdRoute
  AuthProductionPrd1010CreateWsidRoute: typeof AuthProductionPrd1010CreateWsidRoute
  AuthProductionPrd1110CreateWsidRoute: typeof AuthProductionPrd1110CreateWsidRoute
  AuthProductionPrd3110EditIdRoute: typeof AuthProductionPrd3110EditIdRoute
  AuthProductionWo1010EditIdRoute: typeof AuthProductionWo1010EditIdRoute
  AuthProductionWo1110EditIdRoute: typeof AuthProductionWo1110EditIdRoute
  AuthProductionWo3010EditIdRoute: typeof AuthProductionWo3010EditIdRoute
  AuthPurchasePo1010EditIdRoute: typeof AuthPurchasePo1010EditIdRoute
  AuthQcQc8010ViewIdRoute: typeof AuthQcQc8010ViewIdRoute
  AuthQcQc8110EditIdRoute: typeof AuthQcQc8110EditIdRoute
  AuthSaleSale1010EditIdRoute: typeof AuthSaleSale1010EditIdRoute
  AuthSaleSale1220EditIdRoute: typeof AuthSaleSale1220EditIdRoute
  AuthSaleSale2310EditIdRoute: typeof AuthSaleSale2310EditIdRoute
  AuthSettingsCustomersEditIdRoute: typeof AuthSettingsCustomersEditIdRoute
  AuthSettingsGroupsEditIdRoute: typeof AuthSettingsGroupsEditIdRoute
  AuthSettingsHolidaysEditIdRoute: typeof AuthSettingsHolidaysEditIdRouteWithChildren
  AuthSettingsItemsEditIdRoute: typeof AuthSettingsItemsEditIdRoute
  AuthSettingsItemsViewIdRoute: typeof AuthSettingsItemsViewIdRoute
  AuthSettingsLocationsEditIdRoute: typeof AuthSettingsLocationsEditIdRoute
  AuthSettingsMachinesEditIdRoute: typeof AuthSettingsMachinesEditIdRouteWithChildren
  AuthSettingsMoldsDeleteIdRoute: typeof AuthSettingsMoldsDeleteIdRoute
  AuthSettingsMoldsEditIdRoute: typeof AuthSettingsMoldsEditIdRoute
  AuthSettingsPartiesEditIdRoute: typeof AuthSettingsPartiesEditIdRoute
  AuthSettingsRolesEditIdRoute: typeof AuthSettingsRolesEditIdRouteWithChildren
  AuthSettingsRunningNumbersEditIdRoute: typeof AuthSettingsRunningNumbersEditIdRoute
  AuthSettingsSuppliersEditIdRoute: typeof AuthSettingsSuppliersEditIdRoute
  AuthSettingsUsersEditIdRoute: typeof AuthSettingsUsersEditIdRoute
  AuthWarehouseInv1010EditIdRoute: typeof AuthWarehouseInv1010EditIdRoute
  AuthWarehouseInv1015EditIdRoute: typeof AuthWarehouseInv1015EditIdRoute
  AuthWarehouseInv1140EditIdRoute: typeof AuthWarehouseInv1140EditIdRoute
  AuthWarehouseInv1210EditIdRoute: typeof AuthWarehouseInv1210EditIdRoute
  AuthWarehouseInv1310EditIdRoute: typeof AuthWarehouseInv1310EditIdRoute
  AuthWarehouseInv2010EditIdRoute: typeof AuthWarehouseInv2010EditIdRoute
  AuthWarehouseInv2210EditIdRoute: typeof AuthWarehouseInv2210EditIdRoute
  AuthWarehouseInv2215EditIdRoute: typeof AuthWarehouseInv2215EditIdRoute
  AuthWarehouseInv2310EditIdRoute: typeof AuthWarehouseInv2310EditIdRoute
  AuthWarehouseInv3010EditIdRoute: typeof AuthWarehouseInv3010EditIdRoute
  AuthWarehouseInv3020EditIdRoute: typeof AuthWarehouseInv3020EditIdRoute
  AuthWarehouseInv3510IdCompletionRoute: typeof AuthWarehouseInv3510IdCompletionRoute
  AuthWarehouseInv3510IdProgressRoute: typeof AuthWarehouseInv3510IdProgressRoute
  AuthWarehouseInv3510IdVariancesRoute: typeof AuthWarehouseInv3510IdVariancesRoute
  AuthWarehouseInv3510IdZonesRoute: typeof AuthWarehouseInv3510IdZonesRoute
  AuthWarehouseInv3510EditIdRoute: typeof AuthWarehouseInv3510EditIdRoute
  AuthWarehouseInv4310IdOverrideItemsRoute: typeof AuthWarehouseInv4310IdOverrideItemsRoute
  AuthWarehouseInv4310AdjustIdRoute: typeof AuthWarehouseInv4310AdjustIdRoute
  AuthSettingsItemsItemIdIndexRoute: typeof AuthSettingsItemsItemIdIndexRoute
  AuthProductionPrd1010EditWsidIdRoute: typeof AuthProductionPrd1010EditWsidIdRoute
  AuthProductionPrd1110EditWsidIdRoute: typeof AuthProductionPrd1110EditWsidIdRoute
  AuthPurchaseTrackingReceiveIdItemIdRoute: typeof AuthPurchaseTrackingReceiveIdItemIdRoute
  AuthSettingsItemsItemIdBomsIdRoute: typeof AuthSettingsItemsItemIdBomsIdRoute
  AuthSettingsItemsItemIdBomsCreateRoute: typeof AuthSettingsItemsItemIdBomsCreateRoute
  AuthProductionWo1210IndexHoldIdRoute: typeof AuthProductionWo1210IndexHoldIdRoute
  AuthQcQc1010IndexHoldIdRoute: typeof AuthQcQc1010IndexHoldIdRoute
  AuthQcQc8030IndexResultIdRoute: typeof AuthQcQc8030IndexResultIdRoute
  AuthSettingsCustomersIndexDeleteIdRoute: typeof AuthSettingsCustomersIndexDeleteIdRoute
  AuthSettingsLocationsIndexDeleteIdRoute: typeof AuthSettingsLocationsIndexDeleteIdRoute
  AuthSettingsPartiesIndexDeleteIdRoute: typeof AuthSettingsPartiesIndexDeleteIdRoute
  AuthSettingsRunningNumbersIndexDeleteIdRoute: typeof AuthSettingsRunningNumbersIndexDeleteIdRoute
  AuthSettingsSuppliersIndexDeleteIdRoute: typeof AuthSettingsSuppliersIndexDeleteIdRoute
  AuthSettingsUsersIndexDeleteIdRoute: typeof AuthSettingsUsersIndexDeleteIdRoute
  AuthSettingsItemsItemIdBomsEditIdRoute: typeof AuthSettingsItemsItemIdBomsEditIdRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthChangePasswordRoute: AuthChangePasswordRoute,
  AuthHomeRoute: AuthHomeRoute,
  AuthNoPermissionRoute: AuthNoPermissionRoute,
  AuthTestrunIndexRoute: AuthTestrunIndexRoute,
  AuthUserMessagesIndexRoute: AuthUserMessagesIndexRoute,
  AuthAccountingChartOfAccountsCreateRoute:
    AuthAccountingChartOfAccountsCreateRoute,
  AuthAccountingFiscalYearIdRoute: AuthAccountingFiscalYearIdRoute,
  AuthAccountingFiscalYearCreateRoute: AuthAccountingFiscalYearCreateRoute,
  AuthAccountingJournalEntryIdRoute: AuthAccountingJournalEntryIdRoute,
  AuthAccountingJournalEntryCreateRoute: AuthAccountingJournalEntryCreateRoute,
  AuthAccountingReportsGeneralLedgerRoute:
    AuthAccountingReportsGeneralLedgerRoute,
  AuthAccountingReportsTrialBalanceRoute:
    AuthAccountingReportsTrialBalanceRoute,
  AuthProductionPrd1210IdRoute: AuthProductionPrd1210IdRoute,
  AuthProductionPrd3010IdRoute: AuthProductionPrd3010IdRoute,
  AuthProductionPrd3110IdRoute: AuthProductionPrd3110IdRoute,
  AuthProductionPrd4010IdRoute: AuthProductionPrd4010IdRoute,
  AuthProductionWo1010IdRoute: AuthProductionWo1010IdRoute,
  AuthProductionWo1010CreateRoute: AuthProductionWo1010CreateRoute,
  AuthProductionWo1110IdRoute: AuthProductionWo1110IdRoute,
  AuthProductionWo3010IdRoute: AuthProductionWo3010IdRoute,
  AuthProductionWo3010CreateRoute: AuthProductionWo3010CreateRoute,
  AuthPurchasePo1010IdRoute: AuthPurchasePo1010IdRoute,
  AuthPurchasePo1010CreateRoute: AuthPurchasePo1010CreateRoute,
  AuthQcQc8010IdRoute: AuthQcQc8010IdRoute,
  AuthQcQc8010CreateRoute: AuthQcQc8010CreateRoute,
  AuthQcQc8015IdRoute: AuthQcQc8015IdRoute,
  AuthQcQc8110IdRoute: AuthQcQc8110IdRoute,
  AuthQcQc8110CreateRoute: AuthQcQc8110CreateRoute,
  AuthSaleSale1010IdRoute: AuthSaleSale1010IdRoute,
  AuthSaleSale1010CreateRoute: AuthSaleSale1010CreateRoute,
  AuthSaleSale1220IdRoute: AuthSaleSale1220IdRoute,
  AuthSaleSale1220CreateRoute: AuthSaleSale1220CreateRoute,
  AuthSaleSale1230IdRoute: AuthSaleSale1230IdRoute,
  AuthSaleSale2310IdRoute: AuthSaleSale2310IdRoute,
  AuthSaleSale2310CreateRoute: AuthSaleSale2310CreateRoute,
  AuthSettingsCustomersIdRoute: AuthSettingsCustomersIdRoute,
  AuthSettingsCustomersCreateRoute: AuthSettingsCustomersCreateRoute,
  AuthSettingsGroupsIdRoute: AuthSettingsGroupsIdRoute,
  AuthSettingsGroupsCreateRoute: AuthSettingsGroupsCreateRoute,
  AuthSettingsHolidaysIdRoute: AuthSettingsHolidaysIdRoute,
  AuthSettingsHolidaysCreateRoute: AuthSettingsHolidaysCreateRoute,
  AuthSettingsItemsCreateRoute: AuthSettingsItemsCreateRoute,
  AuthSettingsLocationsIdRoute: AuthSettingsLocationsIdRoute,
  AuthSettingsLocationsCreateRoute: AuthSettingsLocationsCreateRoute,
  AuthSettingsMachinesIdRoute: AuthSettingsMachinesIdRoute,
  AuthSettingsMachinesCreateRoute: AuthSettingsMachinesCreateRoute,
  AuthSettingsMoldsIdRoute: AuthSettingsMoldsIdRoute,
  AuthSettingsMoldsCreateRoute: AuthSettingsMoldsCreateRoute,
  AuthSettingsPartiesIdRoute: AuthSettingsPartiesIdRoute,
  AuthSettingsPartiesCreateRoute: AuthSettingsPartiesCreateRoute,
  AuthSettingsRolesIdRoute: AuthSettingsRolesIdRoute,
  AuthSettingsRolesCreateRoute: AuthSettingsRolesCreateRoute,
  AuthSettingsRunningNumbersIdRoute: AuthSettingsRunningNumbersIdRoute,
  AuthSettingsRunningNumbersCreateRoute: AuthSettingsRunningNumbersCreateRoute,
  AuthSettingsRunningNumbersCreateByYearRoute:
    AuthSettingsRunningNumbersCreateByYearRoute,
  AuthSettingsSuppliersIdRoute: AuthSettingsSuppliersIdRoute,
  AuthSettingsSuppliersCreateRoute: AuthSettingsSuppliersCreateRoute,
  AuthSettingsUsersIdRoute: AuthSettingsUsersIdRoute,
  AuthSettingsUsersCreateRoute: AuthSettingsUsersCreateRoute,
  AuthWarehouseInv1010IdRoute: AuthWarehouseInv1010IdRoute,
  AuthWarehouseInv1010CreateRoute: AuthWarehouseInv1010CreateRoute,
  AuthWarehouseInv1015IdRoute: AuthWarehouseInv1015IdRoute,
  AuthWarehouseInv1015CreateRoute: AuthWarehouseInv1015CreateRoute,
  AuthWarehouseInv1110IdRoute: AuthWarehouseInv1110IdRoute,
  AuthWarehouseInv1120IdRoute: AuthWarehouseInv1120IdRoute,
  AuthWarehouseInv1140IdRoute: AuthWarehouseInv1140IdRoute,
  AuthWarehouseInv1140CreateRoute: AuthWarehouseInv1140CreateRoute,
  AuthWarehouseInv1210IdRoute: AuthWarehouseInv1210IdRoute,
  AuthWarehouseInv1210CreateRoute: AuthWarehouseInv1210CreateRoute,
  AuthWarehouseInv1310IdRoute: AuthWarehouseInv1310IdRoute,
  AuthWarehouseInv1310CreateRoute: AuthWarehouseInv1310CreateRoute,
  AuthWarehouseInv2010IdRoute: AuthWarehouseInv2010IdRoute,
  AuthWarehouseInv2010CreateRoute: AuthWarehouseInv2010CreateRoute,
  AuthWarehouseInv2210IdRoute: AuthWarehouseInv2210IdRoute,
  AuthWarehouseInv2210CreateRoute: AuthWarehouseInv2210CreateRoute,
  AuthWarehouseInv2215IdRoute: AuthWarehouseInv2215IdRoute,
  AuthWarehouseInv2215CreateRoute: AuthWarehouseInv2215CreateRoute,
  AuthWarehouseInv2310IdRoute: AuthWarehouseInv2310IdRoute,
  AuthWarehouseInv2310CreateRoute: AuthWarehouseInv2310CreateRoute,
  AuthWarehouseInv3010IdRoute: AuthWarehouseInv3010IdRoute,
  AuthWarehouseInv3010CreateRoute: AuthWarehouseInv3010CreateRoute,
  AuthWarehouseInv3020IdRoute: AuthWarehouseInv3020IdRoute,
  AuthWarehouseInv3020CreateRoute: AuthWarehouseInv3020CreateRoute,
  AuthWarehouseInv3510IdRoute: AuthWarehouseInv3510IdRoute,
  AuthWarehouseInv3510CreateRoute: AuthWarehouseInv3510CreateRoute,
  AuthWarehouseInv4310IdRoute: AuthWarehouseInv4310IdRoute,
  AuthWarehouseInv4310CreateRoute: AuthWarehouseInv4310CreateRoute,
  AuthWarehouseInv5010IdRoute: AuthWarehouseInv5010IdRoute,
  AuthWarehouseInv5010CreateRoute: AuthWarehouseInv5010CreateRoute,
  AuthAccountingChartOfAccountsIndexRoute:
    AuthAccountingChartOfAccountsIndexRoute,
  AuthAccountingFiscalYearIndexRoute: AuthAccountingFiscalYearIndexRoute,
  AuthAccountingJournalEntryIndexRoute: AuthAccountingJournalEntryIndexRoute,
  AuthProductionPrd1010IndexRoute: AuthProductionPrd1010IndexRoute,
  AuthProductionPrd1011IndexRoute: AuthProductionPrd1011IndexRoute,
  AuthProductionPrd1015IndexRoute: AuthProductionPrd1015IndexRoute,
  AuthProductionPrd1110IndexRoute: AuthProductionPrd1110IndexRoute,
  AuthProductionPrd1210IndexRoute: AuthProductionPrd1210IndexRoute,
  AuthProductionPrd2010IndexRoute: AuthProductionPrd2010IndexRoute,
  AuthProductionPrd3010IndexRoute: AuthProductionPrd3010IndexRoute,
  AuthProductionPrd3110IndexRoute: AuthProductionPrd3110IndexRoute,
  AuthProductionPrd4010IndexRoute: AuthProductionPrd4010IndexRoute,
  AuthProductionPrd4020IndexRoute: AuthProductionPrd4020IndexRoute,
  AuthProductionPrd4030IndexRoute: AuthProductionPrd4030IndexRoute,
  AuthProductionWo1010IndexRoute: AuthProductionWo1010IndexRoute,
  AuthProductionWo1110IndexRoute: AuthProductionWo1110IndexRoute,
  AuthProductionWo1115IndexRoute: AuthProductionWo1115IndexRoute,
  AuthProductionWo1210IndexRoute: AuthProductionWo1210IndexRoute,
  AuthProductionWo3010IndexRoute: AuthProductionWo3010IndexRoute,
  AuthProductionWo9010IndexRoute: AuthProductionWo9010IndexRoute,
  AuthPurchaseBplusSyncIndexRoute: AuthPurchaseBplusSyncIndexRoute,
  AuthPurchasePo1010IndexRoute: AuthPurchasePo1010IndexRoute,
  AuthPurchasePo9010IndexRoute: AuthPurchasePo9010IndexRoute,
  AuthPurchasePo9020IndexRoute: AuthPurchasePo9020IndexRoute,
  AuthPurchasePo9030IndexRoute: AuthPurchasePo9030IndexRoute,
  AuthPurchaseProblemIndexRoute: AuthPurchaseProblemIndexRoute,
  AuthPurchaseTrackingIndexRoute: AuthPurchaseTrackingIndexRoute,
  AuthQcQc1010IndexRoute: AuthQcQc1010IndexRoute,
  AuthQcQc8010IndexRoute: AuthQcQc8010IndexRoute,
  AuthQcQc8015IndexRoute: AuthQcQc8015IndexRoute,
  AuthQcQc8030IndexRoute: AuthQcQc8030IndexRoute,
  AuthQcQc8110IndexRoute: AuthQcQc8110IndexRoute,
  AuthQcQc9010IndexRoute: AuthQcQc9010IndexRoute,
  AuthSaleSale1010IndexRoute: AuthSaleSale1010IndexRoute,
  AuthSaleSale1020IndexRoute: AuthSaleSale1020IndexRoute,
  AuthSaleSale1030IndexRoute: AuthSaleSale1030IndexRoute,
  AuthSaleSale1210IndexRoute: AuthSaleSale1210IndexRoute,
  AuthSaleSale1220IndexRoute: AuthSaleSale1220IndexRoute,
  AuthSaleSale1230IndexRoute: AuthSaleSale1230IndexRoute,
  AuthSaleSale2310IndexRoute: AuthSaleSale2310IndexRoute,
  AuthSettingsCustomersIndexRoute: AuthSettingsCustomersIndexRoute,
  AuthSettingsGroupsIndexRoute: AuthSettingsGroupsIndexRoute,
  AuthSettingsHolidaysIndexRoute: AuthSettingsHolidaysIndexRoute,
  AuthSettingsItemsIndexRoute: AuthSettingsItemsIndexRoute,
  AuthSettingsLocationsIndexRoute: AuthSettingsLocationsIndexRoute,
  AuthSettingsMachinesIndexRoute: AuthSettingsMachinesIndexRoute,
  AuthSettingsMoldsIndexRoute: AuthSettingsMoldsIndexRoute,
  AuthSettingsPartiesIndexRoute: AuthSettingsPartiesIndexRoute,
  AuthSettingsRolesIndexRoute: AuthSettingsRolesIndexRoute,
  AuthSettingsRunningNumbersIndexRoute: AuthSettingsRunningNumbersIndexRoute,
  AuthSettingsScreenCaptureIndexRoute: AuthSettingsScreenCaptureIndexRoute,
  AuthSettingsSuppliersIndexRoute: AuthSettingsSuppliersIndexRoute,
  AuthSettingsUsersIndexRoute: AuthSettingsUsersIndexRoute,
  AuthWarehouseDashboardIndexRoute: AuthWarehouseDashboardIndexRoute,
  AuthWarehouseInv1010IndexRoute: AuthWarehouseInv1010IndexRoute,
  AuthWarehouseInv1015IndexRoute: AuthWarehouseInv1015IndexRoute,
  AuthWarehouseInv1110IndexRoute: AuthWarehouseInv1110IndexRoute,
  AuthWarehouseInv1120IndexRoute: AuthWarehouseInv1120IndexRoute,
  AuthWarehouseInv1140IndexRoute: AuthWarehouseInv1140IndexRoute,
  AuthWarehouseInv1210IndexRoute: AuthWarehouseInv1210IndexRoute,
  AuthWarehouseInv1310IndexRoute: AuthWarehouseInv1310IndexRoute,
  AuthWarehouseInv2010IndexRoute: AuthWarehouseInv2010IndexRoute,
  AuthWarehouseInv2210IndexRoute: AuthWarehouseInv2210IndexRoute,
  AuthWarehouseInv2215IndexRoute: AuthWarehouseInv2215IndexRoute,
  AuthWarehouseInv2310IndexRoute: AuthWarehouseInv2310IndexRoute,
  AuthWarehouseInv3010IndexRoute: AuthWarehouseInv3010IndexRoute,
  AuthWarehouseInv3020IndexRoute: AuthWarehouseInv3020IndexRoute,
  AuthWarehouseInv3510IndexRoute: AuthWarehouseInv3510IndexRoute,
  AuthWarehouseInv4010IndexRoute: AuthWarehouseInv4010IndexRoute,
  AuthWarehouseInv4015IndexRoute: AuthWarehouseInv4015IndexRoute,
  AuthWarehouseInv4020IndexRoute: AuthWarehouseInv4020IndexRoute,
  AuthWarehouseInv4110IndexRoute: AuthWarehouseInv4110IndexRoute,
  AuthWarehouseInv4210IndexRoute: AuthWarehouseInv4210IndexRoute,
  AuthWarehouseInv4310IndexRoute: AuthWarehouseInv4310IndexRoute,
  AuthWarehouseInv5010IndexRoute: AuthWarehouseInv5010IndexRoute,
  AuthWarehouseInv9010IndexRoute: AuthWarehouseInv9010IndexRoute,
  AuthWarehouseInv9020IndexRoute: AuthWarehouseInv9020IndexRoute,
  AuthWarehouseInv9110IndexRoute: AuthWarehouseInv9110IndexRoute,
  AuthWarehouseInv9120IndexRoute: AuthWarehouseInv9120IndexRoute,
  AuthWarehouseInv9210IndexRoute: AuthWarehouseInv9210IndexRoute,
  AuthAccountingChartOfAccountsEditIdRoute:
    AuthAccountingChartOfAccountsEditIdRoute,
  AuthAccountingJournalEntryEditIdRoute: AuthAccountingJournalEntryEditIdRoute,
  AuthProductionPrd1010CreateWsidRoute: AuthProductionPrd1010CreateWsidRoute,
  AuthProductionPrd1110CreateWsidRoute: AuthProductionPrd1110CreateWsidRoute,
  AuthProductionPrd3110EditIdRoute: AuthProductionPrd3110EditIdRoute,
  AuthProductionWo1010EditIdRoute: AuthProductionWo1010EditIdRoute,
  AuthProductionWo1110EditIdRoute: AuthProductionWo1110EditIdRoute,
  AuthProductionWo3010EditIdRoute: AuthProductionWo3010EditIdRoute,
  AuthPurchasePo1010EditIdRoute: AuthPurchasePo1010EditIdRoute,
  AuthQcQc8010ViewIdRoute: AuthQcQc8010ViewIdRoute,
  AuthQcQc8110EditIdRoute: AuthQcQc8110EditIdRoute,
  AuthSaleSale1010EditIdRoute: AuthSaleSale1010EditIdRoute,
  AuthSaleSale1220EditIdRoute: AuthSaleSale1220EditIdRoute,
  AuthSaleSale2310EditIdRoute: AuthSaleSale2310EditIdRoute,
  AuthSettingsCustomersEditIdRoute: AuthSettingsCustomersEditIdRoute,
  AuthSettingsGroupsEditIdRoute: AuthSettingsGroupsEditIdRoute,
  AuthSettingsHolidaysEditIdRoute: AuthSettingsHolidaysEditIdRouteWithChildren,
  AuthSettingsItemsEditIdRoute: AuthSettingsItemsEditIdRoute,
  AuthSettingsItemsViewIdRoute: AuthSettingsItemsViewIdRoute,
  AuthSettingsLocationsEditIdRoute: AuthSettingsLocationsEditIdRoute,
  AuthSettingsMachinesEditIdRoute: AuthSettingsMachinesEditIdRouteWithChildren,
  AuthSettingsMoldsDeleteIdRoute: AuthSettingsMoldsDeleteIdRoute,
  AuthSettingsMoldsEditIdRoute: AuthSettingsMoldsEditIdRoute,
  AuthSettingsPartiesEditIdRoute: AuthSettingsPartiesEditIdRoute,
  AuthSettingsRolesEditIdRoute: AuthSettingsRolesEditIdRouteWithChildren,
  AuthSettingsRunningNumbersEditIdRoute: AuthSettingsRunningNumbersEditIdRoute,
  AuthSettingsSuppliersEditIdRoute: AuthSettingsSuppliersEditIdRoute,
  AuthSettingsUsersEditIdRoute: AuthSettingsUsersEditIdRoute,
  AuthWarehouseInv1010EditIdRoute: AuthWarehouseInv1010EditIdRoute,
  AuthWarehouseInv1015EditIdRoute: AuthWarehouseInv1015EditIdRoute,
  AuthWarehouseInv1140EditIdRoute: AuthWarehouseInv1140EditIdRoute,
  AuthWarehouseInv1210EditIdRoute: AuthWarehouseInv1210EditIdRoute,
  AuthWarehouseInv1310EditIdRoute: AuthWarehouseInv1310EditIdRoute,
  AuthWarehouseInv2010EditIdRoute: AuthWarehouseInv2010EditIdRoute,
  AuthWarehouseInv2210EditIdRoute: AuthWarehouseInv2210EditIdRoute,
  AuthWarehouseInv2215EditIdRoute: AuthWarehouseInv2215EditIdRoute,
  AuthWarehouseInv2310EditIdRoute: AuthWarehouseInv2310EditIdRoute,
  AuthWarehouseInv3010EditIdRoute: AuthWarehouseInv3010EditIdRoute,
  AuthWarehouseInv3020EditIdRoute: AuthWarehouseInv3020EditIdRoute,
  AuthWarehouseInv3510IdCompletionRoute: AuthWarehouseInv3510IdCompletionRoute,
  AuthWarehouseInv3510IdProgressRoute: AuthWarehouseInv3510IdProgressRoute,
  AuthWarehouseInv3510IdVariancesRoute: AuthWarehouseInv3510IdVariancesRoute,
  AuthWarehouseInv3510IdZonesRoute: AuthWarehouseInv3510IdZonesRoute,
  AuthWarehouseInv3510EditIdRoute: AuthWarehouseInv3510EditIdRoute,
  AuthWarehouseInv4310IdOverrideItemsRoute:
    AuthWarehouseInv4310IdOverrideItemsRoute,
  AuthWarehouseInv4310AdjustIdRoute: AuthWarehouseInv4310AdjustIdRoute,
  AuthSettingsItemsItemIdIndexRoute: AuthSettingsItemsItemIdIndexRoute,
  AuthProductionPrd1010EditWsidIdRoute: AuthProductionPrd1010EditWsidIdRoute,
  AuthProductionPrd1110EditWsidIdRoute: AuthProductionPrd1110EditWsidIdRoute,
  AuthPurchaseTrackingReceiveIdItemIdRoute:
    AuthPurchaseTrackingReceiveIdItemIdRoute,
  AuthSettingsItemsItemIdBomsIdRoute: AuthSettingsItemsItemIdBomsIdRoute,
  AuthSettingsItemsItemIdBomsCreateRoute:
    AuthSettingsItemsItemIdBomsCreateRoute,
  AuthProductionWo1210IndexHoldIdRoute: AuthProductionWo1210IndexHoldIdRoute,
  AuthQcQc1010IndexHoldIdRoute: AuthQcQc1010IndexHoldIdRoute,
  AuthQcQc8030IndexResultIdRoute: AuthQcQc8030IndexResultIdRoute,
  AuthSettingsCustomersIndexDeleteIdRoute:
    AuthSettingsCustomersIndexDeleteIdRoute,
  AuthSettingsLocationsIndexDeleteIdRoute:
    AuthSettingsLocationsIndexDeleteIdRoute,
  AuthSettingsPartiesIndexDeleteIdRoute: AuthSettingsPartiesIndexDeleteIdRoute,
  AuthSettingsRunningNumbersIndexDeleteIdRoute:
    AuthSettingsRunningNumbersIndexDeleteIdRoute,
  AuthSettingsSuppliersIndexDeleteIdRoute:
    AuthSettingsSuppliersIndexDeleteIdRoute,
  AuthSettingsUsersIndexDeleteIdRoute: AuthSettingsUsersIndexDeleteIdRoute,
  AuthSettingsItemsItemIdBomsEditIdRoute:
    AuthSettingsItemsItemIdBomsEditIdRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/change-password': typeof AuthChangePasswordRoute
  '/home': typeof AuthHomeRoute
  '/no-permission': typeof AuthNoPermissionRoute
  '/testrun': typeof AuthTestrunIndexRoute
  '/user-messages': typeof AuthUserMessagesIndexRoute
  '/accounting/chart-of-accounts/create': typeof AuthAccountingChartOfAccountsCreateRoute
  '/accounting/fiscal-year/$id': typeof AuthAccountingFiscalYearIdRoute
  '/accounting/fiscal-year/create': typeof AuthAccountingFiscalYearCreateRoute
  '/accounting/journal-entry/$id': typeof AuthAccountingJournalEntryIdRoute
  '/accounting/journal-entry/create': typeof AuthAccountingJournalEntryCreateRoute
  '/accounting/reports/general-ledger': typeof AuthAccountingReportsGeneralLedgerRoute
  '/accounting/reports/trial-balance': typeof AuthAccountingReportsTrialBalanceRoute
  '/production/prd1210/$id': typeof AuthProductionPrd1210IdRoute
  '/production/prd3010/$id': typeof AuthProductionPrd3010IdRoute
  '/production/prd3110/$id': typeof AuthProductionPrd3110IdRoute
  '/production/prd4010/$id': typeof AuthProductionPrd4010IdRoute
  '/production/wo1010/$id': typeof AuthProductionWo1010IdRoute
  '/production/wo1010/create': typeof AuthProductionWo1010CreateRoute
  '/production/wo1110/$id': typeof AuthProductionWo1110IdRoute
  '/production/wo3010/$id': typeof AuthProductionWo3010IdRoute
  '/production/wo3010/create': typeof AuthProductionWo3010CreateRoute
  '/purchase/po1010/$id': typeof AuthPurchasePo1010IdRoute
  '/purchase/po1010/create': typeof AuthPurchasePo1010CreateRoute
  '/qc/qc8010/$id': typeof AuthQcQc8010IdRoute
  '/qc/qc8010/create': typeof AuthQcQc8010CreateRoute
  '/qc/qc8015/$id': typeof AuthQcQc8015IdRoute
  '/qc/qc8110/$id': typeof AuthQcQc8110IdRoute
  '/qc/qc8110/create': typeof AuthQcQc8110CreateRoute
  '/sale/sale1010/$id': typeof AuthSaleSale1010IdRoute
  '/sale/sale1010/create': typeof AuthSaleSale1010CreateRoute
  '/sale/sale1220/$id': typeof AuthSaleSale1220IdRoute
  '/sale/sale1220/create': typeof AuthSaleSale1220CreateRoute
  '/sale/sale1230/$id': typeof AuthSaleSale1230IdRoute
  '/sale/sale2310/$id': typeof AuthSaleSale2310IdRoute
  '/sale/sale2310/create': typeof AuthSaleSale2310CreateRoute
  '/settings/customers/$id': typeof AuthSettingsCustomersIdRoute
  '/settings/customers/create': typeof AuthSettingsCustomersCreateRoute
  '/settings/groups/$id': typeof AuthSettingsGroupsIdRoute
  '/settings/groups/create': typeof AuthSettingsGroupsCreateRoute
  '/settings/holidays/$id': typeof AuthSettingsHolidaysIdRoute
  '/settings/holidays/create': typeof AuthSettingsHolidaysCreateRoute
  '/settings/items/create': typeof AuthSettingsItemsCreateRoute
  '/settings/locations/$id': typeof AuthSettingsLocationsIdRoute
  '/settings/locations/create': typeof AuthSettingsLocationsCreateRoute
  '/settings/machines/$id': typeof AuthSettingsMachinesIdRoute
  '/settings/machines/create': typeof AuthSettingsMachinesCreateRoute
  '/settings/molds/$id': typeof AuthSettingsMoldsIdRoute
  '/settings/molds/create': typeof AuthSettingsMoldsCreateRoute
  '/settings/parties/$id': typeof AuthSettingsPartiesIdRoute
  '/settings/parties/create': typeof AuthSettingsPartiesCreateRoute
  '/settings/roles/$id': typeof AuthSettingsRolesIdRoute
  '/settings/roles/create': typeof AuthSettingsRolesCreateRoute
  '/settings/running-numbers/$id': typeof AuthSettingsRunningNumbersIdRoute
  '/settings/running-numbers/create': typeof AuthSettingsRunningNumbersCreateRoute
  '/settings/running-numbers/create-by-year': typeof AuthSettingsRunningNumbersCreateByYearRoute
  '/settings/suppliers/$id': typeof AuthSettingsSuppliersIdRoute
  '/settings/suppliers/create': typeof AuthSettingsSuppliersCreateRoute
  '/settings/users/$id': typeof AuthSettingsUsersIdRoute
  '/settings/users/create': typeof AuthSettingsUsersCreateRoute
  '/warehouse/inv1010/$id': typeof AuthWarehouseInv1010IdRoute
  '/warehouse/inv1010/create': typeof AuthWarehouseInv1010CreateRoute
  '/warehouse/inv1015/$id': typeof AuthWarehouseInv1015IdRoute
  '/warehouse/inv1015/create': typeof AuthWarehouseInv1015CreateRoute
  '/warehouse/inv1110/$id': typeof AuthWarehouseInv1110IdRoute
  '/warehouse/inv1120/$id': typeof AuthWarehouseInv1120IdRoute
  '/warehouse/inv1140/$id': typeof AuthWarehouseInv1140IdRoute
  '/warehouse/inv1140/create': typeof AuthWarehouseInv1140CreateRoute
  '/warehouse/inv1210/$id': typeof AuthWarehouseInv1210IdRoute
  '/warehouse/inv1210/create': typeof AuthWarehouseInv1210CreateRoute
  '/warehouse/inv1310/$id': typeof AuthWarehouseInv1310IdRoute
  '/warehouse/inv1310/create': typeof AuthWarehouseInv1310CreateRoute
  '/warehouse/inv2010/$id': typeof AuthWarehouseInv2010IdRoute
  '/warehouse/inv2010/create': typeof AuthWarehouseInv2010CreateRoute
  '/warehouse/inv2210/$id': typeof AuthWarehouseInv2210IdRoute
  '/warehouse/inv2210/create': typeof AuthWarehouseInv2210CreateRoute
  '/warehouse/inv2215/$id': typeof AuthWarehouseInv2215IdRoute
  '/warehouse/inv2215/create': typeof AuthWarehouseInv2215CreateRoute
  '/warehouse/inv2310/$id': typeof AuthWarehouseInv2310IdRoute
  '/warehouse/inv2310/create': typeof AuthWarehouseInv2310CreateRoute
  '/warehouse/inv3010/$id': typeof AuthWarehouseInv3010IdRoute
  '/warehouse/inv3010/create': typeof AuthWarehouseInv3010CreateRoute
  '/warehouse/inv3020/$id': typeof AuthWarehouseInv3020IdRoute
  '/warehouse/inv3020/create': typeof AuthWarehouseInv3020CreateRoute
  '/warehouse/inv3510/$id': typeof AuthWarehouseInv3510IdRoute
  '/warehouse/inv3510/create': typeof AuthWarehouseInv3510CreateRoute
  '/warehouse/inv4310/$id': typeof AuthWarehouseInv4310IdRoute
  '/warehouse/inv4310/create': typeof AuthWarehouseInv4310CreateRoute
  '/warehouse/inv5010/$id': typeof AuthWarehouseInv5010IdRoute
  '/warehouse/inv5010/create': typeof AuthWarehouseInv5010CreateRoute
  '/accounting/chart-of-accounts': typeof AuthAccountingChartOfAccountsIndexRoute
  '/accounting/fiscal-year': typeof AuthAccountingFiscalYearIndexRoute
  '/accounting/journal-entry': typeof AuthAccountingJournalEntryIndexRoute
  '/production/prd1010': typeof AuthProductionPrd1010IndexRoute
  '/production/prd1011': typeof AuthProductionPrd1011IndexRoute
  '/production/prd1015': typeof AuthProductionPrd1015IndexRoute
  '/production/prd1110': typeof AuthProductionPrd1110IndexRoute
  '/production/prd1210': typeof AuthProductionPrd1210IndexRoute
  '/production/prd2010': typeof AuthProductionPrd2010IndexRoute
  '/production/prd3010': typeof AuthProductionPrd3010IndexRoute
  '/production/prd3110': typeof AuthProductionPrd3110IndexRoute
  '/production/prd4010': typeof AuthProductionPrd4010IndexRoute
  '/production/prd4020': typeof AuthProductionPrd4020IndexRoute
  '/production/prd4030': typeof AuthProductionPrd4030IndexRoute
  '/production/wo1010': typeof AuthProductionWo1010IndexRoute
  '/production/wo1110': typeof AuthProductionWo1110IndexRoute
  '/production/wo1115': typeof AuthProductionWo1115IndexRoute
  '/production/wo1210': typeof AuthProductionWo1210IndexRoute
  '/production/wo3010': typeof AuthProductionWo3010IndexRoute
  '/production/wo9010': typeof AuthProductionWo9010IndexRoute
  '/purchase/bplus-sync': typeof AuthPurchaseBplusSyncIndexRoute
  '/purchase/po1010': typeof AuthPurchasePo1010IndexRoute
  '/purchase/po9010': typeof AuthPurchasePo9010IndexRoute
  '/purchase/po9020': typeof AuthPurchasePo9020IndexRoute
  '/purchase/po9030': typeof AuthPurchasePo9030IndexRoute
  '/purchase/problem': typeof AuthPurchaseProblemIndexRoute
  '/purchase/tracking': typeof AuthPurchaseTrackingIndexRoute
  '/qc/qc1010': typeof AuthQcQc1010IndexRoute
  '/qc/qc8010': typeof AuthQcQc8010IndexRoute
  '/qc/qc8015': typeof AuthQcQc8015IndexRoute
  '/qc/qc8030': typeof AuthQcQc8030IndexRoute
  '/qc/qc8110': typeof AuthQcQc8110IndexRoute
  '/qc/qc9010': typeof AuthQcQc9010IndexRoute
  '/sale/sale1010': typeof AuthSaleSale1010IndexRoute
  '/sale/sale1020': typeof AuthSaleSale1020IndexRoute
  '/sale/sale1030': typeof AuthSaleSale1030IndexRoute
  '/sale/sale1210': typeof AuthSaleSale1210IndexRoute
  '/sale/sale1220': typeof AuthSaleSale1220IndexRoute
  '/sale/sale1230': typeof AuthSaleSale1230IndexRoute
  '/sale/sale2310': typeof AuthSaleSale2310IndexRoute
  '/settings/customers': typeof AuthSettingsCustomersIndexRoute
  '/settings/groups': typeof AuthSettingsGroupsIndexRoute
  '/settings/holidays': typeof AuthSettingsHolidaysIndexRoute
  '/settings/items': typeof AuthSettingsItemsIndexRoute
  '/settings/locations': typeof AuthSettingsLocationsIndexRoute
  '/settings/machines': typeof AuthSettingsMachinesIndexRoute
  '/settings/molds': typeof AuthSettingsMoldsIndexRoute
  '/settings/parties': typeof AuthSettingsPartiesIndexRoute
  '/settings/roles': typeof AuthSettingsRolesIndexRoute
  '/settings/running-numbers': typeof AuthSettingsRunningNumbersIndexRoute
  '/settings/screen-capture': typeof AuthSettingsScreenCaptureIndexRoute
  '/settings/suppliers': typeof AuthSettingsSuppliersIndexRoute
  '/settings/users': typeof AuthSettingsUsersIndexRoute
  '/warehouse/dashboard': typeof AuthWarehouseDashboardIndexRoute
  '/warehouse/inv1010': typeof AuthWarehouseInv1010IndexRoute
  '/warehouse/inv1015': typeof AuthWarehouseInv1015IndexRoute
  '/warehouse/inv1110': typeof AuthWarehouseInv1110IndexRoute
  '/warehouse/inv1120': typeof AuthWarehouseInv1120IndexRoute
  '/warehouse/inv1140': typeof AuthWarehouseInv1140IndexRoute
  '/warehouse/inv1210': typeof AuthWarehouseInv1210IndexRoute
  '/warehouse/inv1310': typeof AuthWarehouseInv1310IndexRoute
  '/warehouse/inv2010': typeof AuthWarehouseInv2010IndexRoute
  '/warehouse/inv2210': typeof AuthWarehouseInv2210IndexRoute
  '/warehouse/inv2215': typeof AuthWarehouseInv2215IndexRoute
  '/warehouse/inv2310': typeof AuthWarehouseInv2310IndexRoute
  '/warehouse/inv3010': typeof AuthWarehouseInv3010IndexRoute
  '/warehouse/inv3020': typeof AuthWarehouseInv3020IndexRoute
  '/warehouse/inv3510': typeof AuthWarehouseInv3510IndexRoute
  '/warehouse/inv4010': typeof AuthWarehouseInv4010IndexRoute
  '/warehouse/inv4015': typeof AuthWarehouseInv4015IndexRoute
  '/warehouse/inv4020': typeof AuthWarehouseInv4020IndexRoute
  '/warehouse/inv4110': typeof AuthWarehouseInv4110IndexRoute
  '/warehouse/inv4210': typeof AuthWarehouseInv4210IndexRoute
  '/warehouse/inv4310': typeof AuthWarehouseInv4310IndexRoute
  '/warehouse/inv5010': typeof AuthWarehouseInv5010IndexRoute
  '/warehouse/inv9010': typeof AuthWarehouseInv9010IndexRoute
  '/warehouse/inv9020': typeof AuthWarehouseInv9020IndexRoute
  '/warehouse/inv9110': typeof AuthWarehouseInv9110IndexRoute
  '/warehouse/inv9120': typeof AuthWarehouseInv9120IndexRoute
  '/warehouse/inv9210': typeof AuthWarehouseInv9210IndexRoute
  '/accounting/chart-of-accounts/edit/$id': typeof AuthAccountingChartOfAccountsEditIdRoute
  '/accounting/journal-entry/edit/$id': typeof AuthAccountingJournalEntryEditIdRoute
  '/production/prd1010/create/$wsid': typeof AuthProductionPrd1010CreateWsidRoute
  '/production/prd1110/create/$wsid': typeof AuthProductionPrd1110CreateWsidRoute
  '/production/prd3110/edit/$id': typeof AuthProductionPrd3110EditIdRoute
  '/production/wo1010/edit/$id': typeof AuthProductionWo1010EditIdRoute
  '/production/wo1110/edit/$id': typeof AuthProductionWo1110EditIdRoute
  '/production/wo3010/edit/$id': typeof AuthProductionWo3010EditIdRoute
  '/purchase/po1010/edit/$id': typeof AuthPurchasePo1010EditIdRoute
  '/qc/qc8010/view/$id': typeof AuthQcQc8010ViewIdRoute
  '/qc/qc8110/edit/$id': typeof AuthQcQc8110EditIdRoute
  '/sale/sale1010/edit/$id': typeof AuthSaleSale1010EditIdRoute
  '/sale/sale1220/edit/$id': typeof AuthSaleSale1220EditIdRoute
  '/sale/sale2310/edit/$id': typeof AuthSaleSale2310EditIdRoute
  '/settings/customers/edit/$id': typeof AuthSettingsCustomersEditIdRoute
  '/settings/groups/edit/$id': typeof AuthSettingsGroupsEditIdRoute
  '/settings/holidays/edit/$id': typeof AuthSettingsHolidaysEditIdRouteWithChildren
  '/settings/items/edit/$id': typeof AuthSettingsItemsEditIdRoute
  '/settings/items/view/$id': typeof AuthSettingsItemsViewIdRoute
  '/settings/locations/edit/$id': typeof AuthSettingsLocationsEditIdRoute
  '/settings/machines/edit/$id': typeof AuthSettingsMachinesEditIdRouteWithChildren
  '/settings/molds/delete/$id': typeof AuthSettingsMoldsDeleteIdRoute
  '/settings/molds/edit/$id': typeof AuthSettingsMoldsEditIdRoute
  '/settings/parties/edit/$id': typeof AuthSettingsPartiesEditIdRoute
  '/settings/roles/edit/$id': typeof AuthSettingsRolesEditIdRouteWithChildren
  '/settings/running-numbers/edit/$id': typeof AuthSettingsRunningNumbersEditIdRoute
  '/settings/suppliers/edit/$id': typeof AuthSettingsSuppliersEditIdRoute
  '/settings/users/edit/$id': typeof AuthSettingsUsersEditIdRoute
  '/warehouse/inv1010/edit/$id': typeof AuthWarehouseInv1010EditIdRoute
  '/warehouse/inv1015/edit/$id': typeof AuthWarehouseInv1015EditIdRoute
  '/warehouse/inv1140/edit/$id': typeof AuthWarehouseInv1140EditIdRoute
  '/warehouse/inv1210/edit/$id': typeof AuthWarehouseInv1210EditIdRoute
  '/warehouse/inv1310/edit/$id': typeof AuthWarehouseInv1310EditIdRoute
  '/warehouse/inv2010/edit/$id': typeof AuthWarehouseInv2010EditIdRoute
  '/warehouse/inv2210/edit/$id': typeof AuthWarehouseInv2210EditIdRoute
  '/warehouse/inv2215/edit/$id': typeof AuthWarehouseInv2215EditIdRoute
  '/warehouse/inv2310/edit/$id': typeof AuthWarehouseInv2310EditIdRoute
  '/warehouse/inv3010/edit/$id': typeof AuthWarehouseInv3010EditIdRoute
  '/warehouse/inv3020/edit/$id': typeof AuthWarehouseInv3020EditIdRoute
  '/warehouse/inv3510/$id/completion': typeof AuthWarehouseInv3510IdCompletionRoute
  '/warehouse/inv3510/$id/progress': typeof AuthWarehouseInv3510IdProgressRoute
  '/warehouse/inv3510/$id/variances': typeof AuthWarehouseInv3510IdVariancesRoute
  '/warehouse/inv3510/$id/zones': typeof AuthWarehouseInv3510IdZonesRoute
  '/warehouse/inv3510/edit/$id': typeof AuthWarehouseInv3510EditIdRoute
  '/warehouse/inv4310/$id/override-items': typeof AuthWarehouseInv4310IdOverrideItemsRoute
  '/warehouse/inv4310/adjust/$id': typeof AuthWarehouseInv4310AdjustIdRoute
  '/settings/items/$itemId': typeof AuthSettingsItemsItemIdIndexRoute
  '/production/prd1010/edit/$wsid/$id': typeof AuthProductionPrd1010EditWsidIdRoute
  '/production/prd1110/edit/$wsid/$id': typeof AuthProductionPrd1110EditWsidIdRoute
  '/purchase/tracking/receive/$id/$itemId': typeof AuthPurchaseTrackingReceiveIdItemIdRoute
  '/settings/holidays/edit/$id/delete': typeof AuthSettingsHolidaysEditIdDeleteRoute
  '/settings/items/$itemId/boms/$id': typeof AuthSettingsItemsItemIdBomsIdRoute
  '/settings/items/$itemId/boms/create': typeof AuthSettingsItemsItemIdBomsCreateRoute
  '/settings/machines/edit/$id/delete': typeof AuthSettingsMachinesEditIdDeleteRoute
  '/settings/roles/edit/$id/delete': typeof AuthSettingsRolesEditIdDeleteRoute
  '/production/wo1210/index/hold/$id': typeof AuthProductionWo1210IndexHoldIdRoute
  '/qc/qc1010/index/hold/$id': typeof AuthQcQc1010IndexHoldIdRoute
  '/qc/qc8030/index/result/$id': typeof AuthQcQc8030IndexResultIdRoute
  '/settings/customers/index/delete/$id': typeof AuthSettingsCustomersIndexDeleteIdRoute
  '/settings/locations/index/delete/$id': typeof AuthSettingsLocationsIndexDeleteIdRoute
  '/settings/parties/index/delete/$id': typeof AuthSettingsPartiesIndexDeleteIdRoute
  '/settings/running-numbers/index/delete/$id': typeof AuthSettingsRunningNumbersIndexDeleteIdRoute
  '/settings/suppliers/index/delete/$id': typeof AuthSettingsSuppliersIndexDeleteIdRoute
  '/settings/users/index/delete/$id': typeof AuthSettingsUsersIndexDeleteIdRoute
  '/settings/items/$itemId/boms/edit/$id': typeof AuthSettingsItemsItemIdBomsEditIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/change-password': typeof AuthChangePasswordRoute
  '/home': typeof AuthHomeRoute
  '/no-permission': typeof AuthNoPermissionRoute
  '/testrun': typeof AuthTestrunIndexRoute
  '/user-messages': typeof AuthUserMessagesIndexRoute
  '/accounting/chart-of-accounts/create': typeof AuthAccountingChartOfAccountsCreateRoute
  '/accounting/fiscal-year/$id': typeof AuthAccountingFiscalYearIdRoute
  '/accounting/fiscal-year/create': typeof AuthAccountingFiscalYearCreateRoute
  '/accounting/journal-entry/$id': typeof AuthAccountingJournalEntryIdRoute
  '/accounting/journal-entry/create': typeof AuthAccountingJournalEntryCreateRoute
  '/accounting/reports/general-ledger': typeof AuthAccountingReportsGeneralLedgerRoute
  '/accounting/reports/trial-balance': typeof AuthAccountingReportsTrialBalanceRoute
  '/production/prd1210/$id': typeof AuthProductionPrd1210IdRoute
  '/production/prd3010/$id': typeof AuthProductionPrd3010IdRoute
  '/production/prd3110/$id': typeof AuthProductionPrd3110IdRoute
  '/production/prd4010/$id': typeof AuthProductionPrd4010IdRoute
  '/production/wo1010/$id': typeof AuthProductionWo1010IdRoute
  '/production/wo1010/create': typeof AuthProductionWo1010CreateRoute
  '/production/wo1110/$id': typeof AuthProductionWo1110IdRoute
  '/production/wo3010/$id': typeof AuthProductionWo3010IdRoute
  '/production/wo3010/create': typeof AuthProductionWo3010CreateRoute
  '/purchase/po1010/$id': typeof AuthPurchasePo1010IdRoute
  '/purchase/po1010/create': typeof AuthPurchasePo1010CreateRoute
  '/qc/qc8010/$id': typeof AuthQcQc8010IdRoute
  '/qc/qc8010/create': typeof AuthQcQc8010CreateRoute
  '/qc/qc8015/$id': typeof AuthQcQc8015IdRoute
  '/qc/qc8110/$id': typeof AuthQcQc8110IdRoute
  '/qc/qc8110/create': typeof AuthQcQc8110CreateRoute
  '/sale/sale1010/$id': typeof AuthSaleSale1010IdRoute
  '/sale/sale1010/create': typeof AuthSaleSale1010CreateRoute
  '/sale/sale1220/$id': typeof AuthSaleSale1220IdRoute
  '/sale/sale1220/create': typeof AuthSaleSale1220CreateRoute
  '/sale/sale1230/$id': typeof AuthSaleSale1230IdRoute
  '/sale/sale2310/$id': typeof AuthSaleSale2310IdRoute
  '/sale/sale2310/create': typeof AuthSaleSale2310CreateRoute
  '/settings/customers/$id': typeof AuthSettingsCustomersIdRoute
  '/settings/customers/create': typeof AuthSettingsCustomersCreateRoute
  '/settings/groups/$id': typeof AuthSettingsGroupsIdRoute
  '/settings/groups/create': typeof AuthSettingsGroupsCreateRoute
  '/settings/holidays/$id': typeof AuthSettingsHolidaysIdRoute
  '/settings/holidays/create': typeof AuthSettingsHolidaysCreateRoute
  '/settings/items/create': typeof AuthSettingsItemsCreateRoute
  '/settings/locations/$id': typeof AuthSettingsLocationsIdRoute
  '/settings/locations/create': typeof AuthSettingsLocationsCreateRoute
  '/settings/machines/$id': typeof AuthSettingsMachinesIdRoute
  '/settings/machines/create': typeof AuthSettingsMachinesCreateRoute
  '/settings/molds/$id': typeof AuthSettingsMoldsIdRoute
  '/settings/molds/create': typeof AuthSettingsMoldsCreateRoute
  '/settings/parties/$id': typeof AuthSettingsPartiesIdRoute
  '/settings/parties/create': typeof AuthSettingsPartiesCreateRoute
  '/settings/roles/$id': typeof AuthSettingsRolesIdRoute
  '/settings/roles/create': typeof AuthSettingsRolesCreateRoute
  '/settings/running-numbers/$id': typeof AuthSettingsRunningNumbersIdRoute
  '/settings/running-numbers/create': typeof AuthSettingsRunningNumbersCreateRoute
  '/settings/running-numbers/create-by-year': typeof AuthSettingsRunningNumbersCreateByYearRoute
  '/settings/suppliers/$id': typeof AuthSettingsSuppliersIdRoute
  '/settings/suppliers/create': typeof AuthSettingsSuppliersCreateRoute
  '/settings/users/$id': typeof AuthSettingsUsersIdRoute
  '/settings/users/create': typeof AuthSettingsUsersCreateRoute
  '/warehouse/inv1010/$id': typeof AuthWarehouseInv1010IdRoute
  '/warehouse/inv1010/create': typeof AuthWarehouseInv1010CreateRoute
  '/warehouse/inv1015/$id': typeof AuthWarehouseInv1015IdRoute
  '/warehouse/inv1015/create': typeof AuthWarehouseInv1015CreateRoute
  '/warehouse/inv1110/$id': typeof AuthWarehouseInv1110IdRoute
  '/warehouse/inv1120/$id': typeof AuthWarehouseInv1120IdRoute
  '/warehouse/inv1140/$id': typeof AuthWarehouseInv1140IdRoute
  '/warehouse/inv1140/create': typeof AuthWarehouseInv1140CreateRoute
  '/warehouse/inv1210/$id': typeof AuthWarehouseInv1210IdRoute
  '/warehouse/inv1210/create': typeof AuthWarehouseInv1210CreateRoute
  '/warehouse/inv1310/$id': typeof AuthWarehouseInv1310IdRoute
  '/warehouse/inv1310/create': typeof AuthWarehouseInv1310CreateRoute
  '/warehouse/inv2010/$id': typeof AuthWarehouseInv2010IdRoute
  '/warehouse/inv2010/create': typeof AuthWarehouseInv2010CreateRoute
  '/warehouse/inv2210/$id': typeof AuthWarehouseInv2210IdRoute
  '/warehouse/inv2210/create': typeof AuthWarehouseInv2210CreateRoute
  '/warehouse/inv2215/$id': typeof AuthWarehouseInv2215IdRoute
  '/warehouse/inv2215/create': typeof AuthWarehouseInv2215CreateRoute
  '/warehouse/inv2310/$id': typeof AuthWarehouseInv2310IdRoute
  '/warehouse/inv2310/create': typeof AuthWarehouseInv2310CreateRoute
  '/warehouse/inv3010/$id': typeof AuthWarehouseInv3010IdRoute
  '/warehouse/inv3010/create': typeof AuthWarehouseInv3010CreateRoute
  '/warehouse/inv3020/$id': typeof AuthWarehouseInv3020IdRoute
  '/warehouse/inv3020/create': typeof AuthWarehouseInv3020CreateRoute
  '/warehouse/inv3510/$id': typeof AuthWarehouseInv3510IdRoute
  '/warehouse/inv3510/create': typeof AuthWarehouseInv3510CreateRoute
  '/warehouse/inv4310/$id': typeof AuthWarehouseInv4310IdRoute
  '/warehouse/inv4310/create': typeof AuthWarehouseInv4310CreateRoute
  '/warehouse/inv5010/$id': typeof AuthWarehouseInv5010IdRoute
  '/warehouse/inv5010/create': typeof AuthWarehouseInv5010CreateRoute
  '/accounting/chart-of-accounts': typeof AuthAccountingChartOfAccountsIndexRoute
  '/accounting/fiscal-year': typeof AuthAccountingFiscalYearIndexRoute
  '/accounting/journal-entry': typeof AuthAccountingJournalEntryIndexRoute
  '/production/prd1010': typeof AuthProductionPrd1010IndexRoute
  '/production/prd1011': typeof AuthProductionPrd1011IndexRoute
  '/production/prd1015': typeof AuthProductionPrd1015IndexRoute
  '/production/prd1110': typeof AuthProductionPrd1110IndexRoute
  '/production/prd1210': typeof AuthProductionPrd1210IndexRoute
  '/production/prd2010': typeof AuthProductionPrd2010IndexRoute
  '/production/prd3010': typeof AuthProductionPrd3010IndexRoute
  '/production/prd3110': typeof AuthProductionPrd3110IndexRoute
  '/production/prd4010': typeof AuthProductionPrd4010IndexRoute
  '/production/prd4020': typeof AuthProductionPrd4020IndexRoute
  '/production/prd4030': typeof AuthProductionPrd4030IndexRoute
  '/production/wo1010': typeof AuthProductionWo1010IndexRoute
  '/production/wo1110': typeof AuthProductionWo1110IndexRoute
  '/production/wo1115': typeof AuthProductionWo1115IndexRoute
  '/production/wo1210': typeof AuthProductionWo1210IndexRoute
  '/production/wo3010': typeof AuthProductionWo3010IndexRoute
  '/production/wo9010': typeof AuthProductionWo9010IndexRoute
  '/purchase/bplus-sync': typeof AuthPurchaseBplusSyncIndexRoute
  '/purchase/po1010': typeof AuthPurchasePo1010IndexRoute
  '/purchase/po9010': typeof AuthPurchasePo9010IndexRoute
  '/purchase/po9020': typeof AuthPurchasePo9020IndexRoute
  '/purchase/po9030': typeof AuthPurchasePo9030IndexRoute
  '/purchase/problem': typeof AuthPurchaseProblemIndexRoute
  '/purchase/tracking': typeof AuthPurchaseTrackingIndexRoute
  '/qc/qc1010': typeof AuthQcQc1010IndexRoute
  '/qc/qc8010': typeof AuthQcQc8010IndexRoute
  '/qc/qc8015': typeof AuthQcQc8015IndexRoute
  '/qc/qc8030': typeof AuthQcQc8030IndexRoute
  '/qc/qc8110': typeof AuthQcQc8110IndexRoute
  '/qc/qc9010': typeof AuthQcQc9010IndexRoute
  '/sale/sale1010': typeof AuthSaleSale1010IndexRoute
  '/sale/sale1020': typeof AuthSaleSale1020IndexRoute
  '/sale/sale1030': typeof AuthSaleSale1030IndexRoute
  '/sale/sale1210': typeof AuthSaleSale1210IndexRoute
  '/sale/sale1220': typeof AuthSaleSale1220IndexRoute
  '/sale/sale1230': typeof AuthSaleSale1230IndexRoute
  '/sale/sale2310': typeof AuthSaleSale2310IndexRoute
  '/settings/customers': typeof AuthSettingsCustomersIndexRoute
  '/settings/groups': typeof AuthSettingsGroupsIndexRoute
  '/settings/holidays': typeof AuthSettingsHolidaysIndexRoute
  '/settings/items': typeof AuthSettingsItemsIndexRoute
  '/settings/locations': typeof AuthSettingsLocationsIndexRoute
  '/settings/machines': typeof AuthSettingsMachinesIndexRoute
  '/settings/molds': typeof AuthSettingsMoldsIndexRoute
  '/settings/parties': typeof AuthSettingsPartiesIndexRoute
  '/settings/roles': typeof AuthSettingsRolesIndexRoute
  '/settings/running-numbers': typeof AuthSettingsRunningNumbersIndexRoute
  '/settings/screen-capture': typeof AuthSettingsScreenCaptureIndexRoute
  '/settings/suppliers': typeof AuthSettingsSuppliersIndexRoute
  '/settings/users': typeof AuthSettingsUsersIndexRoute
  '/warehouse/dashboard': typeof AuthWarehouseDashboardIndexRoute
  '/warehouse/inv1010': typeof AuthWarehouseInv1010IndexRoute
  '/warehouse/inv1015': typeof AuthWarehouseInv1015IndexRoute
  '/warehouse/inv1110': typeof AuthWarehouseInv1110IndexRoute
  '/warehouse/inv1120': typeof AuthWarehouseInv1120IndexRoute
  '/warehouse/inv1140': typeof AuthWarehouseInv1140IndexRoute
  '/warehouse/inv1210': typeof AuthWarehouseInv1210IndexRoute
  '/warehouse/inv1310': typeof AuthWarehouseInv1310IndexRoute
  '/warehouse/inv2010': typeof AuthWarehouseInv2010IndexRoute
  '/warehouse/inv2210': typeof AuthWarehouseInv2210IndexRoute
  '/warehouse/inv2215': typeof AuthWarehouseInv2215IndexRoute
  '/warehouse/inv2310': typeof AuthWarehouseInv2310IndexRoute
  '/warehouse/inv3010': typeof AuthWarehouseInv3010IndexRoute
  '/warehouse/inv3020': typeof AuthWarehouseInv3020IndexRoute
  '/warehouse/inv3510': typeof AuthWarehouseInv3510IndexRoute
  '/warehouse/inv4010': typeof AuthWarehouseInv4010IndexRoute
  '/warehouse/inv4015': typeof AuthWarehouseInv4015IndexRoute
  '/warehouse/inv4020': typeof AuthWarehouseInv4020IndexRoute
  '/warehouse/inv4110': typeof AuthWarehouseInv4110IndexRoute
  '/warehouse/inv4210': typeof AuthWarehouseInv4210IndexRoute
  '/warehouse/inv4310': typeof AuthWarehouseInv4310IndexRoute
  '/warehouse/inv5010': typeof AuthWarehouseInv5010IndexRoute
  '/warehouse/inv9010': typeof AuthWarehouseInv9010IndexRoute
  '/warehouse/inv9020': typeof AuthWarehouseInv9020IndexRoute
  '/warehouse/inv9110': typeof AuthWarehouseInv9110IndexRoute
  '/warehouse/inv9120': typeof AuthWarehouseInv9120IndexRoute
  '/warehouse/inv9210': typeof AuthWarehouseInv9210IndexRoute
  '/accounting/chart-of-accounts/edit/$id': typeof AuthAccountingChartOfAccountsEditIdRoute
  '/accounting/journal-entry/edit/$id': typeof AuthAccountingJournalEntryEditIdRoute
  '/production/prd1010/create/$wsid': typeof AuthProductionPrd1010CreateWsidRoute
  '/production/prd1110/create/$wsid': typeof AuthProductionPrd1110CreateWsidRoute
  '/production/prd3110/edit/$id': typeof AuthProductionPrd3110EditIdRoute
  '/production/wo1010/edit/$id': typeof AuthProductionWo1010EditIdRoute
  '/production/wo1110/edit/$id': typeof AuthProductionWo1110EditIdRoute
  '/production/wo3010/edit/$id': typeof AuthProductionWo3010EditIdRoute
  '/purchase/po1010/edit/$id': typeof AuthPurchasePo1010EditIdRoute
  '/qc/qc8010/view/$id': typeof AuthQcQc8010ViewIdRoute
  '/qc/qc8110/edit/$id': typeof AuthQcQc8110EditIdRoute
  '/sale/sale1010/edit/$id': typeof AuthSaleSale1010EditIdRoute
  '/sale/sale1220/edit/$id': typeof AuthSaleSale1220EditIdRoute
  '/sale/sale2310/edit/$id': typeof AuthSaleSale2310EditIdRoute
  '/settings/customers/edit/$id': typeof AuthSettingsCustomersEditIdRoute
  '/settings/groups/edit/$id': typeof AuthSettingsGroupsEditIdRoute
  '/settings/holidays/edit/$id': typeof AuthSettingsHolidaysEditIdRouteWithChildren
  '/settings/items/edit/$id': typeof AuthSettingsItemsEditIdRoute
  '/settings/items/view/$id': typeof AuthSettingsItemsViewIdRoute
  '/settings/locations/edit/$id': typeof AuthSettingsLocationsEditIdRoute
  '/settings/machines/edit/$id': typeof AuthSettingsMachinesEditIdRouteWithChildren
  '/settings/molds/delete/$id': typeof AuthSettingsMoldsDeleteIdRoute
  '/settings/molds/edit/$id': typeof AuthSettingsMoldsEditIdRoute
  '/settings/parties/edit/$id': typeof AuthSettingsPartiesEditIdRoute
  '/settings/roles/edit/$id': typeof AuthSettingsRolesEditIdRouteWithChildren
  '/settings/running-numbers/edit/$id': typeof AuthSettingsRunningNumbersEditIdRoute
  '/settings/suppliers/edit/$id': typeof AuthSettingsSuppliersEditIdRoute
  '/settings/users/edit/$id': typeof AuthSettingsUsersEditIdRoute
  '/warehouse/inv1010/edit/$id': typeof AuthWarehouseInv1010EditIdRoute
  '/warehouse/inv1015/edit/$id': typeof AuthWarehouseInv1015EditIdRoute
  '/warehouse/inv1140/edit/$id': typeof AuthWarehouseInv1140EditIdRoute
  '/warehouse/inv1210/edit/$id': typeof AuthWarehouseInv1210EditIdRoute
  '/warehouse/inv1310/edit/$id': typeof AuthWarehouseInv1310EditIdRoute
  '/warehouse/inv2010/edit/$id': typeof AuthWarehouseInv2010EditIdRoute
  '/warehouse/inv2210/edit/$id': typeof AuthWarehouseInv2210EditIdRoute
  '/warehouse/inv2215/edit/$id': typeof AuthWarehouseInv2215EditIdRoute
  '/warehouse/inv2310/edit/$id': typeof AuthWarehouseInv2310EditIdRoute
  '/warehouse/inv3010/edit/$id': typeof AuthWarehouseInv3010EditIdRoute
  '/warehouse/inv3020/edit/$id': typeof AuthWarehouseInv3020EditIdRoute
  '/warehouse/inv3510/$id/completion': typeof AuthWarehouseInv3510IdCompletionRoute
  '/warehouse/inv3510/$id/progress': typeof AuthWarehouseInv3510IdProgressRoute
  '/warehouse/inv3510/$id/variances': typeof AuthWarehouseInv3510IdVariancesRoute
  '/warehouse/inv3510/$id/zones': typeof AuthWarehouseInv3510IdZonesRoute
  '/warehouse/inv3510/edit/$id': typeof AuthWarehouseInv3510EditIdRoute
  '/warehouse/inv4310/$id/override-items': typeof AuthWarehouseInv4310IdOverrideItemsRoute
  '/warehouse/inv4310/adjust/$id': typeof AuthWarehouseInv4310AdjustIdRoute
  '/settings/items/$itemId': typeof AuthSettingsItemsItemIdIndexRoute
  '/production/prd1010/edit/$wsid/$id': typeof AuthProductionPrd1010EditWsidIdRoute
  '/production/prd1110/edit/$wsid/$id': typeof AuthProductionPrd1110EditWsidIdRoute
  '/purchase/tracking/receive/$id/$itemId': typeof AuthPurchaseTrackingReceiveIdItemIdRoute
  '/settings/holidays/edit/$id/delete': typeof AuthSettingsHolidaysEditIdDeleteRoute
  '/settings/items/$itemId/boms/$id': typeof AuthSettingsItemsItemIdBomsIdRoute
  '/settings/items/$itemId/boms/create': typeof AuthSettingsItemsItemIdBomsCreateRoute
  '/settings/machines/edit/$id/delete': typeof AuthSettingsMachinesEditIdDeleteRoute
  '/settings/roles/edit/$id/delete': typeof AuthSettingsRolesEditIdDeleteRoute
  '/production/wo1210/index/hold/$id': typeof AuthProductionWo1210IndexHoldIdRoute
  '/qc/qc1010/index/hold/$id': typeof AuthQcQc1010IndexHoldIdRoute
  '/qc/qc8030/index/result/$id': typeof AuthQcQc8030IndexResultIdRoute
  '/settings/customers/index/delete/$id': typeof AuthSettingsCustomersIndexDeleteIdRoute
  '/settings/locations/index/delete/$id': typeof AuthSettingsLocationsIndexDeleteIdRoute
  '/settings/parties/index/delete/$id': typeof AuthSettingsPartiesIndexDeleteIdRoute
  '/settings/running-numbers/index/delete/$id': typeof AuthSettingsRunningNumbersIndexDeleteIdRoute
  '/settings/suppliers/index/delete/$id': typeof AuthSettingsSuppliersIndexDeleteIdRoute
  '/settings/users/index/delete/$id': typeof AuthSettingsUsersIndexDeleteIdRoute
  '/settings/items/$itemId/boms/edit/$id': typeof AuthSettingsItemsItemIdBomsEditIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/change-password': typeof AuthChangePasswordRoute
  '/_auth/home': typeof AuthHomeRoute
  '/_auth/no-permission': typeof AuthNoPermissionRoute
  '/_auth/testrun/': typeof AuthTestrunIndexRoute
  '/_auth/user-messages/': typeof AuthUserMessagesIndexRoute
  '/_auth/accounting/chart-of-accounts/create': typeof AuthAccountingChartOfAccountsCreateRoute
  '/_auth/accounting/fiscal-year/$id': typeof AuthAccountingFiscalYearIdRoute
  '/_auth/accounting/fiscal-year/create': typeof AuthAccountingFiscalYearCreateRoute
  '/_auth/accounting/journal-entry/$id': typeof AuthAccountingJournalEntryIdRoute
  '/_auth/accounting/journal-entry/create': typeof AuthAccountingJournalEntryCreateRoute
  '/_auth/accounting/reports/general-ledger': typeof AuthAccountingReportsGeneralLedgerRoute
  '/_auth/accounting/reports/trial-balance': typeof AuthAccountingReportsTrialBalanceRoute
  '/_auth/production/prd1210/$id': typeof AuthProductionPrd1210IdRoute
  '/_auth/production/prd3010/$id': typeof AuthProductionPrd3010IdRoute
  '/_auth/production/prd3110/$id': typeof AuthProductionPrd3110IdRoute
  '/_auth/production/prd4010/$id': typeof AuthProductionPrd4010IdRoute
  '/_auth/production/wo1010/$id': typeof AuthProductionWo1010IdRoute
  '/_auth/production/wo1010/create': typeof AuthProductionWo1010CreateRoute
  '/_auth/production/wo1110/$id': typeof AuthProductionWo1110IdRoute
  '/_auth/production/wo3010/$id': typeof AuthProductionWo3010IdRoute
  '/_auth/production/wo3010/create': typeof AuthProductionWo3010CreateRoute
  '/_auth/purchase/po1010/$id': typeof AuthPurchasePo1010IdRoute
  '/_auth/purchase/po1010/create': typeof AuthPurchasePo1010CreateRoute
  '/_auth/qc/qc8010/$id': typeof AuthQcQc8010IdRoute
  '/_auth/qc/qc8010/create': typeof AuthQcQc8010CreateRoute
  '/_auth/qc/qc8015/$id': typeof AuthQcQc8015IdRoute
  '/_auth/qc/qc8110/$id': typeof AuthQcQc8110IdRoute
  '/_auth/qc/qc8110/create': typeof AuthQcQc8110CreateRoute
  '/_auth/sale/sale1010/$id': typeof AuthSaleSale1010IdRoute
  '/_auth/sale/sale1010/create': typeof AuthSaleSale1010CreateRoute
  '/_auth/sale/sale1220/$id': typeof AuthSaleSale1220IdRoute
  '/_auth/sale/sale1220/create': typeof AuthSaleSale1220CreateRoute
  '/_auth/sale/sale1230/$id': typeof AuthSaleSale1230IdRoute
  '/_auth/sale/sale2310/$id': typeof AuthSaleSale2310IdRoute
  '/_auth/sale/sale2310/create': typeof AuthSaleSale2310CreateRoute
  '/_auth/settings/customers/$id': typeof AuthSettingsCustomersIdRoute
  '/_auth/settings/customers/create': typeof AuthSettingsCustomersCreateRoute
  '/_auth/settings/groups/$id': typeof AuthSettingsGroupsIdRoute
  '/_auth/settings/groups/create': typeof AuthSettingsGroupsCreateRoute
  '/_auth/settings/holidays/$id': typeof AuthSettingsHolidaysIdRoute
  '/_auth/settings/holidays/create': typeof AuthSettingsHolidaysCreateRoute
  '/_auth/settings/items/create': typeof AuthSettingsItemsCreateRoute
  '/_auth/settings/locations/$id': typeof AuthSettingsLocationsIdRoute
  '/_auth/settings/locations/create': typeof AuthSettingsLocationsCreateRoute
  '/_auth/settings/machines/$id': typeof AuthSettingsMachinesIdRoute
  '/_auth/settings/machines/create': typeof AuthSettingsMachinesCreateRoute
  '/_auth/settings/molds/$id': typeof AuthSettingsMoldsIdRoute
  '/_auth/settings/molds/create': typeof AuthSettingsMoldsCreateRoute
  '/_auth/settings/parties/$id': typeof AuthSettingsPartiesIdRoute
  '/_auth/settings/parties/create': typeof AuthSettingsPartiesCreateRoute
  '/_auth/settings/roles/$id': typeof AuthSettingsRolesIdRoute
  '/_auth/settings/roles/create': typeof AuthSettingsRolesCreateRoute
  '/_auth/settings/running-numbers/$id': typeof AuthSettingsRunningNumbersIdRoute
  '/_auth/settings/running-numbers/create': typeof AuthSettingsRunningNumbersCreateRoute
  '/_auth/settings/running-numbers/create-by-year': typeof AuthSettingsRunningNumbersCreateByYearRoute
  '/_auth/settings/suppliers/$id': typeof AuthSettingsSuppliersIdRoute
  '/_auth/settings/suppliers/create': typeof AuthSettingsSuppliersCreateRoute
  '/_auth/settings/users/$id': typeof AuthSettingsUsersIdRoute
  '/_auth/settings/users/create': typeof AuthSettingsUsersCreateRoute
  '/_auth/warehouse/inv1010/$id': typeof AuthWarehouseInv1010IdRoute
  '/_auth/warehouse/inv1010/create': typeof AuthWarehouseInv1010CreateRoute
  '/_auth/warehouse/inv1015/$id': typeof AuthWarehouseInv1015IdRoute
  '/_auth/warehouse/inv1015/create': typeof AuthWarehouseInv1015CreateRoute
  '/_auth/warehouse/inv1110/$id': typeof AuthWarehouseInv1110IdRoute
  '/_auth/warehouse/inv1120/$id': typeof AuthWarehouseInv1120IdRoute
  '/_auth/warehouse/inv1140/$id': typeof AuthWarehouseInv1140IdRoute
  '/_auth/warehouse/inv1140/create': typeof AuthWarehouseInv1140CreateRoute
  '/_auth/warehouse/inv1210/$id': typeof AuthWarehouseInv1210IdRoute
  '/_auth/warehouse/inv1210/create': typeof AuthWarehouseInv1210CreateRoute
  '/_auth/warehouse/inv1310/$id': typeof AuthWarehouseInv1310IdRoute
  '/_auth/warehouse/inv1310/create': typeof AuthWarehouseInv1310CreateRoute
  '/_auth/warehouse/inv2010/$id': typeof AuthWarehouseInv2010IdRoute
  '/_auth/warehouse/inv2010/create': typeof AuthWarehouseInv2010CreateRoute
  '/_auth/warehouse/inv2210/$id': typeof AuthWarehouseInv2210IdRoute
  '/_auth/warehouse/inv2210/create': typeof AuthWarehouseInv2210CreateRoute
  '/_auth/warehouse/inv2215/$id': typeof AuthWarehouseInv2215IdRoute
  '/_auth/warehouse/inv2215/create': typeof AuthWarehouseInv2215CreateRoute
  '/_auth/warehouse/inv2310/$id': typeof AuthWarehouseInv2310IdRoute
  '/_auth/warehouse/inv2310/create': typeof AuthWarehouseInv2310CreateRoute
  '/_auth/warehouse/inv3010/$id': typeof AuthWarehouseInv3010IdRoute
  '/_auth/warehouse/inv3010/create': typeof AuthWarehouseInv3010CreateRoute
  '/_auth/warehouse/inv3020/$id': typeof AuthWarehouseInv3020IdRoute
  '/_auth/warehouse/inv3020/create': typeof AuthWarehouseInv3020CreateRoute
  '/_auth/warehouse/inv3510/$id': typeof AuthWarehouseInv3510IdRoute
  '/_auth/warehouse/inv3510/create': typeof AuthWarehouseInv3510CreateRoute
  '/_auth/warehouse/inv4310/$id': typeof AuthWarehouseInv4310IdRoute
  '/_auth/warehouse/inv4310/create': typeof AuthWarehouseInv4310CreateRoute
  '/_auth/warehouse/inv5010/$id': typeof AuthWarehouseInv5010IdRoute
  '/_auth/warehouse/inv5010/create': typeof AuthWarehouseInv5010CreateRoute
  '/_auth/accounting/chart-of-accounts/': typeof AuthAccountingChartOfAccountsIndexRoute
  '/_auth/accounting/fiscal-year/': typeof AuthAccountingFiscalYearIndexRoute
  '/_auth/accounting/journal-entry/': typeof AuthAccountingJournalEntryIndexRoute
  '/_auth/production/prd1010/': typeof AuthProductionPrd1010IndexRoute
  '/_auth/production/prd1011/': typeof AuthProductionPrd1011IndexRoute
  '/_auth/production/prd1015/': typeof AuthProductionPrd1015IndexRoute
  '/_auth/production/prd1110/': typeof AuthProductionPrd1110IndexRoute
  '/_auth/production/prd1210/': typeof AuthProductionPrd1210IndexRoute
  '/_auth/production/prd2010/': typeof AuthProductionPrd2010IndexRoute
  '/_auth/production/prd3010/': typeof AuthProductionPrd3010IndexRoute
  '/_auth/production/prd3110/': typeof AuthProductionPrd3110IndexRoute
  '/_auth/production/prd4010/': typeof AuthProductionPrd4010IndexRoute
  '/_auth/production/prd4020/': typeof AuthProductionPrd4020IndexRoute
  '/_auth/production/prd4030/': typeof AuthProductionPrd4030IndexRoute
  '/_auth/production/wo1010/': typeof AuthProductionWo1010IndexRoute
  '/_auth/production/wo1110/': typeof AuthProductionWo1110IndexRoute
  '/_auth/production/wo1115/': typeof AuthProductionWo1115IndexRoute
  '/_auth/production/wo1210/': typeof AuthProductionWo1210IndexRoute
  '/_auth/production/wo3010/': typeof AuthProductionWo3010IndexRoute
  '/_auth/production/wo9010/': typeof AuthProductionWo9010IndexRoute
  '/_auth/purchase/bplus-sync/': typeof AuthPurchaseBplusSyncIndexRoute
  '/_auth/purchase/po1010/': typeof AuthPurchasePo1010IndexRoute
  '/_auth/purchase/po9010/': typeof AuthPurchasePo9010IndexRoute
  '/_auth/purchase/po9020/': typeof AuthPurchasePo9020IndexRoute
  '/_auth/purchase/po9030/': typeof AuthPurchasePo9030IndexRoute
  '/_auth/purchase/problem/': typeof AuthPurchaseProblemIndexRoute
  '/_auth/purchase/tracking/': typeof AuthPurchaseTrackingIndexRoute
  '/_auth/qc/qc1010/': typeof AuthQcQc1010IndexRoute
  '/_auth/qc/qc8010/': typeof AuthQcQc8010IndexRoute
  '/_auth/qc/qc8015/': typeof AuthQcQc8015IndexRoute
  '/_auth/qc/qc8030/': typeof AuthQcQc8030IndexRoute
  '/_auth/qc/qc8110/': typeof AuthQcQc8110IndexRoute
  '/_auth/qc/qc9010/': typeof AuthQcQc9010IndexRoute
  '/_auth/sale/sale1010/': typeof AuthSaleSale1010IndexRoute
  '/_auth/sale/sale1020/': typeof AuthSaleSale1020IndexRoute
  '/_auth/sale/sale1030/': typeof AuthSaleSale1030IndexRoute
  '/_auth/sale/sale1210/': typeof AuthSaleSale1210IndexRoute
  '/_auth/sale/sale1220/': typeof AuthSaleSale1220IndexRoute
  '/_auth/sale/sale1230/': typeof AuthSaleSale1230IndexRoute
  '/_auth/sale/sale2310/': typeof AuthSaleSale2310IndexRoute
  '/_auth/settings/customers/': typeof AuthSettingsCustomersIndexRoute
  '/_auth/settings/groups/': typeof AuthSettingsGroupsIndexRoute
  '/_auth/settings/holidays/': typeof AuthSettingsHolidaysIndexRoute
  '/_auth/settings/items/': typeof AuthSettingsItemsIndexRoute
  '/_auth/settings/locations/': typeof AuthSettingsLocationsIndexRoute
  '/_auth/settings/machines/': typeof AuthSettingsMachinesIndexRoute
  '/_auth/settings/molds/': typeof AuthSettingsMoldsIndexRoute
  '/_auth/settings/parties/': typeof AuthSettingsPartiesIndexRoute
  '/_auth/settings/roles/': typeof AuthSettingsRolesIndexRoute
  '/_auth/settings/running-numbers/': typeof AuthSettingsRunningNumbersIndexRoute
  '/_auth/settings/screen-capture/': typeof AuthSettingsScreenCaptureIndexRoute
  '/_auth/settings/suppliers/': typeof AuthSettingsSuppliersIndexRoute
  '/_auth/settings/users/': typeof AuthSettingsUsersIndexRoute
  '/_auth/warehouse/dashboard/': typeof AuthWarehouseDashboardIndexRoute
  '/_auth/warehouse/inv1010/': typeof AuthWarehouseInv1010IndexRoute
  '/_auth/warehouse/inv1015/': typeof AuthWarehouseInv1015IndexRoute
  '/_auth/warehouse/inv1110/': typeof AuthWarehouseInv1110IndexRoute
  '/_auth/warehouse/inv1120/': typeof AuthWarehouseInv1120IndexRoute
  '/_auth/warehouse/inv1140/': typeof AuthWarehouseInv1140IndexRoute
  '/_auth/warehouse/inv1210/': typeof AuthWarehouseInv1210IndexRoute
  '/_auth/warehouse/inv1310/': typeof AuthWarehouseInv1310IndexRoute
  '/_auth/warehouse/inv2010/': typeof AuthWarehouseInv2010IndexRoute
  '/_auth/warehouse/inv2210/': typeof AuthWarehouseInv2210IndexRoute
  '/_auth/warehouse/inv2215/': typeof AuthWarehouseInv2215IndexRoute
  '/_auth/warehouse/inv2310/': typeof AuthWarehouseInv2310IndexRoute
  '/_auth/warehouse/inv3010/': typeof AuthWarehouseInv3010IndexRoute
  '/_auth/warehouse/inv3020/': typeof AuthWarehouseInv3020IndexRoute
  '/_auth/warehouse/inv3510/': typeof AuthWarehouseInv3510IndexRoute
  '/_auth/warehouse/inv4010/': typeof AuthWarehouseInv4010IndexRoute
  '/_auth/warehouse/inv4015/': typeof AuthWarehouseInv4015IndexRoute
  '/_auth/warehouse/inv4020/': typeof AuthWarehouseInv4020IndexRoute
  '/_auth/warehouse/inv4110/': typeof AuthWarehouseInv4110IndexRoute
  '/_auth/warehouse/inv4210/': typeof AuthWarehouseInv4210IndexRoute
  '/_auth/warehouse/inv4310/': typeof AuthWarehouseInv4310IndexRoute
  '/_auth/warehouse/inv5010/': typeof AuthWarehouseInv5010IndexRoute
  '/_auth/warehouse/inv9010/': typeof AuthWarehouseInv9010IndexRoute
  '/_auth/warehouse/inv9020/': typeof AuthWarehouseInv9020IndexRoute
  '/_auth/warehouse/inv9110/': typeof AuthWarehouseInv9110IndexRoute
  '/_auth/warehouse/inv9120/': typeof AuthWarehouseInv9120IndexRoute
  '/_auth/warehouse/inv9210/': typeof AuthWarehouseInv9210IndexRoute
  '/_auth/accounting/chart-of-accounts/edit/$id': typeof AuthAccountingChartOfAccountsEditIdRoute
  '/_auth/accounting/journal-entry/edit/$id': typeof AuthAccountingJournalEntryEditIdRoute
  '/_auth/production/prd1010/create/$wsid': typeof AuthProductionPrd1010CreateWsidRoute
  '/_auth/production/prd1110/create/$wsid': typeof AuthProductionPrd1110CreateWsidRoute
  '/_auth/production/prd3110/edit/$id': typeof AuthProductionPrd3110EditIdRoute
  '/_auth/production/wo1010/edit/$id': typeof AuthProductionWo1010EditIdRoute
  '/_auth/production/wo1110/edit/$id': typeof AuthProductionWo1110EditIdRoute
  '/_auth/production/wo3010/edit/$id': typeof AuthProductionWo3010EditIdRoute
  '/_auth/purchase/po1010/edit/$id': typeof AuthPurchasePo1010EditIdRoute
  '/_auth/qc/qc8010/view/$id': typeof AuthQcQc8010ViewIdRoute
  '/_auth/qc/qc8110/edit/$id': typeof AuthQcQc8110EditIdRoute
  '/_auth/sale/sale1010/edit/$id': typeof AuthSaleSale1010EditIdRoute
  '/_auth/sale/sale1220/edit/$id': typeof AuthSaleSale1220EditIdRoute
  '/_auth/sale/sale2310/edit/$id': typeof AuthSaleSale2310EditIdRoute
  '/_auth/settings/customers/edit/$id': typeof AuthSettingsCustomersEditIdRoute
  '/_auth/settings/groups/edit/$id': typeof AuthSettingsGroupsEditIdRoute
  '/_auth/settings/holidays/edit/$id': typeof AuthSettingsHolidaysEditIdRouteWithChildren
  '/_auth/settings/items/edit/$id': typeof AuthSettingsItemsEditIdRoute
  '/_auth/settings/items/view/$id': typeof AuthSettingsItemsViewIdRoute
  '/_auth/settings/locations/edit/$id': typeof AuthSettingsLocationsEditIdRoute
  '/_auth/settings/machines/edit/$id': typeof AuthSettingsMachinesEditIdRouteWithChildren
  '/_auth/settings/molds/delete/$id': typeof AuthSettingsMoldsDeleteIdRoute
  '/_auth/settings/molds/edit/$id': typeof AuthSettingsMoldsEditIdRoute
  '/_auth/settings/parties/edit/$id': typeof AuthSettingsPartiesEditIdRoute
  '/_auth/settings/roles/edit/$id': typeof AuthSettingsRolesEditIdRouteWithChildren
  '/_auth/settings/running-numbers/edit/$id': typeof AuthSettingsRunningNumbersEditIdRoute
  '/_auth/settings/suppliers/edit/$id': typeof AuthSettingsSuppliersEditIdRoute
  '/_auth/settings/users/edit/$id': typeof AuthSettingsUsersEditIdRoute
  '/_auth/warehouse/inv1010/edit/$id': typeof AuthWarehouseInv1010EditIdRoute
  '/_auth/warehouse/inv1015/edit/$id': typeof AuthWarehouseInv1015EditIdRoute
  '/_auth/warehouse/inv1140/edit/$id': typeof AuthWarehouseInv1140EditIdRoute
  '/_auth/warehouse/inv1210/edit/$id': typeof AuthWarehouseInv1210EditIdRoute
  '/_auth/warehouse/inv1310/edit/$id': typeof AuthWarehouseInv1310EditIdRoute
  '/_auth/warehouse/inv2010/edit/$id': typeof AuthWarehouseInv2010EditIdRoute
  '/_auth/warehouse/inv2210/edit/$id': typeof AuthWarehouseInv2210EditIdRoute
  '/_auth/warehouse/inv2215/edit/$id': typeof AuthWarehouseInv2215EditIdRoute
  '/_auth/warehouse/inv2310/edit/$id': typeof AuthWarehouseInv2310EditIdRoute
  '/_auth/warehouse/inv3010/edit/$id': typeof AuthWarehouseInv3010EditIdRoute
  '/_auth/warehouse/inv3020/edit/$id': typeof AuthWarehouseInv3020EditIdRoute
  '/_auth/warehouse/inv3510/$id_/completion': typeof AuthWarehouseInv3510IdCompletionRoute
  '/_auth/warehouse/inv3510/$id_/progress': typeof AuthWarehouseInv3510IdProgressRoute
  '/_auth/warehouse/inv3510/$id_/variances': typeof AuthWarehouseInv3510IdVariancesRoute
  '/_auth/warehouse/inv3510/$id_/zones': typeof AuthWarehouseInv3510IdZonesRoute
  '/_auth/warehouse/inv3510/edit/$id': typeof AuthWarehouseInv3510EditIdRoute
  '/_auth/warehouse/inv4310/$id_/override-items': typeof AuthWarehouseInv4310IdOverrideItemsRoute
  '/_auth/warehouse/inv4310/adjust/$id': typeof AuthWarehouseInv4310AdjustIdRoute
  '/_auth/settings/items/$itemId/': typeof AuthSettingsItemsItemIdIndexRoute
  '/_auth/production/prd1010/edit/$wsid/$id': typeof AuthProductionPrd1010EditWsidIdRoute
  '/_auth/production/prd1110/edit/$wsid/$id': typeof AuthProductionPrd1110EditWsidIdRoute
  '/_auth/purchase/tracking/receive/$id/$itemId': typeof AuthPurchaseTrackingReceiveIdItemIdRoute
  '/_auth/settings/holidays/edit/$id/delete': typeof AuthSettingsHolidaysEditIdDeleteRoute
  '/_auth/settings/items/$itemId/boms/$id': typeof AuthSettingsItemsItemIdBomsIdRoute
  '/_auth/settings/items/$itemId/boms/create': typeof AuthSettingsItemsItemIdBomsCreateRoute
  '/_auth/settings/machines/edit/$id/delete': typeof AuthSettingsMachinesEditIdDeleteRoute
  '/_auth/settings/roles/edit/$id/delete': typeof AuthSettingsRolesEditIdDeleteRoute
  '/_auth/production/wo1210/index/hold/$id': typeof AuthProductionWo1210IndexHoldIdRoute
  '/_auth/qc/qc1010/index/hold/$id': typeof AuthQcQc1010IndexHoldIdRoute
  '/_auth/qc/qc8030/index/result/$id': typeof AuthQcQc8030IndexResultIdRoute
  '/_auth/settings/customers/index/delete/$id': typeof AuthSettingsCustomersIndexDeleteIdRoute
  '/_auth/settings/locations/index/delete/$id': typeof AuthSettingsLocationsIndexDeleteIdRoute
  '/_auth/settings/parties/index/delete/$id': typeof AuthSettingsPartiesIndexDeleteIdRoute
  '/_auth/settings/running-numbers/index/delete/$id': typeof AuthSettingsRunningNumbersIndexDeleteIdRoute
  '/_auth/settings/suppliers/index/delete/$id': typeof AuthSettingsSuppliersIndexDeleteIdRoute
  '/_auth/settings/users/index/delete/$id': typeof AuthSettingsUsersIndexDeleteIdRoute
  '/_auth/settings/items/$itemId/boms/edit/$id': typeof AuthSettingsItemsItemIdBomsEditIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/login'
    | '/change-password'
    | '/home'
    | '/no-permission'
    | '/testrun'
    | '/user-messages'
    | '/accounting/chart-of-accounts/create'
    | '/accounting/fiscal-year/$id'
    | '/accounting/fiscal-year/create'
    | '/accounting/journal-entry/$id'
    | '/accounting/journal-entry/create'
    | '/accounting/reports/general-ledger'
    | '/accounting/reports/trial-balance'
    | '/production/prd1210/$id'
    | '/production/prd3010/$id'
    | '/production/prd3110/$id'
    | '/production/prd4010/$id'
    | '/production/wo1010/$id'
    | '/production/wo1010/create'
    | '/production/wo1110/$id'
    | '/production/wo3010/$id'
    | '/production/wo3010/create'
    | '/purchase/po1010/$id'
    | '/purchase/po1010/create'
    | '/qc/qc8010/$id'
    | '/qc/qc8010/create'
    | '/qc/qc8015/$id'
    | '/qc/qc8110/$id'
    | '/qc/qc8110/create'
    | '/sale/sale1010/$id'
    | '/sale/sale1010/create'
    | '/sale/sale1220/$id'
    | '/sale/sale1220/create'
    | '/sale/sale1230/$id'
    | '/sale/sale2310/$id'
    | '/sale/sale2310/create'
    | '/settings/customers/$id'
    | '/settings/customers/create'
    | '/settings/groups/$id'
    | '/settings/groups/create'
    | '/settings/holidays/$id'
    | '/settings/holidays/create'
    | '/settings/items/create'
    | '/settings/locations/$id'
    | '/settings/locations/create'
    | '/settings/machines/$id'
    | '/settings/machines/create'
    | '/settings/molds/$id'
    | '/settings/molds/create'
    | '/settings/parties/$id'
    | '/settings/parties/create'
    | '/settings/roles/$id'
    | '/settings/roles/create'
    | '/settings/running-numbers/$id'
    | '/settings/running-numbers/create'
    | '/settings/running-numbers/create-by-year'
    | '/settings/suppliers/$id'
    | '/settings/suppliers/create'
    | '/settings/users/$id'
    | '/settings/users/create'
    | '/warehouse/inv1010/$id'
    | '/warehouse/inv1010/create'
    | '/warehouse/inv1015/$id'
    | '/warehouse/inv1015/create'
    | '/warehouse/inv1110/$id'
    | '/warehouse/inv1120/$id'
    | '/warehouse/inv1140/$id'
    | '/warehouse/inv1140/create'
    | '/warehouse/inv1210/$id'
    | '/warehouse/inv1210/create'
    | '/warehouse/inv1310/$id'
    | '/warehouse/inv1310/create'
    | '/warehouse/inv2010/$id'
    | '/warehouse/inv2010/create'
    | '/warehouse/inv2210/$id'
    | '/warehouse/inv2210/create'
    | '/warehouse/inv2215/$id'
    | '/warehouse/inv2215/create'
    | '/warehouse/inv2310/$id'
    | '/warehouse/inv2310/create'
    | '/warehouse/inv3010/$id'
    | '/warehouse/inv3010/create'
    | '/warehouse/inv3020/$id'
    | '/warehouse/inv3020/create'
    | '/warehouse/inv3510/$id'
    | '/warehouse/inv3510/create'
    | '/warehouse/inv4310/$id'
    | '/warehouse/inv4310/create'
    | '/warehouse/inv5010/$id'
    | '/warehouse/inv5010/create'
    | '/accounting/chart-of-accounts'
    | '/accounting/fiscal-year'
    | '/accounting/journal-entry'
    | '/production/prd1010'
    | '/production/prd1011'
    | '/production/prd1015'
    | '/production/prd1110'
    | '/production/prd1210'
    | '/production/prd2010'
    | '/production/prd3010'
    | '/production/prd3110'
    | '/production/prd4010'
    | '/production/prd4020'
    | '/production/prd4030'
    | '/production/wo1010'
    | '/production/wo1110'
    | '/production/wo1115'
    | '/production/wo1210'
    | '/production/wo3010'
    | '/production/wo9010'
    | '/purchase/bplus-sync'
    | '/purchase/po1010'
    | '/purchase/po9010'
    | '/purchase/po9020'
    | '/purchase/po9030'
    | '/purchase/problem'
    | '/purchase/tracking'
    | '/qc/qc1010'
    | '/qc/qc8010'
    | '/qc/qc8015'
    | '/qc/qc8030'
    | '/qc/qc8110'
    | '/qc/qc9010'
    | '/sale/sale1010'
    | '/sale/sale1020'
    | '/sale/sale1030'
    | '/sale/sale1210'
    | '/sale/sale1220'
    | '/sale/sale1230'
    | '/sale/sale2310'
    | '/settings/customers'
    | '/settings/groups'
    | '/settings/holidays'
    | '/settings/items'
    | '/settings/locations'
    | '/settings/machines'
    | '/settings/molds'
    | '/settings/parties'
    | '/settings/roles'
    | '/settings/running-numbers'
    | '/settings/screen-capture'
    | '/settings/suppliers'
    | '/settings/users'
    | '/warehouse/dashboard'
    | '/warehouse/inv1010'
    | '/warehouse/inv1015'
    | '/warehouse/inv1110'
    | '/warehouse/inv1120'
    | '/warehouse/inv1140'
    | '/warehouse/inv1210'
    | '/warehouse/inv1310'
    | '/warehouse/inv2010'
    | '/warehouse/inv2210'
    | '/warehouse/inv2215'
    | '/warehouse/inv2310'
    | '/warehouse/inv3010'
    | '/warehouse/inv3020'
    | '/warehouse/inv3510'
    | '/warehouse/inv4010'
    | '/warehouse/inv4015'
    | '/warehouse/inv4020'
    | '/warehouse/inv4110'
    | '/warehouse/inv4210'
    | '/warehouse/inv4310'
    | '/warehouse/inv5010'
    | '/warehouse/inv9010'
    | '/warehouse/inv9020'
    | '/warehouse/inv9110'
    | '/warehouse/inv9120'
    | '/warehouse/inv9210'
    | '/accounting/chart-of-accounts/edit/$id'
    | '/accounting/journal-entry/edit/$id'
    | '/production/prd1010/create/$wsid'
    | '/production/prd1110/create/$wsid'
    | '/production/prd3110/edit/$id'
    | '/production/wo1010/edit/$id'
    | '/production/wo1110/edit/$id'
    | '/production/wo3010/edit/$id'
    | '/purchase/po1010/edit/$id'
    | '/qc/qc8010/view/$id'
    | '/qc/qc8110/edit/$id'
    | '/sale/sale1010/edit/$id'
    | '/sale/sale1220/edit/$id'
    | '/sale/sale2310/edit/$id'
    | '/settings/customers/edit/$id'
    | '/settings/groups/edit/$id'
    | '/settings/holidays/edit/$id'
    | '/settings/items/edit/$id'
    | '/settings/items/view/$id'
    | '/settings/locations/edit/$id'
    | '/settings/machines/edit/$id'
    | '/settings/molds/delete/$id'
    | '/settings/molds/edit/$id'
    | '/settings/parties/edit/$id'
    | '/settings/roles/edit/$id'
    | '/settings/running-numbers/edit/$id'
    | '/settings/suppliers/edit/$id'
    | '/settings/users/edit/$id'
    | '/warehouse/inv1010/edit/$id'
    | '/warehouse/inv1015/edit/$id'
    | '/warehouse/inv1140/edit/$id'
    | '/warehouse/inv1210/edit/$id'
    | '/warehouse/inv1310/edit/$id'
    | '/warehouse/inv2010/edit/$id'
    | '/warehouse/inv2210/edit/$id'
    | '/warehouse/inv2215/edit/$id'
    | '/warehouse/inv2310/edit/$id'
    | '/warehouse/inv3010/edit/$id'
    | '/warehouse/inv3020/edit/$id'
    | '/warehouse/inv3510/$id/completion'
    | '/warehouse/inv3510/$id/progress'
    | '/warehouse/inv3510/$id/variances'
    | '/warehouse/inv3510/$id/zones'
    | '/warehouse/inv3510/edit/$id'
    | '/warehouse/inv4310/$id/override-items'
    | '/warehouse/inv4310/adjust/$id'
    | '/settings/items/$itemId'
    | '/production/prd1010/edit/$wsid/$id'
    | '/production/prd1110/edit/$wsid/$id'
    | '/purchase/tracking/receive/$id/$itemId'
    | '/settings/holidays/edit/$id/delete'
    | '/settings/items/$itemId/boms/$id'
    | '/settings/items/$itemId/boms/create'
    | '/settings/machines/edit/$id/delete'
    | '/settings/roles/edit/$id/delete'
    | '/production/wo1210/index/hold/$id'
    | '/qc/qc1010/index/hold/$id'
    | '/qc/qc8030/index/result/$id'
    | '/settings/customers/index/delete/$id'
    | '/settings/locations/index/delete/$id'
    | '/settings/parties/index/delete/$id'
    | '/settings/running-numbers/index/delete/$id'
    | '/settings/suppliers/index/delete/$id'
    | '/settings/users/index/delete/$id'
    | '/settings/items/$itemId/boms/edit/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/login'
    | '/change-password'
    | '/home'
    | '/no-permission'
    | '/testrun'
    | '/user-messages'
    | '/accounting/chart-of-accounts/create'
    | '/accounting/fiscal-year/$id'
    | '/accounting/fiscal-year/create'
    | '/accounting/journal-entry/$id'
    | '/accounting/journal-entry/create'
    | '/accounting/reports/general-ledger'
    | '/accounting/reports/trial-balance'
    | '/production/prd1210/$id'
    | '/production/prd3010/$id'
    | '/production/prd3110/$id'
    | '/production/prd4010/$id'
    | '/production/wo1010/$id'
    | '/production/wo1010/create'
    | '/production/wo1110/$id'
    | '/production/wo3010/$id'
    | '/production/wo3010/create'
    | '/purchase/po1010/$id'
    | '/purchase/po1010/create'
    | '/qc/qc8010/$id'
    | '/qc/qc8010/create'
    | '/qc/qc8015/$id'
    | '/qc/qc8110/$id'
    | '/qc/qc8110/create'
    | '/sale/sale1010/$id'
    | '/sale/sale1010/create'
    | '/sale/sale1220/$id'
    | '/sale/sale1220/create'
    | '/sale/sale1230/$id'
    | '/sale/sale2310/$id'
    | '/sale/sale2310/create'
    | '/settings/customers/$id'
    | '/settings/customers/create'
    | '/settings/groups/$id'
    | '/settings/groups/create'
    | '/settings/holidays/$id'
    | '/settings/holidays/create'
    | '/settings/items/create'
    | '/settings/locations/$id'
    | '/settings/locations/create'
    | '/settings/machines/$id'
    | '/settings/machines/create'
    | '/settings/molds/$id'
    | '/settings/molds/create'
    | '/settings/parties/$id'
    | '/settings/parties/create'
    | '/settings/roles/$id'
    | '/settings/roles/create'
    | '/settings/running-numbers/$id'
    | '/settings/running-numbers/create'
    | '/settings/running-numbers/create-by-year'
    | '/settings/suppliers/$id'
    | '/settings/suppliers/create'
    | '/settings/users/$id'
    | '/settings/users/create'
    | '/warehouse/inv1010/$id'
    | '/warehouse/inv1010/create'
    | '/warehouse/inv1015/$id'
    | '/warehouse/inv1015/create'
    | '/warehouse/inv1110/$id'
    | '/warehouse/inv1120/$id'
    | '/warehouse/inv1140/$id'
    | '/warehouse/inv1140/create'
    | '/warehouse/inv1210/$id'
    | '/warehouse/inv1210/create'
    | '/warehouse/inv1310/$id'
    | '/warehouse/inv1310/create'
    | '/warehouse/inv2010/$id'
    | '/warehouse/inv2010/create'
    | '/warehouse/inv2210/$id'
    | '/warehouse/inv2210/create'
    | '/warehouse/inv2215/$id'
    | '/warehouse/inv2215/create'
    | '/warehouse/inv2310/$id'
    | '/warehouse/inv2310/create'
    | '/warehouse/inv3010/$id'
    | '/warehouse/inv3010/create'
    | '/warehouse/inv3020/$id'
    | '/warehouse/inv3020/create'
    | '/warehouse/inv3510/$id'
    | '/warehouse/inv3510/create'
    | '/warehouse/inv4310/$id'
    | '/warehouse/inv4310/create'
    | '/warehouse/inv5010/$id'
    | '/warehouse/inv5010/create'
    | '/accounting/chart-of-accounts'
    | '/accounting/fiscal-year'
    | '/accounting/journal-entry'
    | '/production/prd1010'
    | '/production/prd1011'
    | '/production/prd1015'
    | '/production/prd1110'
    | '/production/prd1210'
    | '/production/prd2010'
    | '/production/prd3010'
    | '/production/prd3110'
    | '/production/prd4010'
    | '/production/prd4020'
    | '/production/prd4030'
    | '/production/wo1010'
    | '/production/wo1110'
    | '/production/wo1115'
    | '/production/wo1210'
    | '/production/wo3010'
    | '/production/wo9010'
    | '/purchase/bplus-sync'
    | '/purchase/po1010'
    | '/purchase/po9010'
    | '/purchase/po9020'
    | '/purchase/po9030'
    | '/purchase/problem'
    | '/purchase/tracking'
    | '/qc/qc1010'
    | '/qc/qc8010'
    | '/qc/qc8015'
    | '/qc/qc8030'
    | '/qc/qc8110'
    | '/qc/qc9010'
    | '/sale/sale1010'
    | '/sale/sale1020'
    | '/sale/sale1030'
    | '/sale/sale1210'
    | '/sale/sale1220'
    | '/sale/sale1230'
    | '/sale/sale2310'
    | '/settings/customers'
    | '/settings/groups'
    | '/settings/holidays'
    | '/settings/items'
    | '/settings/locations'
    | '/settings/machines'
    | '/settings/molds'
    | '/settings/parties'
    | '/settings/roles'
    | '/settings/running-numbers'
    | '/settings/screen-capture'
    | '/settings/suppliers'
    | '/settings/users'
    | '/warehouse/dashboard'
    | '/warehouse/inv1010'
    | '/warehouse/inv1015'
    | '/warehouse/inv1110'
    | '/warehouse/inv1120'
    | '/warehouse/inv1140'
    | '/warehouse/inv1210'
    | '/warehouse/inv1310'
    | '/warehouse/inv2010'
    | '/warehouse/inv2210'
    | '/warehouse/inv2215'
    | '/warehouse/inv2310'
    | '/warehouse/inv3010'
    | '/warehouse/inv3020'
    | '/warehouse/inv3510'
    | '/warehouse/inv4010'
    | '/warehouse/inv4015'
    | '/warehouse/inv4020'
    | '/warehouse/inv4110'
    | '/warehouse/inv4210'
    | '/warehouse/inv4310'
    | '/warehouse/inv5010'
    | '/warehouse/inv9010'
    | '/warehouse/inv9020'
    | '/warehouse/inv9110'
    | '/warehouse/inv9120'
    | '/warehouse/inv9210'
    | '/accounting/chart-of-accounts/edit/$id'
    | '/accounting/journal-entry/edit/$id'
    | '/production/prd1010/create/$wsid'
    | '/production/prd1110/create/$wsid'
    | '/production/prd3110/edit/$id'
    | '/production/wo1010/edit/$id'
    | '/production/wo1110/edit/$id'
    | '/production/wo3010/edit/$id'
    | '/purchase/po1010/edit/$id'
    | '/qc/qc8010/view/$id'
    | '/qc/qc8110/edit/$id'
    | '/sale/sale1010/edit/$id'
    | '/sale/sale1220/edit/$id'
    | '/sale/sale2310/edit/$id'
    | '/settings/customers/edit/$id'
    | '/settings/groups/edit/$id'
    | '/settings/holidays/edit/$id'
    | '/settings/items/edit/$id'
    | '/settings/items/view/$id'
    | '/settings/locations/edit/$id'
    | '/settings/machines/edit/$id'
    | '/settings/molds/delete/$id'
    | '/settings/molds/edit/$id'
    | '/settings/parties/edit/$id'
    | '/settings/roles/edit/$id'
    | '/settings/running-numbers/edit/$id'
    | '/settings/suppliers/edit/$id'
    | '/settings/users/edit/$id'
    | '/warehouse/inv1010/edit/$id'
    | '/warehouse/inv1015/edit/$id'
    | '/warehouse/inv1140/edit/$id'
    | '/warehouse/inv1210/edit/$id'
    | '/warehouse/inv1310/edit/$id'
    | '/warehouse/inv2010/edit/$id'
    | '/warehouse/inv2210/edit/$id'
    | '/warehouse/inv2215/edit/$id'
    | '/warehouse/inv2310/edit/$id'
    | '/warehouse/inv3010/edit/$id'
    | '/warehouse/inv3020/edit/$id'
    | '/warehouse/inv3510/$id/completion'
    | '/warehouse/inv3510/$id/progress'
    | '/warehouse/inv3510/$id/variances'
    | '/warehouse/inv3510/$id/zones'
    | '/warehouse/inv3510/edit/$id'
    | '/warehouse/inv4310/$id/override-items'
    | '/warehouse/inv4310/adjust/$id'
    | '/settings/items/$itemId'
    | '/production/prd1010/edit/$wsid/$id'
    | '/production/prd1110/edit/$wsid/$id'
    | '/purchase/tracking/receive/$id/$itemId'
    | '/settings/holidays/edit/$id/delete'
    | '/settings/items/$itemId/boms/$id'
    | '/settings/items/$itemId/boms/create'
    | '/settings/machines/edit/$id/delete'
    | '/settings/roles/edit/$id/delete'
    | '/production/wo1210/index/hold/$id'
    | '/qc/qc1010/index/hold/$id'
    | '/qc/qc8030/index/result/$id'
    | '/settings/customers/index/delete/$id'
    | '/settings/locations/index/delete/$id'
    | '/settings/parties/index/delete/$id'
    | '/settings/running-numbers/index/delete/$id'
    | '/settings/suppliers/index/delete/$id'
    | '/settings/users/index/delete/$id'
    | '/settings/items/$itemId/boms/edit/$id'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/change-password'
    | '/_auth/home'
    | '/_auth/no-permission'
    | '/_auth/testrun/'
    | '/_auth/user-messages/'
    | '/_auth/accounting/chart-of-accounts/create'
    | '/_auth/accounting/fiscal-year/$id'
    | '/_auth/accounting/fiscal-year/create'
    | '/_auth/accounting/journal-entry/$id'
    | '/_auth/accounting/journal-entry/create'
    | '/_auth/accounting/reports/general-ledger'
    | '/_auth/accounting/reports/trial-balance'
    | '/_auth/production/prd1210/$id'
    | '/_auth/production/prd3010/$id'
    | '/_auth/production/prd3110/$id'
    | '/_auth/production/prd4010/$id'
    | '/_auth/production/wo1010/$id'
    | '/_auth/production/wo1010/create'
    | '/_auth/production/wo1110/$id'
    | '/_auth/production/wo3010/$id'
    | '/_auth/production/wo3010/create'
    | '/_auth/purchase/po1010/$id'
    | '/_auth/purchase/po1010/create'
    | '/_auth/qc/qc8010/$id'
    | '/_auth/qc/qc8010/create'
    | '/_auth/qc/qc8015/$id'
    | '/_auth/qc/qc8110/$id'
    | '/_auth/qc/qc8110/create'
    | '/_auth/sale/sale1010/$id'
    | '/_auth/sale/sale1010/create'
    | '/_auth/sale/sale1220/$id'
    | '/_auth/sale/sale1220/create'
    | '/_auth/sale/sale1230/$id'
    | '/_auth/sale/sale2310/$id'
    | '/_auth/sale/sale2310/create'
    | '/_auth/settings/customers/$id'
    | '/_auth/settings/customers/create'
    | '/_auth/settings/groups/$id'
    | '/_auth/settings/groups/create'
    | '/_auth/settings/holidays/$id'
    | '/_auth/settings/holidays/create'
    | '/_auth/settings/items/create'
    | '/_auth/settings/locations/$id'
    | '/_auth/settings/locations/create'
    | '/_auth/settings/machines/$id'
    | '/_auth/settings/machines/create'
    | '/_auth/settings/molds/$id'
    | '/_auth/settings/molds/create'
    | '/_auth/settings/parties/$id'
    | '/_auth/settings/parties/create'
    | '/_auth/settings/roles/$id'
    | '/_auth/settings/roles/create'
    | '/_auth/settings/running-numbers/$id'
    | '/_auth/settings/running-numbers/create'
    | '/_auth/settings/running-numbers/create-by-year'
    | '/_auth/settings/suppliers/$id'
    | '/_auth/settings/suppliers/create'
    | '/_auth/settings/users/$id'
    | '/_auth/settings/users/create'
    | '/_auth/warehouse/inv1010/$id'
    | '/_auth/warehouse/inv1010/create'
    | '/_auth/warehouse/inv1015/$id'
    | '/_auth/warehouse/inv1015/create'
    | '/_auth/warehouse/inv1110/$id'
    | '/_auth/warehouse/inv1120/$id'
    | '/_auth/warehouse/inv1140/$id'
    | '/_auth/warehouse/inv1140/create'
    | '/_auth/warehouse/inv1210/$id'
    | '/_auth/warehouse/inv1210/create'
    | '/_auth/warehouse/inv1310/$id'
    | '/_auth/warehouse/inv1310/create'
    | '/_auth/warehouse/inv2010/$id'
    | '/_auth/warehouse/inv2010/create'
    | '/_auth/warehouse/inv2210/$id'
    | '/_auth/warehouse/inv2210/create'
    | '/_auth/warehouse/inv2215/$id'
    | '/_auth/warehouse/inv2215/create'
    | '/_auth/warehouse/inv2310/$id'
    | '/_auth/warehouse/inv2310/create'
    | '/_auth/warehouse/inv3010/$id'
    | '/_auth/warehouse/inv3010/create'
    | '/_auth/warehouse/inv3020/$id'
    | '/_auth/warehouse/inv3020/create'
    | '/_auth/warehouse/inv3510/$id'
    | '/_auth/warehouse/inv3510/create'
    | '/_auth/warehouse/inv4310/$id'
    | '/_auth/warehouse/inv4310/create'
    | '/_auth/warehouse/inv5010/$id'
    | '/_auth/warehouse/inv5010/create'
    | '/_auth/accounting/chart-of-accounts/'
    | '/_auth/accounting/fiscal-year/'
    | '/_auth/accounting/journal-entry/'
    | '/_auth/production/prd1010/'
    | '/_auth/production/prd1011/'
    | '/_auth/production/prd1015/'
    | '/_auth/production/prd1110/'
    | '/_auth/production/prd1210/'
    | '/_auth/production/prd2010/'
    | '/_auth/production/prd3010/'
    | '/_auth/production/prd3110/'
    | '/_auth/production/prd4010/'
    | '/_auth/production/prd4020/'
    | '/_auth/production/prd4030/'
    | '/_auth/production/wo1010/'
    | '/_auth/production/wo1110/'
    | '/_auth/production/wo1115/'
    | '/_auth/production/wo1210/'
    | '/_auth/production/wo3010/'
    | '/_auth/production/wo9010/'
    | '/_auth/purchase/bplus-sync/'
    | '/_auth/purchase/po1010/'
    | '/_auth/purchase/po9010/'
    | '/_auth/purchase/po9020/'
    | '/_auth/purchase/po9030/'
    | '/_auth/purchase/problem/'
    | '/_auth/purchase/tracking/'
    | '/_auth/qc/qc1010/'
    | '/_auth/qc/qc8010/'
    | '/_auth/qc/qc8015/'
    | '/_auth/qc/qc8030/'
    | '/_auth/qc/qc8110/'
    | '/_auth/qc/qc9010/'
    | '/_auth/sale/sale1010/'
    | '/_auth/sale/sale1020/'
    | '/_auth/sale/sale1030/'
    | '/_auth/sale/sale1210/'
    | '/_auth/sale/sale1220/'
    | '/_auth/sale/sale1230/'
    | '/_auth/sale/sale2310/'
    | '/_auth/settings/customers/'
    | '/_auth/settings/groups/'
    | '/_auth/settings/holidays/'
    | '/_auth/settings/items/'
    | '/_auth/settings/locations/'
    | '/_auth/settings/machines/'
    | '/_auth/settings/molds/'
    | '/_auth/settings/parties/'
    | '/_auth/settings/roles/'
    | '/_auth/settings/running-numbers/'
    | '/_auth/settings/screen-capture/'
    | '/_auth/settings/suppliers/'
    | '/_auth/settings/users/'
    | '/_auth/warehouse/dashboard/'
    | '/_auth/warehouse/inv1010/'
    | '/_auth/warehouse/inv1015/'
    | '/_auth/warehouse/inv1110/'
    | '/_auth/warehouse/inv1120/'
    | '/_auth/warehouse/inv1140/'
    | '/_auth/warehouse/inv1210/'
    | '/_auth/warehouse/inv1310/'
    | '/_auth/warehouse/inv2010/'
    | '/_auth/warehouse/inv2210/'
    | '/_auth/warehouse/inv2215/'
    | '/_auth/warehouse/inv2310/'
    | '/_auth/warehouse/inv3010/'
    | '/_auth/warehouse/inv3020/'
    | '/_auth/warehouse/inv3510/'
    | '/_auth/warehouse/inv4010/'
    | '/_auth/warehouse/inv4015/'
    | '/_auth/warehouse/inv4020/'
    | '/_auth/warehouse/inv4110/'
    | '/_auth/warehouse/inv4210/'
    | '/_auth/warehouse/inv4310/'
    | '/_auth/warehouse/inv5010/'
    | '/_auth/warehouse/inv9010/'
    | '/_auth/warehouse/inv9020/'
    | '/_auth/warehouse/inv9110/'
    | '/_auth/warehouse/inv9120/'
    | '/_auth/warehouse/inv9210/'
    | '/_auth/accounting/chart-of-accounts/edit/$id'
    | '/_auth/accounting/journal-entry/edit/$id'
    | '/_auth/production/prd1010/create/$wsid'
    | '/_auth/production/prd1110/create/$wsid'
    | '/_auth/production/prd3110/edit/$id'
    | '/_auth/production/wo1010/edit/$id'
    | '/_auth/production/wo1110/edit/$id'
    | '/_auth/production/wo3010/edit/$id'
    | '/_auth/purchase/po1010/edit/$id'
    | '/_auth/qc/qc8010/view/$id'
    | '/_auth/qc/qc8110/edit/$id'
    | '/_auth/sale/sale1010/edit/$id'
    | '/_auth/sale/sale1220/edit/$id'
    | '/_auth/sale/sale2310/edit/$id'
    | '/_auth/settings/customers/edit/$id'
    | '/_auth/settings/groups/edit/$id'
    | '/_auth/settings/holidays/edit/$id'
    | '/_auth/settings/items/edit/$id'
    | '/_auth/settings/items/view/$id'
    | '/_auth/settings/locations/edit/$id'
    | '/_auth/settings/machines/edit/$id'
    | '/_auth/settings/molds/delete/$id'
    | '/_auth/settings/molds/edit/$id'
    | '/_auth/settings/parties/edit/$id'
    | '/_auth/settings/roles/edit/$id'
    | '/_auth/settings/running-numbers/edit/$id'
    | '/_auth/settings/suppliers/edit/$id'
    | '/_auth/settings/users/edit/$id'
    | '/_auth/warehouse/inv1010/edit/$id'
    | '/_auth/warehouse/inv1015/edit/$id'
    | '/_auth/warehouse/inv1140/edit/$id'
    | '/_auth/warehouse/inv1210/edit/$id'
    | '/_auth/warehouse/inv1310/edit/$id'
    | '/_auth/warehouse/inv2010/edit/$id'
    | '/_auth/warehouse/inv2210/edit/$id'
    | '/_auth/warehouse/inv2215/edit/$id'
    | '/_auth/warehouse/inv2310/edit/$id'
    | '/_auth/warehouse/inv3010/edit/$id'
    | '/_auth/warehouse/inv3020/edit/$id'
    | '/_auth/warehouse/inv3510/$id_/completion'
    | '/_auth/warehouse/inv3510/$id_/progress'
    | '/_auth/warehouse/inv3510/$id_/variances'
    | '/_auth/warehouse/inv3510/$id_/zones'
    | '/_auth/warehouse/inv3510/edit/$id'
    | '/_auth/warehouse/inv4310/$id_/override-items'
    | '/_auth/warehouse/inv4310/adjust/$id'
    | '/_auth/settings/items/$itemId/'
    | '/_auth/production/prd1010/edit/$wsid/$id'
    | '/_auth/production/prd1110/edit/$wsid/$id'
    | '/_auth/purchase/tracking/receive/$id/$itemId'
    | '/_auth/settings/holidays/edit/$id/delete'
    | '/_auth/settings/items/$itemId/boms/$id'
    | '/_auth/settings/items/$itemId/boms/create'
    | '/_auth/settings/machines/edit/$id/delete'
    | '/_auth/settings/roles/edit/$id/delete'
    | '/_auth/production/wo1210/index/hold/$id'
    | '/_auth/qc/qc1010/index/hold/$id'
    | '/_auth/qc/qc8030/index/result/$id'
    | '/_auth/settings/customers/index/delete/$id'
    | '/_auth/settings/locations/index/delete/$id'
    | '/_auth/settings/parties/index/delete/$id'
    | '/_auth/settings/running-numbers/index/delete/$id'
    | '/_auth/settings/suppliers/index/delete/$id'
    | '/_auth/settings/users/index/delete/$id'
    | '/_auth/settings/items/$itemId/boms/edit/$id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/login"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/change-password",
        "/_auth/home",
        "/_auth/no-permission",
        "/_auth/testrun/",
        "/_auth/user-messages/",
        "/_auth/accounting/chart-of-accounts/create",
        "/_auth/accounting/fiscal-year/$id",
        "/_auth/accounting/fiscal-year/create",
        "/_auth/accounting/journal-entry/$id",
        "/_auth/accounting/journal-entry/create",
        "/_auth/accounting/reports/general-ledger",
        "/_auth/accounting/reports/trial-balance",
        "/_auth/production/prd1210/$id",
        "/_auth/production/prd3010/$id",
        "/_auth/production/prd3110/$id",
        "/_auth/production/prd4010/$id",
        "/_auth/production/wo1010/$id",
        "/_auth/production/wo1010/create",
        "/_auth/production/wo1110/$id",
        "/_auth/production/wo3010/$id",
        "/_auth/production/wo3010/create",
        "/_auth/purchase/po1010/$id",
        "/_auth/purchase/po1010/create",
        "/_auth/qc/qc8010/$id",
        "/_auth/qc/qc8010/create",
        "/_auth/qc/qc8015/$id",
        "/_auth/qc/qc8110/$id",
        "/_auth/qc/qc8110/create",
        "/_auth/sale/sale1010/$id",
        "/_auth/sale/sale1010/create",
        "/_auth/sale/sale1220/$id",
        "/_auth/sale/sale1220/create",
        "/_auth/sale/sale1230/$id",
        "/_auth/sale/sale2310/$id",
        "/_auth/sale/sale2310/create",
        "/_auth/settings/customers/$id",
        "/_auth/settings/customers/create",
        "/_auth/settings/groups/$id",
        "/_auth/settings/groups/create",
        "/_auth/settings/holidays/$id",
        "/_auth/settings/holidays/create",
        "/_auth/settings/items/create",
        "/_auth/settings/locations/$id",
        "/_auth/settings/locations/create",
        "/_auth/settings/machines/$id",
        "/_auth/settings/machines/create",
        "/_auth/settings/molds/$id",
        "/_auth/settings/molds/create",
        "/_auth/settings/parties/$id",
        "/_auth/settings/parties/create",
        "/_auth/settings/roles/$id",
        "/_auth/settings/roles/create",
        "/_auth/settings/running-numbers/$id",
        "/_auth/settings/running-numbers/create",
        "/_auth/settings/running-numbers/create-by-year",
        "/_auth/settings/suppliers/$id",
        "/_auth/settings/suppliers/create",
        "/_auth/settings/users/$id",
        "/_auth/settings/users/create",
        "/_auth/warehouse/inv1010/$id",
        "/_auth/warehouse/inv1010/create",
        "/_auth/warehouse/inv1015/$id",
        "/_auth/warehouse/inv1015/create",
        "/_auth/warehouse/inv1110/$id",
        "/_auth/warehouse/inv1120/$id",
        "/_auth/warehouse/inv1140/$id",
        "/_auth/warehouse/inv1140/create",
        "/_auth/warehouse/inv1210/$id",
        "/_auth/warehouse/inv1210/create",
        "/_auth/warehouse/inv1310/$id",
        "/_auth/warehouse/inv1310/create",
        "/_auth/warehouse/inv2010/$id",
        "/_auth/warehouse/inv2010/create",
        "/_auth/warehouse/inv2210/$id",
        "/_auth/warehouse/inv2210/create",
        "/_auth/warehouse/inv2215/$id",
        "/_auth/warehouse/inv2215/create",
        "/_auth/warehouse/inv2310/$id",
        "/_auth/warehouse/inv2310/create",
        "/_auth/warehouse/inv3010/$id",
        "/_auth/warehouse/inv3010/create",
        "/_auth/warehouse/inv3020/$id",
        "/_auth/warehouse/inv3020/create",
        "/_auth/warehouse/inv3510/$id",
        "/_auth/warehouse/inv3510/create",
        "/_auth/warehouse/inv4310/$id",
        "/_auth/warehouse/inv4310/create",
        "/_auth/warehouse/inv5010/$id",
        "/_auth/warehouse/inv5010/create",
        "/_auth/accounting/chart-of-accounts/",
        "/_auth/accounting/fiscal-year/",
        "/_auth/accounting/journal-entry/",
        "/_auth/production/prd1010/",
        "/_auth/production/prd1011/",
        "/_auth/production/prd1015/",
        "/_auth/production/prd1110/",
        "/_auth/production/prd1210/",
        "/_auth/production/prd2010/",
        "/_auth/production/prd3010/",
        "/_auth/production/prd3110/",
        "/_auth/production/prd4010/",
        "/_auth/production/prd4020/",
        "/_auth/production/prd4030/",
        "/_auth/production/wo1010/",
        "/_auth/production/wo1110/",
        "/_auth/production/wo1115/",
        "/_auth/production/wo1210/",
        "/_auth/production/wo3010/",
        "/_auth/production/wo9010/",
        "/_auth/purchase/bplus-sync/",
        "/_auth/purchase/po1010/",
        "/_auth/purchase/po9010/",
        "/_auth/purchase/po9020/",
        "/_auth/purchase/po9030/",
        "/_auth/purchase/problem/",
        "/_auth/purchase/tracking/",
        "/_auth/qc/qc1010/",
        "/_auth/qc/qc8010/",
        "/_auth/qc/qc8015/",
        "/_auth/qc/qc8030/",
        "/_auth/qc/qc8110/",
        "/_auth/qc/qc9010/",
        "/_auth/sale/sale1010/",
        "/_auth/sale/sale1020/",
        "/_auth/sale/sale1030/",
        "/_auth/sale/sale1210/",
        "/_auth/sale/sale1220/",
        "/_auth/sale/sale1230/",
        "/_auth/sale/sale2310/",
        "/_auth/settings/customers/",
        "/_auth/settings/groups/",
        "/_auth/settings/holidays/",
        "/_auth/settings/items/",
        "/_auth/settings/locations/",
        "/_auth/settings/machines/",
        "/_auth/settings/molds/",
        "/_auth/settings/parties/",
        "/_auth/settings/roles/",
        "/_auth/settings/running-numbers/",
        "/_auth/settings/screen-capture/",
        "/_auth/settings/suppliers/",
        "/_auth/settings/users/",
        "/_auth/warehouse/dashboard/",
        "/_auth/warehouse/inv1010/",
        "/_auth/warehouse/inv1015/",
        "/_auth/warehouse/inv1110/",
        "/_auth/warehouse/inv1120/",
        "/_auth/warehouse/inv1140/",
        "/_auth/warehouse/inv1210/",
        "/_auth/warehouse/inv1310/",
        "/_auth/warehouse/inv2010/",
        "/_auth/warehouse/inv2210/",
        "/_auth/warehouse/inv2215/",
        "/_auth/warehouse/inv2310/",
        "/_auth/warehouse/inv3010/",
        "/_auth/warehouse/inv3020/",
        "/_auth/warehouse/inv3510/",
        "/_auth/warehouse/inv4010/",
        "/_auth/warehouse/inv4015/",
        "/_auth/warehouse/inv4020/",
        "/_auth/warehouse/inv4110/",
        "/_auth/warehouse/inv4210/",
        "/_auth/warehouse/inv4310/",
        "/_auth/warehouse/inv5010/",
        "/_auth/warehouse/inv9010/",
        "/_auth/warehouse/inv9020/",
        "/_auth/warehouse/inv9110/",
        "/_auth/warehouse/inv9120/",
        "/_auth/warehouse/inv9210/",
        "/_auth/accounting/chart-of-accounts/edit/$id",
        "/_auth/accounting/journal-entry/edit/$id",
        "/_auth/production/prd1010/create/$wsid",
        "/_auth/production/prd1110/create/$wsid",
        "/_auth/production/prd3110/edit/$id",
        "/_auth/production/wo1010/edit/$id",
        "/_auth/production/wo1110/edit/$id",
        "/_auth/production/wo3010/edit/$id",
        "/_auth/purchase/po1010/edit/$id",
        "/_auth/qc/qc8010/view/$id",
        "/_auth/qc/qc8110/edit/$id",
        "/_auth/sale/sale1010/edit/$id",
        "/_auth/sale/sale1220/edit/$id",
        "/_auth/sale/sale2310/edit/$id",
        "/_auth/settings/customers/edit/$id",
        "/_auth/settings/groups/edit/$id",
        "/_auth/settings/holidays/edit/$id",
        "/_auth/settings/items/edit/$id",
        "/_auth/settings/items/view/$id",
        "/_auth/settings/locations/edit/$id",
        "/_auth/settings/machines/edit/$id",
        "/_auth/settings/molds/delete/$id",
        "/_auth/settings/molds/edit/$id",
        "/_auth/settings/parties/edit/$id",
        "/_auth/settings/roles/edit/$id",
        "/_auth/settings/running-numbers/edit/$id",
        "/_auth/settings/suppliers/edit/$id",
        "/_auth/settings/users/edit/$id",
        "/_auth/warehouse/inv1010/edit/$id",
        "/_auth/warehouse/inv1015/edit/$id",
        "/_auth/warehouse/inv1140/edit/$id",
        "/_auth/warehouse/inv1210/edit/$id",
        "/_auth/warehouse/inv1310/edit/$id",
        "/_auth/warehouse/inv2010/edit/$id",
        "/_auth/warehouse/inv2210/edit/$id",
        "/_auth/warehouse/inv2215/edit/$id",
        "/_auth/warehouse/inv2310/edit/$id",
        "/_auth/warehouse/inv3010/edit/$id",
        "/_auth/warehouse/inv3020/edit/$id",
        "/_auth/warehouse/inv3510/$id_/completion",
        "/_auth/warehouse/inv3510/$id_/progress",
        "/_auth/warehouse/inv3510/$id_/variances",
        "/_auth/warehouse/inv3510/$id_/zones",
        "/_auth/warehouse/inv3510/edit/$id",
        "/_auth/warehouse/inv4310/$id_/override-items",
        "/_auth/warehouse/inv4310/adjust/$id",
        "/_auth/settings/items/$itemId/",
        "/_auth/production/prd1010/edit/$wsid/$id",
        "/_auth/production/prd1110/edit/$wsid/$id",
        "/_auth/purchase/tracking/receive/$id/$itemId",
        "/_auth/settings/items/$itemId/boms/$id",
        "/_auth/settings/items/$itemId/boms/create",
        "/_auth/production/wo1210/index/hold/$id",
        "/_auth/qc/qc1010/index/hold/$id",
        "/_auth/qc/qc8030/index/result/$id",
        "/_auth/settings/customers/index/delete/$id",
        "/_auth/settings/locations/index/delete/$id",
        "/_auth/settings/parties/index/delete/$id",
        "/_auth/settings/running-numbers/index/delete/$id",
        "/_auth/settings/suppliers/index/delete/$id",
        "/_auth/settings/users/index/delete/$id",
        "/_auth/settings/items/$itemId/boms/edit/$id"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/_auth/change-password": {
      "filePath": "_auth/change-password.tsx",
      "parent": "/_auth"
    },
    "/_auth/home": {
      "filePath": "_auth/home.tsx",
      "parent": "/_auth"
    },
    "/_auth/no-permission": {
      "filePath": "_auth/no-permission.tsx",
      "parent": "/_auth"
    },
    "/_auth/testrun/": {
      "filePath": "_auth/testrun/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/user-messages/": {
      "filePath": "_auth/user-messages/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/accounting/chart-of-accounts/create": {
      "filePath": "_auth/accounting/chart-of-accounts/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/accounting/fiscal-year/$id": {
      "filePath": "_auth/accounting/fiscal-year/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/accounting/fiscal-year/create": {
      "filePath": "_auth/accounting/fiscal-year/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/accounting/journal-entry/$id": {
      "filePath": "_auth/accounting/journal-entry/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/accounting/journal-entry/create": {
      "filePath": "_auth/accounting/journal-entry/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/accounting/reports/general-ledger": {
      "filePath": "_auth/accounting/reports/general-ledger.tsx",
      "parent": "/_auth"
    },
    "/_auth/accounting/reports/trial-balance": {
      "filePath": "_auth/accounting/reports/trial-balance.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd1210/$id": {
      "filePath": "_auth/production/prd1210/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd3010/$id": {
      "filePath": "_auth/production/prd3010/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd3110/$id": {
      "filePath": "_auth/production/prd3110/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd4010/$id": {
      "filePath": "_auth/production/prd4010/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/wo1010/$id": {
      "filePath": "_auth/production/wo1010/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/wo1010/create": {
      "filePath": "_auth/production/wo1010/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/wo1110/$id": {
      "filePath": "_auth/production/wo1110/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/wo3010/$id": {
      "filePath": "_auth/production/wo3010/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/wo3010/create": {
      "filePath": "_auth/production/wo3010/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/purchase/po1010/$id": {
      "filePath": "_auth/purchase/po1010/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/purchase/po1010/create": {
      "filePath": "_auth/purchase/po1010/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/qc/qc8010/$id": {
      "filePath": "_auth/qc/qc8010/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/qc/qc8010/create": {
      "filePath": "_auth/qc/qc8010/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/qc/qc8015/$id": {
      "filePath": "_auth/qc/qc8015/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/qc/qc8110/$id": {
      "filePath": "_auth/qc/qc8110/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/qc/qc8110/create": {
      "filePath": "_auth/qc/qc8110/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale1010/$id": {
      "filePath": "_auth/sale/sale1010/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale1010/create": {
      "filePath": "_auth/sale/sale1010/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale1220/$id": {
      "filePath": "_auth/sale/sale1220/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale1220/create": {
      "filePath": "_auth/sale/sale1220/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale1230/$id": {
      "filePath": "_auth/sale/sale1230/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale2310/$id": {
      "filePath": "_auth/sale/sale2310/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale2310/create": {
      "filePath": "_auth/sale/sale2310/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/customers/$id": {
      "filePath": "_auth/settings/customers/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/customers/create": {
      "filePath": "_auth/settings/customers/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/groups/$id": {
      "filePath": "_auth/settings/groups/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/groups/create": {
      "filePath": "_auth/settings/groups/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/holidays/$id": {
      "filePath": "_auth/settings/holidays/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/holidays/create": {
      "filePath": "_auth/settings/holidays/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/items/create": {
      "filePath": "_auth/settings/items/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/locations/$id": {
      "filePath": "_auth/settings/locations/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/locations/create": {
      "filePath": "_auth/settings/locations/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/machines/$id": {
      "filePath": "_auth/settings/machines/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/machines/create": {
      "filePath": "_auth/settings/machines/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/molds/$id": {
      "filePath": "_auth/settings/molds/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/molds/create": {
      "filePath": "_auth/settings/molds/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/parties/$id": {
      "filePath": "_auth/settings/parties/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/parties/create": {
      "filePath": "_auth/settings/parties/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/roles/$id": {
      "filePath": "_auth/settings/roles/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/roles/create": {
      "filePath": "_auth/settings/roles/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/running-numbers/$id": {
      "filePath": "_auth/settings/running-numbers/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/running-numbers/create": {
      "filePath": "_auth/settings/running-numbers/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/running-numbers/create-by-year": {
      "filePath": "_auth/settings/running-numbers/create-by-year.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/suppliers/$id": {
      "filePath": "_auth/settings/suppliers/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/suppliers/create": {
      "filePath": "_auth/settings/suppliers/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/users/$id": {
      "filePath": "_auth/settings/users/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/users/create": {
      "filePath": "_auth/settings/users/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1010/$id": {
      "filePath": "_auth/warehouse/inv1010/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1010/create": {
      "filePath": "_auth/warehouse/inv1010/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1015/$id": {
      "filePath": "_auth/warehouse/inv1015/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1015/create": {
      "filePath": "_auth/warehouse/inv1015/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1110/$id": {
      "filePath": "_auth/warehouse/inv1110/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1120/$id": {
      "filePath": "_auth/warehouse/inv1120/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1140/$id": {
      "filePath": "_auth/warehouse/inv1140/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1140/create": {
      "filePath": "_auth/warehouse/inv1140/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1210/$id": {
      "filePath": "_auth/warehouse/inv1210/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1210/create": {
      "filePath": "_auth/warehouse/inv1210/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1310/$id": {
      "filePath": "_auth/warehouse/inv1310/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1310/create": {
      "filePath": "_auth/warehouse/inv1310/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv2010/$id": {
      "filePath": "_auth/warehouse/inv2010/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv2010/create": {
      "filePath": "_auth/warehouse/inv2010/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv2210/$id": {
      "filePath": "_auth/warehouse/inv2210/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv2210/create": {
      "filePath": "_auth/warehouse/inv2210/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv2215/$id": {
      "filePath": "_auth/warehouse/inv2215/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv2215/create": {
      "filePath": "_auth/warehouse/inv2215/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv2310/$id": {
      "filePath": "_auth/warehouse/inv2310/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv2310/create": {
      "filePath": "_auth/warehouse/inv2310/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv3010/$id": {
      "filePath": "_auth/warehouse/inv3010/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv3010/create": {
      "filePath": "_auth/warehouse/inv3010/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv3020/$id": {
      "filePath": "_auth/warehouse/inv3020/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv3020/create": {
      "filePath": "_auth/warehouse/inv3020/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv3510/$id": {
      "filePath": "_auth/warehouse/inv3510/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv3510/create": {
      "filePath": "_auth/warehouse/inv3510/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv4310/$id": {
      "filePath": "_auth/warehouse/inv4310/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv4310/create": {
      "filePath": "_auth/warehouse/inv4310/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv5010/$id": {
      "filePath": "_auth/warehouse/inv5010/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv5010/create": {
      "filePath": "_auth/warehouse/inv5010/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/accounting/chart-of-accounts/": {
      "filePath": "_auth/accounting/chart-of-accounts/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/accounting/fiscal-year/": {
      "filePath": "_auth/accounting/fiscal-year/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/accounting/journal-entry/": {
      "filePath": "_auth/accounting/journal-entry/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd1010/": {
      "filePath": "_auth/production/prd1010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd1011/": {
      "filePath": "_auth/production/prd1011/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd1015/": {
      "filePath": "_auth/production/prd1015/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd1110/": {
      "filePath": "_auth/production/prd1110/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd1210/": {
      "filePath": "_auth/production/prd1210/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd2010/": {
      "filePath": "_auth/production/prd2010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd3010/": {
      "filePath": "_auth/production/prd3010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd3110/": {
      "filePath": "_auth/production/prd3110/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd4010/": {
      "filePath": "_auth/production/prd4010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd4020/": {
      "filePath": "_auth/production/prd4020/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd4030/": {
      "filePath": "_auth/production/prd4030/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/wo1010/": {
      "filePath": "_auth/production/wo1010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/wo1110/": {
      "filePath": "_auth/production/wo1110/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/wo1115/": {
      "filePath": "_auth/production/wo1115/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/wo1210/": {
      "filePath": "_auth/production/wo1210/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/wo3010/": {
      "filePath": "_auth/production/wo3010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/wo9010/": {
      "filePath": "_auth/production/wo9010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/purchase/bplus-sync/": {
      "filePath": "_auth/purchase/bplus-sync/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/purchase/po1010/": {
      "filePath": "_auth/purchase/po1010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/purchase/po9010/": {
      "filePath": "_auth/purchase/po9010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/purchase/po9020/": {
      "filePath": "_auth/purchase/po9020/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/purchase/po9030/": {
      "filePath": "_auth/purchase/po9030/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/purchase/problem/": {
      "filePath": "_auth/purchase/problem/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/purchase/tracking/": {
      "filePath": "_auth/purchase/tracking/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/qc/qc1010/": {
      "filePath": "_auth/qc/qc1010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/qc/qc8010/": {
      "filePath": "_auth/qc/qc8010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/qc/qc8015/": {
      "filePath": "_auth/qc/qc8015/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/qc/qc8030/": {
      "filePath": "_auth/qc/qc8030/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/qc/qc8110/": {
      "filePath": "_auth/qc/qc8110/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/qc/qc9010/": {
      "filePath": "_auth/qc/qc9010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale1010/": {
      "filePath": "_auth/sale/sale1010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale1020/": {
      "filePath": "_auth/sale/sale1020/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale1030/": {
      "filePath": "_auth/sale/sale1030/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale1210/": {
      "filePath": "_auth/sale/sale1210/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale1220/": {
      "filePath": "_auth/sale/sale1220/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale1230/": {
      "filePath": "_auth/sale/sale1230/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale2310/": {
      "filePath": "_auth/sale/sale2310/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/customers/": {
      "filePath": "_auth/settings/customers/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/groups/": {
      "filePath": "_auth/settings/groups/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/holidays/": {
      "filePath": "_auth/settings/holidays/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/items/": {
      "filePath": "_auth/settings/items/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/locations/": {
      "filePath": "_auth/settings/locations/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/machines/": {
      "filePath": "_auth/settings/machines/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/molds/": {
      "filePath": "_auth/settings/molds/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/parties/": {
      "filePath": "_auth/settings/parties/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/roles/": {
      "filePath": "_auth/settings/roles/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/running-numbers/": {
      "filePath": "_auth/settings/running-numbers/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/screen-capture/": {
      "filePath": "_auth/settings/screen-capture/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/suppliers/": {
      "filePath": "_auth/settings/suppliers/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/users/": {
      "filePath": "_auth/settings/users/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/dashboard/": {
      "filePath": "_auth/warehouse/dashboard/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1010/": {
      "filePath": "_auth/warehouse/inv1010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1015/": {
      "filePath": "_auth/warehouse/inv1015/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1110/": {
      "filePath": "_auth/warehouse/inv1110/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1120/": {
      "filePath": "_auth/warehouse/inv1120/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1140/": {
      "filePath": "_auth/warehouse/inv1140/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1210/": {
      "filePath": "_auth/warehouse/inv1210/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1310/": {
      "filePath": "_auth/warehouse/inv1310/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv2010/": {
      "filePath": "_auth/warehouse/inv2010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv2210/": {
      "filePath": "_auth/warehouse/inv2210/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv2215/": {
      "filePath": "_auth/warehouse/inv2215/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv2310/": {
      "filePath": "_auth/warehouse/inv2310/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv3010/": {
      "filePath": "_auth/warehouse/inv3010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv3020/": {
      "filePath": "_auth/warehouse/inv3020/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv3510/": {
      "filePath": "_auth/warehouse/inv3510/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv4010/": {
      "filePath": "_auth/warehouse/inv4010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv4015/": {
      "filePath": "_auth/warehouse/inv4015/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv4020/": {
      "filePath": "_auth/warehouse/inv4020/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv4110/": {
      "filePath": "_auth/warehouse/inv4110/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv4210/": {
      "filePath": "_auth/warehouse/inv4210/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv4310/": {
      "filePath": "_auth/warehouse/inv4310/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv5010/": {
      "filePath": "_auth/warehouse/inv5010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv9010/": {
      "filePath": "_auth/warehouse/inv9010/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv9020/": {
      "filePath": "_auth/warehouse/inv9020/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv9110/": {
      "filePath": "_auth/warehouse/inv9110/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv9120/": {
      "filePath": "_auth/warehouse/inv9120/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv9210/": {
      "filePath": "_auth/warehouse/inv9210/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/accounting/chart-of-accounts/edit/$id": {
      "filePath": "_auth/accounting/chart-of-accounts/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/accounting/journal-entry/edit/$id": {
      "filePath": "_auth/accounting/journal-entry/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd1010/create/$wsid": {
      "filePath": "_auth/production/prd1010/create.$wsid.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd1110/create/$wsid": {
      "filePath": "_auth/production/prd1110/create.$wsid.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd3110/edit/$id": {
      "filePath": "_auth/production/prd3110/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/wo1010/edit/$id": {
      "filePath": "_auth/production/wo1010/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/wo1110/edit/$id": {
      "filePath": "_auth/production/wo1110/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/wo3010/edit/$id": {
      "filePath": "_auth/production/wo3010/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/purchase/po1010/edit/$id": {
      "filePath": "_auth/purchase/po1010/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/qc/qc8010/view/$id": {
      "filePath": "_auth/qc/qc8010/view.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/qc/qc8110/edit/$id": {
      "filePath": "_auth/qc/qc8110/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale1010/edit/$id": {
      "filePath": "_auth/sale/sale1010/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale1220/edit/$id": {
      "filePath": "_auth/sale/sale1220/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/sale/sale2310/edit/$id": {
      "filePath": "_auth/sale/sale2310/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/customers/edit/$id": {
      "filePath": "_auth/settings/customers/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/groups/edit/$id": {
      "filePath": "_auth/settings/groups/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/holidays/edit/$id": {
      "filePath": "_auth/settings/holidays/edit.$id.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/settings/holidays/edit/$id/delete"
      ]
    },
    "/_auth/settings/items/edit/$id": {
      "filePath": "_auth/settings/items/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/items/view/$id": {
      "filePath": "_auth/settings/items/view.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/locations/edit/$id": {
      "filePath": "_auth/settings/locations/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/machines/edit/$id": {
      "filePath": "_auth/settings/machines/edit.$id.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/settings/machines/edit/$id/delete"
      ]
    },
    "/_auth/settings/molds/delete/$id": {
      "filePath": "_auth/settings/molds/delete.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/molds/edit/$id": {
      "filePath": "_auth/settings/molds/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/parties/edit/$id": {
      "filePath": "_auth/settings/parties/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/roles/edit/$id": {
      "filePath": "_auth/settings/roles/edit.$id.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/settings/roles/edit/$id/delete"
      ]
    },
    "/_auth/settings/running-numbers/edit/$id": {
      "filePath": "_auth/settings/running-numbers/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/suppliers/edit/$id": {
      "filePath": "_auth/settings/suppliers/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/users/edit/$id": {
      "filePath": "_auth/settings/users/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1010/edit/$id": {
      "filePath": "_auth/warehouse/inv1010/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1015/edit/$id": {
      "filePath": "_auth/warehouse/inv1015/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1140/edit/$id": {
      "filePath": "_auth/warehouse/inv1140/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1210/edit/$id": {
      "filePath": "_auth/warehouse/inv1210/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv1310/edit/$id": {
      "filePath": "_auth/warehouse/inv1310/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv2010/edit/$id": {
      "filePath": "_auth/warehouse/inv2010/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv2210/edit/$id": {
      "filePath": "_auth/warehouse/inv2210/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv2215/edit/$id": {
      "filePath": "_auth/warehouse/inv2215/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv2310/edit/$id": {
      "filePath": "_auth/warehouse/inv2310/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv3010/edit/$id": {
      "filePath": "_auth/warehouse/inv3010/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv3020/edit/$id": {
      "filePath": "_auth/warehouse/inv3020/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv3510/$id_/completion": {
      "filePath": "_auth/warehouse/inv3510/$id_.completion.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv3510/$id_/progress": {
      "filePath": "_auth/warehouse/inv3510/$id_.progress.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv3510/$id_/variances": {
      "filePath": "_auth/warehouse/inv3510/$id_.variances.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv3510/$id_/zones": {
      "filePath": "_auth/warehouse/inv3510/$id_.zones.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv3510/edit/$id": {
      "filePath": "_auth/warehouse/inv3510/edit.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv4310/$id_/override-items": {
      "filePath": "_auth/warehouse/inv4310/$id_.override-items.tsx",
      "parent": "/_auth"
    },
    "/_auth/warehouse/inv4310/adjust/$id": {
      "filePath": "_auth/warehouse/inv4310/adjust.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/items/$itemId/": {
      "filePath": "_auth/settings/items/$itemId/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd1010/edit/$wsid/$id": {
      "filePath": "_auth/production/prd1010/edit.$wsid.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/production/prd1110/edit/$wsid/$id": {
      "filePath": "_auth/production/prd1110/edit.$wsid.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/purchase/tracking/receive/$id/$itemId": {
      "filePath": "_auth/purchase/tracking/receive.$id.$itemId.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/holidays/edit/$id/delete": {
      "filePath": "_auth/settings/holidays/edit.$id.delete.tsx",
      "parent": "/_auth/settings/holidays/edit/$id"
    },
    "/_auth/settings/items/$itemId/boms/$id": {
      "filePath": "_auth/settings/items/$itemId/boms/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/items/$itemId/boms/create": {
      "filePath": "_auth/settings/items/$itemId/boms/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/machines/edit/$id/delete": {
      "filePath": "_auth/settings/machines/edit.$id.delete.tsx",
      "parent": "/_auth/settings/machines/edit/$id"
    },
    "/_auth/settings/roles/edit/$id/delete": {
      "filePath": "_auth/settings/roles/edit.$id.delete.tsx",
      "parent": "/_auth/settings/roles/edit/$id"
    },
    "/_auth/production/wo1210/index/hold/$id": {
      "filePath": "_auth/production/wo1210/index.hold.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/qc/qc1010/index/hold/$id": {
      "filePath": "_auth/qc/qc1010/index.hold.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/qc/qc8030/index/result/$id": {
      "filePath": "_auth/qc/qc8030/index.result.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/customers/index/delete/$id": {
      "filePath": "_auth/settings/customers/index.delete.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/locations/index/delete/$id": {
      "filePath": "_auth/settings/locations/index.delete.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/parties/index/delete/$id": {
      "filePath": "_auth/settings/parties/index.delete.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/running-numbers/index/delete/$id": {
      "filePath": "_auth/settings/running-numbers/index.delete.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/suppliers/index/delete/$id": {
      "filePath": "_auth/settings/suppliers/index.delete.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/users/index/delete/$id": {
      "filePath": "_auth/settings/users/index.delete.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/items/$itemId/boms/edit/$id": {
      "filePath": "_auth/settings/items/$itemId/boms/edit.$id.tsx",
      "parent": "/_auth"
    }
  }
}
ROUTE_MANIFEST_END */
